var recaptcha= recaptcha ? recaptcha :{};
var grecaptcha=null;

function ReCaptchaReady(){
	if(grecaptcha)
	$('.recaptcha-render').each(function(i,c){

			var id=$(c).attr('id');
			if(!$(c).hasClass('rendered')){
				$(c).addClass('rendered');
				recaptcha[id] = {id : grecaptcha.render(id, {'sitekey' : $('body').data('g-recaptcha-key'), 'size':$(window).width()>567 ? 'normal':'compact' })};
				//console.log('render captcha',id,recaptcha)

			}
	})
}

// Проверяем, можно ли использовать Webp формат
function canUseWebp() {
    // Создаем элемент canvas
    let elem = document.createElement('canvas');
    // Приводим элемент к булеву типу
    if (!!(elem.getContext && elem.getContext('2d'))) {
        // Создаем изображение в формате webp, возвращаем индекс искомого элемента и сразу же проверяем его
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    // Иначе Webp не используем
    return false;
}

function change_captcha(a)
	{
	if (document.getElementById(a))
		{
		var img=document.getElementById(a);
		var now = new Date().getTime();
		img.src='/ajax_page.php?what=change_captcha&'+now;
		}
	}

function closeCities() {
	var height = $(".cities").height() + 33;
	$(".cities").removeClass("active").stop().animate({top: ($('#up_1180').height()-height) +"px"}, 450, function() {
		$(".cities").css({top: "-"+height+"px"})
		$('html').unbind('click');
		$('.cities').unbind('click');
	});
}

function openCities() {
	// var height = $(".cities").height() + 33;
	// $(".cities").addClass("active").stop().css({top: ($('#up_1180').height()-height)+'px' }).animate({top: ($('#up_1180').height()+33)+"px"}, 450, function() {
	// 	$('html').click(function() {
	// 		closeCities();
	// 	});
	// 	$('.cities').click(function(event){
	// 		event.stopPropagation();
	// 	});
	// });
}

var timerAdverts = 0;
var c = 0;
var adverts, maxAdverts;
function setAdverts(maxAdverts, speed){
	if (c >= maxAdverts)
		c = 0;
	var cAdv= adverts[c];
	//console.log(cAdv);
	var sp=$('<span>').css({'display':'none'}).bind('mouseover mouseout', function() {
				if (timerAdverts) {
					clearTimeout(timerAdverts);
					timerAdverts = 0;
				}
				else
					timerAdverts = setTimeout("setAdverts('"+ maxAdverts +"', "+ speed +")", speed);
			}).click(function(){
				setAdvertLink(c-1);
				setAdvertContent(c-1);
				closeTopSlider('.cities');
				openTopSlider(".offers");
				$(".running-line").addClass('hidden');
			}).html(cAdv['descr']);

	if($('.running-line > span').length)
		$('.running-line > span').fadeOut(300, function() {
			$(this).replaceWith(sp);
			sp.fadeIn(300)
		});
	else{
		$('.running-line').append(sp);
		sp.fadeIn(300)
	}
	c++;
	timerAdverts = setTimeout("setAdverts('"+ maxAdverts +"', "+ speed +")", speed);
}

function hideRunningLine() {
	if (maxAdverts > 1)
		clearTimeout(timerAdverts);
	$('.running-line').fadeOut(300);
}

function showRunningLine(maxAdverts, speed) {
	$('.running-line').fadeIn(300);
	if (maxAdverts > 1)
		timerAdverts = setTimeout("setAdverts('"+ maxAdverts +"', "+ speed +")", speed);
}

function showAdvert(key) {
	setAdvertLink(key);
	$(".offer-body").fadeOut(function() {
		setAdvertContent(key);
		$(".offer-body").fadeIn();
	});
}

function setAdvertLink(key) {
	$(".offers-list").find('li').removeClass('active');
	$(".offer-link-" + key).addClass('active');
}

function setAdvertContent(key) {
	var advert = adverts[key];
	$(".offer-title").empty().text(advert['descr']);
	var txt=advert['text'];
	$(".offer-descr").empty().html(txt);
	$(".offer-info-title").empty().text(advert['company_name']);
	$(".offer-info-phone").empty().text(advert['company_phone']);
	if (typeof advert['url'] != undefined)
		$(".offer-url").attr("href", advert['company_url']);
	else
		$(".offer-url").removeAttr("href");
}

function closeTopSlider(className) {
	var height = $(className).height() + 33;
	$(className).removeClass("active").stop().animate({top:"-"+ height +"px"}, 450, function() {
		$('html').unbind('click');
		$(className).unbind('click');
	});
}

function openTopSlider(className) {
	$(className).addClass("active").stop().animate({top:"33px"}, 450, function() {
		$('html').click(function() {
			closeTopSlider(className);
			$(".running-line").removeClass('hidden');
		});
		$(className).click(function(event){
			event.stopPropagation();
		});
	});
}

function get_exib_calendar(year, month, type)
	{

			$.ajax({
			url: '/ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_exib_calendar', my_year:year, my_month:month, my_type:type},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{
				$('#calendar').html(html.responseText);
				}
			else
				{
				$('#calendar').html('');
				}
			},
			cache: false,
			async: true
		});
	}


function get_seminar_calendar(year, month)
	{

			$.ajax({
			url: '/ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_seminar_calendar', my_year:year, my_month:month},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{
				$('#calendar').html(html.responseText);
				}
			else
				{
				$('#calendar').html('');
				}
			},
			cache: false,
			async: true
		});
	}


function show_social()
{

$('#item-3').html('<iframe src="//www.facebook.com/plugins/likebox.php?href=http%3A%2F%2Fwww.facebook.com%2Fpages%2FЖурнал-Сантехника-Отопление-Кондиционирование%2F121784067893680&amp;width=350&amp;height=290&amp;colorscheme=light&amp;show_faces=true&amp;border_color&amp;stream=false&amp;header=true" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:350px; height:290px;"></iframe>');

}


function last_journal_carousel()
{

var ar=$('#archive_slide').position();


$('#archive_slide').css('position', 'relative');
$('#archive_slide').css('height', '237px');
$('#archive_slide .archive_item').each(	function(index, item) {

$(item).css('position', 'absolute');
$(item).css('height', '237px');
$(item).css('width', '150px');

var left=index*70;
var z_index=1000-index*60;
$(item).css('left', left);
$(item).css('top', 0);

var width=150-index*20;
var top=index*20;
$(item).find('img').css('width', width);
$(item).css('padding-top', top);
$(item).css('z-index', z_index);

});



$('#archive_slide').bind("mousemove", function(event, ui)
	{
	var tmpX=event.pageX-ar.left;
	var tmpY=event.pageY-ar.top;

	if (tmpX<125) {tmpX=125;}
	if (tmpX>325) {tmpX=325;}
	$('#archive_slide .archive_item').each(function(index, item)
		{
		if (index>-1)
			{
			var ar2=$(item).position();
			var ser=125+ar2.left;
			var delta_x=tmpX-ser;
			delta_x=Math.abs(delta_x);



		var stop_x=200;
		var new_x=90;
		var new_t=60;
		if (delta_x<stop_x)
			{
			a1=150-new_x;
			a2=stop_x-delta_x;
			y=a1*a2/stop_x;
			new_x=new_x+y;

			new_t=150-new_x;
			}

		$(item).css('padding-top', new_t);


		$(item).find('img').css('width', new_x);


		var tmp_z=$(item).find('img').css('width').split('px');
		var new_z=tmp_z[0]*10;
		$(item).css('z-index', new_z);
			}
		return;
		});

	});

}

function is_retina(){
    if( 'devicePixelRatio' in window
        && window.devicePixelRatio > 1 ){
            return true;
        }
    return false;
}

function changeRatioCookie(value) {
    $.ajax({
        method: "GET",
        url: "/site/set-cookie",
        data: {
            'name': 'device_pixel_ratio',
            'value': value,
            'maxAge': 3600 * 24 * 365 * 100,
            'path': '/'
        },
        dataType: 'json'
    })
        .done(function( data ) {
            console.log(data)
            if(data.success == 1){
                window.location.reload();
            }
        });

    /*setCookie('device_pixel_ratio', value);
    $.get('/site/set-cookie', {
        'name': 'device_pixel_ratio',
        'value': value,
        'maxAge': 3600 * 24 * 365 * 100,
        'path': '/'
    }, function(data){
        if(data.success == 1){
            window.location.reload();
        }
    }); */
}

function check_ratio()
{
  let cookieRatio = parseInt(getCookie('device_pixel_ratio'));
  if (isNaN(cookieRatio)) {
      cookieRatio = 1;
  }

  if ('devicePixelRatio' in window) {
      if( cookieRatio !== 2
          && window.devicePixelRatio >= 2 ) {
          console.log('change to retina')
          changeRatioCookie(2);
      } else if ( window.devicePixelRatio < 2
          && cookieRatio > 1
      ) {
          console.log('change to no retina')
          changeRatioCookie(1);
      }
  }
}

function check_slider()
{
var bigw=$('#new_gallery').width();
var smallw=$('#gim_1').width();
var mar=Math.ceil(bigw/100);
var prom=3+24*bigw/100;
prom=Math.ceil(bigw-3*mar)/4;

$('.gdiv').css('width', prom+'px');
var test=3*mar+4*prom;

var mar2=mar-2;
prom=prom+mar;
$('.slide_setka').css('width',bigw+'px');
$('.gdiv').css('width', prom+'px');
$('.gdivtr').css('width', prom+'px');
$('#gim').css('width', prom+'px');
$('#gimtr').css('width', prom+'px');
$('#gdiv_2').css('left', prom+'px');
$('#gdiv_3').css('right', prom+'px');
$('#gdivtr_2').css('left', prom+'px');
$('#gdivtr_3').css('right', prom+'px');
$('#new_gallery').css('padding-bottom', mar2+'px');
}

function  slide_tuman(a, w)
{

		if (a!=current_slide)
			{
			if (w==1) {$('#gim_'+a).css({opacity:0.3});}
			if (w==0) {$('#gim_'+a).css({opacity:1});}


			}

	return;

}
var current_slide=0;

function show_gal(a)
	{
		var b=gimp[a];
		tpm=gimp[0];
		gimp[0]=gimp[a];
		gimp[a]=tpm;
		var alt='';
		if (b!=current_slide)
			{
			$('.gim').css({opacity:1});
			$('#gim_'+b).css({opacity:1});
			var tmp=0;
			$('#new_gallery_'+current_slide).fadeOut(300);
			alt=$('#new_gallery_image_'+current_slide).attr('alt');

			setTimeout(function () {$('#new_gallery_'+b).fadeIn(300);}, 300);

			current_slide=b;
			$('#gim_'+a).attr('alt', alt);
			$('#gimtr_'+a).attr('alt', alt);
			}
		$('.gim').each(function() {
		var tid=$(this).attr('id');
		tmpa=tid.split('gim_');
		var id=tmpa[1];

		$(this).attr('src', gimi[gimp[id]]);



});
	return;
	}

		function just_show_video(video_file_id, div, autoplay, my_width, my_height, without_adver)
			{

			if (video_file_id)
				{
				if (!my_width) {my_width=450;}
				if (!my_height) {my_height=254;}
				$.ajax({
				url: '/ajax_page.php',
				type: 'post',
				beforeSend: function() {$('#loader_'+video_file_id).show();},
				data: {what:'show_video', my_div:div, video_file_id:video_file_id, my_width:my_width, my_height:my_height,my_autoplay:autoplay, my_preview:1, my_without_adver:without_adver},
				dataType:'html',
				complete: function(html)
					{
					if (html.responseText)
						{

						$('#'+div).css('background','');
						$('#'+div).html(html.responseText);
						$('#'+div).unbind('click');
						}
					else
						{
						$('#'+div).html('Видео не найдено');
						}
					$('#loader_'+video_file_id).hide();
					},
				cache: false,
				async: true
				});
				}
			}


		function show_video(video_file_id, div, autoplay, my_width, my_height, without_adver)
			{
			if (video_file_id && div)
				{
				$.ajax({
				url: '/ajax_page.php',
				type: 'post',
				beforeSend: function() {},
				data: {what:'show_video', my_div:div, video_file_id:video_file_id, my_width:350, my_height:212,my_autoplay:autoplay, my_preview:1, my_without_adver:without_adver},
				dataType:'html',
				complete: function(html)
					{
					if (html.responseText)
						{
						$('#'+div).html(html.responseText);
						$('#'+div).fadeIn(500);
						$('#'+div).unbind('click');
						$('#last_main_video_preview').fadeOut(500);
						$('#last_main_video_preview span.text').fadeOut(500, function() {
						});
					}
					else
						{
						$('#'+div).html('Видео не найдено');
						}
					},
				cache: false,
				async: true
				});
				}
			}

function showRecoveryPass(main, back) {


			$.ajax({
			url: '/user_ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_recovery_pass_form'},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{
				$('#login-wrapper').html(html.responseText);
				$("#login-wrapper").fadeIn(500);
				$('#tag_main').val(main);
				$('#backpage').val(back);
				$('#send_password').focus();
				}
			else
				{
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);
				}
			},
			cache: false,
			async: true
		});


}

function showRecovery(main, back) {


			$.ajax({
			url: '/user_ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_recovery_form'},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{
				$('#login-wrapper').html(html.responseText);
				$("#login-wrapper").fadeIn(500);
				$('#tag_main').val(main);
				$('#backpage').val(back);
				$('#send_mail').focus();
				}
			else
				{
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);
				}
			},
			cache: false,
			async: true
		});


}

function showSetNewPass() {


			$.ajax({
			url: '/user_ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_set_new_pass_form'},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{
				$('#login-wrapper').html(html.responseText);
				$("#login-wrapper").fadeIn(500);
				$('#send_mail').focus();
				}
			else
				{
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);
				}
			},
			cache: false,
			async: true
		});


}
function continueDownloadAfterLogin(){
	$('#login-wrapper').hide();

	window.location.reload(1)
}


function showLogin(main, back, login_mail, login_message, callback) {

			$.ajax({
			url: '/user_ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_user_login_form', back:back,'login_message':login_message ? login_message :'','callback': callback ? callback :''},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{

				$('#login-wrapper').html(html.responseText);
				$("#login-wrapper").fadeIn(500);
				$('#tag_main').val(main);
				$('#backpage').val(back);

				if (getCookie('login_memory') && !login_mail){
					$('#send_login_label').html('');
					$('#send_login').val(getCookie('login_memory'));
					if ($('#send_login').val()) {
						$('#send_password').val(getCookie('login_pass_'+$('#send_login').val()));
					}
				}

				if (login_mail){
					$('#send_login').val(login_mail);
					if ($('#send_login').val()) {
						if(pass=getCookie('login_pass_'+$('#send_login').val())){
							$('#send_password').val(pass);
						}
					}
					$('#backpage').val(back);
					//$('.login_anons').toggle();
					$('#send_password').focus();
				}

				if($('#send_login').val()==''){
					$('#send_login').focus();
				}else{
					if($('#send_password').val()==''){
						$('#send_password').focus();
					}
				}
			}else
				{
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);
				}
			},
			cache: false,
			async: true
		});


}



function showRegister(main, back) {


			$.ajax({
			url: '/user_ajax_page.php',
			type: 'post',
			beforeSend: function() {},
			data: {what:'get_register_form'},
			dataType:'html',
			complete: function(html) {
			if (html.responseText)
				{

				$('#login-wrapper').html(html.responseText);
				$("#login-wrapper").fadeIn(500);
				if (main) {$('#tag_main').val(main);}
				if (back) {$('#backpage').val(back);}
				$('#send_mail').focus();
				}
			else
				{
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);
				}
			},
			cache: false,
			async: true
		});


}

function closeLogin() {
				$('#login-wrapper').html('');
				$("#login-wrapper").fadeOut(500);

}

function onFocusPass(a){
	$('#'+a).removeClass("noactive");
	DefPass(a);
	$('#'+a+'_label').css('color','#cccccc');
	return;
}

function DefPass(a)
{
	var def=$('#'+a+'_def').val();
	if ($('#'+a).val()) {$('#'+a+'_label').html('');}
	else {$('#'+a+'_label').html(def);}
	return;
}

function onBlurPass(a){
	$('#'+a).addClass("noactive");
	DefPass(a);
	$('#'+a+'_label').css('color','#777777');
	return;
}

function auto_login_prepare()
{
	return false;

	if ($('#send_login').val()){
		if (getCookie('login_pass_'+$('#send_login').val())){
			$('#send_password').val(getCookie('login_pass_'+$('#send_login').val()));
			if ($('#send_password').val().length>0) {onFocusPass('send_password');}
		}else{
			$('#send_password').val('');DefPass('send_password');DefPass('send_login');
		}
	} else {
		$('#send_password').val('');DefPass('send_password');DefPass('send_login');
	}
}




function get_scroll(){

   if(window.scrollY==undefined){
      return parseInt(document.body.scrollTop);
   }

  return parseInt(window.scrollY);
}

function get_scroll_x(){

   if(window.scrollX==undefined){
      return parseInt(document.body.scrollLeft);
   }

  return parseInt(window.scrollX);
}

function set_scroll(a){

   if(window.scrollY==undefined){
      document.body.scrollTop=a;
   }
   else {
  window.scrollY=a;}
}

function set_scroll_x(a){

   if(window.scrollX==undefined){

     document.body.Left=a;
   }
   else {
  window.scrollX=a;}
}

function addHandler(object, event, handler, useCapture) {
      if (object.addEventListener) {
            object.addEventListener(event, handler, useCapture ? useCapture : false);
      } else if (object.attachEvent) {
            object.attachEvent('on' + event, handler);
      } else alert("Add handler is not supported");
}

function removeHandler(object, event, handler) {
      if (object.removeEventListener) {
            object.removeEventListener(event, handler, false);
      } else if (object.detachEvent) {
            object.detachEvent('on' + event, handler);
      } else alert("Remove handler is not supported");
}
function show_menu_all()
{
for (i=1;i<100;i++)
{
a=document.getElementById('day'+i);
if (a)
	{
	$('#day'+i).show();
	document.getElementById('day'+i+'_button').src='/images/str_programm_down.gif';
	}
	}
}

function hide_menu_all()
{
for (i=1;i<100;i++)
{
a=document.getElementById('day'+i);
if (a)
	{
	$('#day'+i).hide();
	document.getElementById('day'+i+'_button').src='/images/str_programm_left.gif';
	}
	}
}

function show_menu(a, b)
{
src=document.getElementById(b).src;
f=src.indexOf('str_programm_left');
if (f>0)
	{newsrc=src.replace('str_programm_left', 'str_programm_down');}
f=src.indexOf('str_programm_down');
if (f>0)
	{newsrc=src.replace('str_programm_down', 'str_programm_left');}
document.getElementById(b).src=newsrc;
$("#"+a).slideToggle("slow");

}

function increaseSize(a) {
	$(a).each(function() {
		var currentSize = parseInt($(this).css("font-size"));
		$(this).css("font-size", (currentSize+1) + "px");
	});
}

function decreaseSize(a) {
	$(a).each(function() {
		var currentSize = parseInt($(this).css("font-size"));
		$(this).css("font-size", (currentSize-1) + "px");
	});
}


function HideRoll(drop, subgroupId) {
   drop.style.visibility='hidden';
   var subgroup = document.getElementById('subgroup-'+subgroupId);
   var senderA = document.getElementById('subgroup-'+subgroupId+'-link');
}


function ShowRoll(drop, subgroupId) {
   drop.style.visibility='visible';
   var subgroup = document.getElementById('subgroup-'+subgroupId);
   var senderA = document.getElementById('subgroup-'+subgroupId+'-link');
}


function SubgroupMouseOut(subgroup, subgroupId) {
   var senderA = document.getElementById('subgroup-'+subgroupId+'-link');
}

function show_map_detail(sender, target, leftout, topout)
	{
	var sender = document.getElementById(sender);
   var  target = document.getElementById(target);
   var top=pageY(sender);
   var left=pageX(sender);
   target.style.top=top+topout+'px';
   target.style.left=left+leftout+'px';

   target.style.visibility = 'visible';
	}

function DropMenu(sender, dropObj1, subgroupId, topout, leftout) {
if (!leftout) {leftout=140;}
if (!topout) {topout=-1;}
   var senderA = document.getElementById('subgroup-'+subgroupId+'-link');
   var dropObj = document.getElementById(dropObj1);
   var top=pageY(sender);
   var left=pageX(sender);



   dropObj.style.top=top+topout+'px';
   dropObj.style.left=left+leftout+'px';

   dropObj.style.visibility = 'visible';
}

function pageX(elem) {
       return elem.offsetParent ? elem.offsetLeft + pageX( elem.offsetParent ) :  elem.offsetLeft;
}

/* Определение координаты элемента по вертикали */

function pageY(elem) {
       return elem.offsetParent ? elem.offsetTop + pageY( elem.offsetParent ) : elem.offsetTop;
}


function getAbsolutePosition(el) {
	var r = { x: el.offsetLeft, y: el.offsetTop };
	if (el.offsetParent) {
		var tmp = getAbsolutePosition(el.offsetParent);
		r.x += tmp.x;
		r.y += tmp.y;
	}
	return r;
}

function HideMenu(sender, dropObj) {
   var dropObj = document.getElementById(dropObj);
   dropObj.style.visibility = 'hidden';
}

function show_alert(elem)
{
if ($('#'+elem).attr('checked')) {alert('Осторожно! Это галочка удаления!');}

}


function getBrowserInfo() {
    var t,v = undefined;

    if (window.chrome) t = 'Chrome';
    else if (window.opera) t = 'Opera';
    else if (document.all) {
        t = 'IE';
        var nv = navigator.appVersion;
        var s = nv.indexOf('MSIE')+5;
        v = nv.substring(s,s+1);
    }
    else if (navigator.appName) t = 'Netscape';

    return {type:t,version:v};
}

function bookmark(a, title, url){

	if (!url) {url = window.document.location;}
    if (!title) {title=window.document.title;}
    var b = getBrowserInfo();

    if (b.type == 'IE' && 8 >= b.version && b.version >= 4) window.external.AddFavorite(url,title);
    else if (b.type == 'Opera') {
        a.href = url;
        a.rel = "sidebar";
        a.title = url+','+title;
        return true;
    }
    else if (b.type == "Netscape") window.sidebar.addPanel(title,url,"");
    else alert("Нажмите CTRL-D, чтобы добавить страницу в закладки.");
    return false;
}

function validateSize(field, maxsize)
{
if (!maxsize) {maxsize=30*1024*1024;}

if (maxsize>0 && $('#'+field).val()!='' && document.getElementById(field))
	{
	fileInput=document.getElementById(field);
	var fileObj, size;
	if ( typeof ActiveXObject == "function" )
		{ /* IE     */
		fileObj = (new ActiveXObject("Scripting.FileSystemObject")).getFile(fileInput.value);
		}
	else
		{
		fileObj = fileInput.files[0];
		}
	size = fileObj.size; /* Size returned in bytes.   */
	//alert(size);
	if(size > maxsize)
		{
		return false;
		}
	}
	return true;
}

function set_dark_div(id)
{
if (!id) {id='big_dark_div';}
	var common_lay='<div style="z-index:9999;background:url(/images/big_banner_overlay.png);position:absolute;top:0;left:0;width:100%;height:100%;text-align:center;padding:100 0 0 0;" id="'+id+'"></div>';
$(common_lay).appendTo('body');
var arrayPageSize = getPageSize();
	$('#big_message_div').css('background','url(/images/big_banner_overlay.png)');
	$('#big_message_div').css('position','absolute');
	$('#big_message_div').css('top',0);
	$('#big_message_div').css('left', 0);
	$('#big_message_div').css('width','100%');
	$('#big_message_div').css('height',arrayPageSize[1]+'px');
/*	$('#big_message_div').css('cursor','pointer');	*/


return;
}

function getCookie(name) {
	var cookie = " " + document.cookie;
	var search = " " + name + "=";
	var setStr = null;
	var offset = 0;
	var end = 0;
	if (cookie.length > 0) {
		offset = cookie.indexOf(search);
		if (offset != -1) {
			offset += search.length;
			end = cookie.indexOf(";", offset)
			if (end == -1) {
				end = cookie.length;
			}
			setStr = unescape(cookie.substring(offset, end));
		}
	}
	return(setStr);
}

function setCookie(name, value) {

    $.get('/site/set-cookie', {
        'name': name,
        'value': value,
        'maxAge': 3600 * 24 * 365 * 100,
        'path': '/'
    });

}

function setDomainCookie(name, value, dom) {
    if(!dom) dom='www.c-o-k.ru';
    delDomainCookie(name,dom); /* чтоб удалить куки для других доменов */

    $.get('/site/set-cookie', {
        'name': name,
        'value': value,
        'maxAge': 3600 * 24 * 365 * 100,
        'path': '/',
        'domain': dom
    });
}

function delCookie(name) {
var today = new Date();
var expiration_past = new Date(today.getTime() - 100*365 * 24 * 60 * 60 * 1000);  /* 1 год назад*/
document.cookie = name + '=delete; path=/; expires=' + expiration_past.toGMTString();
}

function delDomainCookie(name,dom) {
if(!dom) dom='c-o-k.ru';
dom=dom.replace('www.','');

var today = new Date();
var expiration_past = new Date(today.getTime() - 100*365 * 24 * 60 * 60 * 1000);  /* 1 год назад*/
document.cookie = name + '=delete; path=/; domain='+dom+'; expires=' + expiration_past.toGMTString();
document.cookie = name + '=delete; path=/; domain=www.'+dom+'; expires=' + expiration_past.toGMTString();
}


function onFocusSearch(a){

	/*if(a.value==a.defaultValue){$(a).val("").removeClass("noactive")}*/

	if ($(window).width() <= 567) {
	//	var w=$('#header').width()-165;
		//$("#search-inpt").animate({'width':w-31}, 250).css({'padding-left':'50px'});
		//$('#header-links li.search').animate({'width':w},250)

	}
	else{

	/*
		var w1 = $("#search-inpt").width(); //была ширина поля

		var w2 = $("#header-links li.social").width() + 10; //ширина соц. иконок

		var w = w1 + w2 + "px"; //стала ширина поля

		var l = "-=" + w2 + "px"; //смещаем влево на ширину соц. иконок

		$("#search-inpt").animate({"width":w, "left":l}, 250);
		*/

	}



	if (typeof $("#search-live").html() != 'undefined')
		if ($("#search-live").html().length > 0) {
			$("#search-live").fadeIn(150);
			/*$("#search-close").fadeIn(150);*/
		}
	$("#search-live").attr('z-index', 10000);
	if ($(window).width() <= 567)
		$("#search-live").width($(window).width()-100);

}



/* потеря фокуса поля поиска */
//var search_link_here=0;
function onBlurSearch(a){

console.log(a)
//if (search_link_here==0)
	//{
		/*if(a.value==""){$(a).addClass("noactive").val(a.defaultValue)}*/

		//if ($(window).width() <=567) {

		//	$("#search-inpt").animate({"width":"10px"}, 250);
		//	$("#header-links li.search").animate({'width':'10px'},250)
		//	$("#search-inpt").attr('placeholder','');
	//	}
		//else{
			$('#header-links li.search').removeClass('active');
			/*
			$('#search-inpt').animate({'width':'180px','left':'0'},250,function(){
				$('#header-links li.search').removeClass('active');
			})*/

	//	}

		$("#search-live").hide();
		$("#search-close").hide();
	//}
	//else return;
};



/* фокус поля */

function onFocus(a){

	if(a.value==a.defaultValue){$(a).val("").removeClass("noactive")}

}



/* потеря фокуса поля */

function onBlur(a){

	if(a.value==""){$(a).addClass("noactive").val(a.defaultValue)}

};



/* табы */

function showTab(li, tab) {

  var tabs = $(li).parent("ul");

  var text = $("#"+tab).parent("div");



  tabs.find("li").removeClass("active");

  $(li).addClass("active");



  text.find("div").removeClass("active");

  $("#"+tab).addClass("active");


}



/* ширина подменю */
/*
function menuW() {

  $("#menu li div").width($("#menu ul").width());
  $('#submenuBg').width($("#menu ul").width());
}
*/
t=0;
const preloadRightNewsImg = function(img) {
    const src=$(img).data('preload-src');
    const webp = $(img).data('preload-webp-src');
    const isCircle = $(img).get(0).hasAttribute('data-circle');

    if (isCircle) {
        if (state.isWebpSupported) {
            $(img).addClass('webp-yes');
            $(img).css({
                'background-image': 'url(' + webp + ')'
            });
        } else {
            $(img).addClass('webp-no');
            $(img).css({
                'background-image': 'url(' + src + ')'
            });
        }
    } else {
        $(img).append('<source srcset="' + webp + '" type="image/webp" />');
        const mime = $(img).data('preload-mime');
        const alt = $(img).data('alt');
        $(img).append('<source srcset="' + src + '" type="' + mime + '" />');
        $(img).append('<img alt="' + alt + '" src="' + src + '" />')
    }
    $(img).removeClass('preload');
}
function get_news_right(){
				$.ajax({
				url: '/ajax_page.php',
				type: 'post',
				beforeSend: function(XMLHttpRequest) {
					t=(new Date()).getTime();
					/*alert('start:'+t);*/
				},
				data: {what:'get_right_news', my_begin:0, my_count:30, ajax:1},
				dataType:'html',
				complete: function(html)
					{
/*						alert(html.responseText);*/
					/*alert((new Date()).getTime()+'\n'+t+'\n'+((new Date()).getTime()-t)); return false;*/
					if (html.responseText)
						{

						$('#news_right').html(html.responseText);
                        replaceWebp();


						if($('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on')){

									//alert('xxx:1');
									$('#news_right li  span.title').each(function(i,span){

										h0=parseInt($(span).css('line-height'));
										h=$(span).height();

										if(h>h0){

											var text=$(span).text().split(' ');
											while($(span).height()>h0)
											{
												text.pop();
												var newtext=text.join(' ')+'...';
												$(span).text(newtext);
											}
											$(span).css({'white-space':'nowrap'})
										}
									});
						}
						else{
							//alert('xxx:2');
							$('#news_right li').trimNewsAnons()
						}

						if($('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on')){

						/*if($('input[name=rubric_list]').val()=='yes'){*/

							newsScroller.refresh({
								btnNext:"#news-wrapper .next",
								btnPrev:"#news-wrapper .prev",
								visible:col,
								scroller:'#news_right_scroller',
								speed:700,
								itemheight:14,
								itempadding:15,
								dynamicAddAfterNextClick:function(){
									var startcount=$('#news_right li').length;
									$.ajax({
											url: '/ajax_page.php',
											type: 'post',
											data: {what:'get_right_news', my_begin: startcount, my_count:col, ajax:1},
											dataType:'html',
											success:function(html){
												if(startcount==$('#news_right li').length){
													$('#news_right').append(html);
                                                    replaceWebp();

													if($('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on')){
															//alert('xxx:3');
															$('#news_right li  span.title').each(function(i,span){
																h0=parseInt($(span).css('line-height'));
																h=$(span).height();

																if(h>h0){

																	var text=$(span).text().split(' ');
																	while($(span).height()>h0)
																	{
																		text.pop();
																		var newtext=text.join(' ')+' ...';
																		$(span).text(newtext);
																	}
																	$(span).css({'white-space':'nowrap'})
																}
															});
													}
												}

											}

									});

								}

							  });
						}
						/*if($('input[name=rubric_list]').val()=='no'){*/
						if(typeof newsScroller != 'undefined' && !$('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on')){
							newsScroller.refresh({
							btnNext:"#news-wrapper .next",
							btnPrev:"#news-wrapper .prev",
							visible:col,
							scroller:'#news_right_scroller',
							speed:700,
							itemheight:90,
							itempadding:30,
							dynamicAddAfterNextClick:function(){
								var startcount=$('#news_right li').length;

								$.ajax({
										url: '/ajax_page.php',
										type: 'post',
										data: {what:'get_right_news', my_begin: startcount , my_count:col, ajax:1},
										dataType:'html',
										success:function(html){
											if(startcount==$('#news_right li').length) {
                                                $('#news_right').append(html);
                                                replaceWebp();
                                            }
										}

								});

							},
							afterNextClick:function(){

								//alert('xxx:4');
								$('#news_right li .preload').each(function(i,img){
                                    console.log(i, col, $(img))
									if(i < col){
                                        preloadRightNewsImg(img)
									}
								});
							}

						  })

						}


						}


					},
				cache: true,
				async: true
				});


}
function get_article_main()
  {
 				$.ajax({
				url: '/ajax_page.php',
				type: 'post',
				beforeSend: function() {},
				data: {what:'get_article_main'},
				dataType:'html',
				complete: function(html)
					{

					if (html.responseText)
						{
						$('#article_main').html(html.responseText);

						if($('ul#article_main li').length){
							$('ul#article_main li').each(function(i,li){
								var span=$(li).find('span.exactly');
								var title=$(li).find('em.title');
								var anons=$(li).find('em.article_anons');
								var title_height=$(title).height()+parseInt($(title).css('paddingTop'))+parseInt($(title).css('paddingBottom'));
								var anons_height=$(anons).height()+parseInt($(anons).css('paddingTop'))+parseInt($(anons).css('paddingBottom'));
								var span_height=title_height+anons_height;
								var span_height_max=107;
								if(span_height > span_height_max){
									var text=$(anons).text();
									var textarray=text.split(' ');
									do{
										textarray.pop();
										text=textarray.join(' ')+'...';
										$(anons).text(text);
										var title_height=$(title).height()+parseInt($(title).css('paddingTop'))+parseInt($(title).css('paddingBottom'));
										var anons_height=$(anons).height()+parseInt($(anons).css('paddingTop'))+parseInt($(anons).css('paddingBottom'));
										var span_height=title_height+anons_height;
									}	while( span_height > span_height_max)
								}
							})
						}

						}


					},
				cache: false,
				async: true
				});
}


function showContacts() {$("#contacts-full").slideToggle(150);}

function checkCaptcha(input){
	input.value=input.value.replace(new RegExp("[^0-9a-z]",'gi'),'');
}

function addToBookmark(classname,user,doc_id,doc_type,id,addtext,deltext){

	data={'what':classname,'user_id':user,'document_id':doc_id,'type':doc_type};

	var comment='<div class="BookmarkComment">'+
					'<span></span><div>Ваш комментарий к закладке</div>'+
					'<textarea name="BookmarkComment"></textarea>'+
					'<div id="sendBookmarkComment">Добавить</div>'+
				'</div>';
	if(classname=='addToBookmarks')
		{
			$('.BookmarkComment').remove();
			$('#'+id).after(comment);
			$('.BookmarkComment').fadeIn(500);
			$('#sendBookmarkComment').click(function(){
					data.comment=$('textarea[name=BookmarkComment]').val();
					$('.BookmarkComment').fadeOut(500);
					$('.BookmarkComment').remove();
					$.ajax({
						   type: "POST",
						   url: "/ajax_page.php",
						   data: data,
						   dataType: 'json',
						   success: function(response){

										if(response['status']=='add')
											{
												$('#'+id).children('span.txt').html(deltext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
												$('#'+id).attr('className','delFromBookmarks');
											}
										if(response['status']=='del')
											{
												$('#'+id).children('span.txt').html(addtext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
												$('#'+id).attr('className','addToBookmarks');
											}

						   }
					   });
			});


			return false;
		}
	else{
			$.ajax({
			   type: "POST",
			   url: "/ajax_page.php",
			   data: data,
			   dataType: 'json',
			   success: function(response){

							if(response['status']=='add')
								{
									$('#'+id).children('span.txt').html(deltext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
									$('#'+id).attr('className','delFromBookmarks');
								}
							if(response['status']=='del')
								{
									$('#'+id).children('span.txt').html(addtext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
									$('#'+id).attr('className','addToBookmarks');
								}
			   }
		   });
   }
}

function addToBookmark1(classname,user,doc_id,doc_type,id,addtext,deltext){

	data={'what':classname,'user_id':user,'document_id':doc_id,'type':doc_type};


	if(classname=='addToBookmarks')
		{
					$.ajax({
						   type: "POST",
						   url: "/ajax_page.php",
						   data: data,
						   dataType: 'json',
						   success: function(response){
						   			if(response['status']=='add')
											{
												$('#'+id).children('span.txt').html(deltext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
												$('#'+id).attr('className','delFromBookmarks');
											}
										if(response['status']=='del')
											{
												$('#'+id).children('span.txt').html(addtext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
												$('#'+id).attr('className','addToBookmarks');
											}

						   }
					   });



			return false;
		}
	else{
			$.ajax({
			   type: "POST",
			   url: "/ajax_page.php",
			   data: data,
			   dataType: 'json',
			   success: function(response){

							if(response['status']=='add')
								{
									$('#'+id).children('span.txt').html(deltext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
									$('#'+id).attr('className','delFromBookmarks');
								}
							if(response['status']=='del')
								{
									$('#'+id).children('span.txt').html(addtext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
									$('#'+id).attr('className','addToBookmarks');
								}
			   }
		   });
   }
}

function addNote(classname,user,doc_id,doc_type,id,addtext,deltext,addnote,addmorenote){




			if($('#bookmark_form_'+doc_id).is(':visible')){
				$('#bookmark_form_'+doc_id).slideUp(500);
				$('#bookmark_form_'+doc_id).closest('.complist').removeClass('opened');
			}
			else{
				$('.complist').removeClass('opened');
				$('#bookmark_form_'+doc_id).closest('.complist').addClass('opened');

				start_title=$('#bookmark_form_'+doc_id+' .bookmark_title input').val();
				start_desc=$('#bookmark_form_'+doc_id+' .bookmark_desc textarea').val();
				start_new_categ=$('#bookmark_form_'+doc_id+' .new_category_input input').val();

				$('#bookmark_form_'+doc_id+' .bookmark_title input').focus(function(){
							if($(this).val()==start_title)
								$(this).val('');
							$(this).closest('.bookmark_title').addClass('focus');
				});
				$('#bookmark_form_'+doc_id+' .bookmark_title input').blur(function(){
					if($(this).val()=='')
						$(this).val(start_title);
						$(this).closest('.bookmark_title').removeClass('focus');
				});




				$('#bookmark_form_'+doc_id+' .bookmark_desc textarea').focus(function(){
					if($(this).val()==start_desc)
						$(this).val('');
				});
				$('#bookmark_form_'+doc_id+' .bookmark_desc textarea').blur(function(){
					if($(this).val().length==0)
						$(this).val(start_desc);
				});

				$('#bookmark_form_'+doc_id+' .new_category_input input').focus(function(){
					if($(this).val()==start_new_categ)
						$(this).val('');
					$(this).css('color','#7E8484');
				});
				$('#bookmark_form_'+doc_id+' .new_category_input input').blur(function(){
					if($(this).val().length==0)
						$(this).val(start_new_categ);
				});



				data={'what':classname,'user_id':user,'document_id':doc_id,'type':doc_type};
				$('.bookmark_form').slideUp(500);
				$('#bookmark_form_'+doc_id).slideDown(500);


				if($('#bookmark_form_'+doc_id+' .cusel').length)
				{
					params = {
							refreshEl: '#category_select_'+doc_id, /* перечисляем через запятую id селектов, которые нужно обновить */
							visRows: 5
							}
							cuSelRefresh(params);
				}
				else{


					var params = {
								changedEl: '#bookmark_form_'+doc_id+' .category_selector select',
								visRows: 5,
								scrollArrows: true
							}

							cuSel(params);
				}

				/*$('#bookmark_form_'+doc_id+' .bookmark_title input').focus();*/

				/*
				if($('#bookmark_form_'+doc_id+' .category_selector select').val()=='new')
					$('#bookmark_form_'+doc_id+' .category_selector select').closest('.category_selector').children('.new_category_input').show();
				else
					$('#bookmark_form_'+doc_id+' .category_selector select').closest('.category_selector').children('.new_category_input').hide();
				*/
				if($('#bookmark_form_'+doc_id+' .category_selector input').val()=='new')
					$('#bookmark_form_'+doc_id+' .category_selector input').closest('.category_selector').children('.new_category_input').show();
				else
					$('#bookmark_form_'+doc_id+' .category_selector input').closest('.category_selector').children('.new_category_input').hide();


				$('#bookmark_form_'+doc_id+' .category_selector .cusel input').unbind('change');
				$('#bookmark_form_'+doc_id+' .category_selector .cusel input').change(function(){
					if($(this).val()=='new')
						$(this).closest('.category_selector').children('.new_category_input').show();
					else
						$(this).closest('.category_selector').children('.new_category_input').hide();
				});

				$('#bookmark_form_'+doc_id+' .send_button input').unbind('click');
				$('#bookmark_form_'+doc_id+' .send_button input').click(function(){
					var error=false;
					/*if($(this).closest('.bookmark_bot').find('.category_selector select').val()=='new'){*/
					if($(this).closest('.bookmark_bot').find('.category_selector input').val()=='new'){
						data.category_name=$('#bookmark_form_'+doc_id+' .category_selector .new_category_input input').val()!=start_new_categ ? $('#bookmark_form_'+doc_id+' .category_selector .new_category_input input').val() :'';
						if(!data.category_name)
							{
								$(this).closest('.bookmark_bot').find('.category_selector .new_category_input input').css('color','#ff0000');
								error=true;
							}
						data.category='new';

					}else{
						/*data.category=$('#bookmark_form_'+doc_id+' .category_selector select').val();*/
							data.category=$('#bookmark_form_'+doc_id+' .category_selector input').val();
					}

					if(!error){
						data.title=$('#bookmark_form_'+doc_id+' .bookmark_title input').val()!=start_title ? $('#bookmark_form_'+doc_id+' .bookmark_title input').val() : '';
						data.comment=$('#bookmark_form_'+doc_id+' .bookmark_desc textarea').val()!=start_desc ? $('#bookmark_form_'+doc_id+' .bookmark_desc textarea').val(): '';

						$.ajax({
							   type: "POST",
							   url: "/ajax_page.php",
							   data: data,
							   dataType: 'json',
							   success: function(response){
											if($('#bookmarks-tab').length){

												location.reload();

}											var status;
											if(response['status']=='add' || response['status']=='change')
												status='bookmark';
											if(response['status']=='add_note')
												status='note';

											if(data.category=='new'){
												$('.bookmark_form .category_selector option').removeAttr('selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span').removeAttr('selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span').removeClass('cuselActive');

												$('.bookmark_form .category_selector select').append('<option value="'+response['category_id']+'">'+data.category_name+'</option>');
												$('.bookmark_form .category_selector .cusel-scroll-pane').append('<span selected="selected" val="'+response['category_id']+'" class="cuselActive">'+data.category_name+'</span>');


												$('.bookmark_form .category_selector option[value='+response['category_id']+']').attr('selected','selected');
											}else{
												$('.bookmark_form .category_selector option').removeAttr('selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span').removeAttr('selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span').removeClass('cuselActive');

												$('.bookmark_form .category_selector option[value='+data.category+']').attr('selected','selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span[val='+data.category+']').attr('selected','selected');
												$('.bookmark_form .category_selector .cusel-scroll-pane span[val='+data.category+']').addClass('cuselActive');
											}


											if(data.category_name)
												name=data.category_name
											else
												name=$('#bookmark_form_'+doc_id+' .cusel-scroll-pane span[val='+data.category+']').text();


											$('.bookmark_form .category_selector .cusel input').each(function(){
												$(this).val(data.category);
												$(this).closest('.cusel').find('.cuselText').text(name);
											});




											$('.bookmark_status_'+doc_id).val('status');

											if(status=='bookmark'){
												$('#'+id).removeClass('addToBookmarks');
												$('#'+id).addClass('delFromBookmarks');

												$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
												$('#'+id).children('span.txt').html(addnote);
											}
											if(status=='note'){
												$('#'+id).removeClass('addToBookmarks');
												$('#'+id).addClass('delFromBookmarks');
												$('#'+id).find('img').attr('src','/images/note_blue.png');
												$('#'+id).children('span.txt').html(addmorenote);
												if($('li.add_note_menu').length)
													$('li.add_note_menu').slideDown(500);
											}

											$('#bookmark_form_'+doc_id).slideUp(500, function(){
												$('#bookmark_form_'+doc_id+' .bookmark_title input').val(start_title);
												$('#bookmark_form_'+doc_id+' .bookmark_desc textarea').val(start_desc);
												/*$('#bookmark_form_'+doc_id+' .bookmark_desc label').show();*/
												/*$('#bookmark_form_'+doc_id+' .bookmark_title label').show();*/
												/*$('#bookmark_form_'+doc_id+' .bookmark_desc label.error').show();*/
												/*$('#bookmark_form_'+doc_id+' .bookmark_title label.error').show();*/
											});



							   }
						   });
					}
				});
			}


			return false;
}

function addNote1(classname,user,doc_id,doc_type,id,addtext,deltext){

	data={'what':classname,'user_id':user,'document_id':doc_id,'type':doc_type};


	if(classname=='addToBookmarks')
		{
			$('.bookmark_form').fadeOut(500);
			$('#bookmark_form').slideDown(500);

			if($('#bookmark_form .category_selector select').val()=='new')
				$('#bookmark_form .category_selector select').closest('.category_selector').children('.new_category_input').show();
			else
				$('#bookmark_form .category_selector select').closest('.category_selector').children('.new_category_input').hide();


			$('#bookmark_form .category_selector select').unbind('change');
			$('#bookmark_form .category_selector select').change(function(){
				if($(this).val()=='new')
					$(this).closest('.category_selector').children('.new_category_input').show();
				else
					$(this).closest('.category_selector').children('.new_category_input').hide();
			});

			$('#bookmark_form .send_button').unbind('click');
			$('#bookmark_form .send_button').click(function(){
				var error=false;
				if($(this).closest('.bookmark_bot').find('.category_selector select').val()=='new'){
					if(!$(this).closest('.bookmark_bot').find('.category_selector .new_category_input input').val())
						{
							$(this).closest('.bookmark_bot').find('.category_selector .new_category_input label.error').show();
							error=true;
						}
					data.category='new';
					data.category_name=$('#bookmark_form .category_selector .new_category_input input').val();
				}else{
					data.category=$('#bookmark_form .category_selector select').val();
				}

				if(!error){
					data.title=$('#bookmark_form .bookmark_title input').val();
					data.comment=$('#bookmark_form .bookmark_desc textarea').val();

					$.ajax({
						   type: "POST",
						   url: "/ajax_page.php",
						   data: data,
						   dataType: 'json',
						   success: function(response){
										if(response['status']=='add')
											{
												$('#'+id).children('span.txt').html(deltext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
												$('#'+id).attr('className','delFromBookmarks');

											}
										if(response['status']=='del')
											{
												$('#'+id).children('span.txt').html(addtext);
												$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
												$('#'+id).attr('className','addToBookmarks');
											}
										$('#bookmark_form').slideUp(500);
										var str=$('#about-company li.add_note_menu').html();
										str=str.replace('Добавить заметку','Мои заметки');
										$('#about-company li.add_note_menu').html(str);


						   }
					   });
				}
			});


			return false;
		}
	else{
			$.ajax({
			   type: "POST",
			   url: "/ajax_page.php",
			   data: data,
			   dataType: 'json',
			   success: function(response){

							if(response['status']=='add')
								{
									$('#'+id).children('span.txt').html(deltext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_blue.png');
									$('#'+id).attr('className','delFromBookmarks');
								}
							if(response['status']=='del')
								{
									$('#'+id).children('span.txt').html(addtext);
									$('#'+id).find('img').attr('src','/images/bookmark_HD_grey.png');
									$('#'+id).attr('className','addToBookmarks');
								}
			   }
		   });
   }
}
function go_to_company(event,url){

	event = event || window.event
	if($(event.target).attr('id')=='bookmarks_buttons' || $(event.target).closest('#bookmarks_buttons' ).length)
		return false;
	else
		window.location.href=url;


}
var newsScroller;






//var docWidth=window.document.innerWidth;
//console.log(window.document.documentElement.offsetWidth);


if (window.matchMedia("(max-width:767px)").matches) {
	$(document).ready(function(){
		var menu=$('#wrapper #menu');
		if(menu.length){
			var menuH=menu.height();
			var wrap=$('<div>').height(menuH).addClass('menu_mobile__wrapper');
			menu.wrap(wrap);
			var offsetTop0=menu.offset().top;
		}

		$(window).scroll(function(){
			var ws=$(window).scrollTop();

			var offsetTop=offsetTop0+$('#up_1180').height();

			if(ws<=offsetTop){

				 if(menu.css('position')=='fixed')
					menu.css({'position':'relative'})
			}else{

				if(menu.css('position')!='fixed')
					menu.css({'position':'fixed','top':0,'z-index':501})
			}
		});

	})

}
//ParalaxRun=0; //отключим пока


/*
function set_banner (place_id, id_type) {
	$.ajax({
		url: '/user_request.php',
		type: 'post',
		data: {
			what: 'get_banners',
			place_id: place_id,
			id_type: id_type,
		},
		dataType:'html',
		complete: function(html) {
			//console.log(html.responseText);
			if (html.responseText)
				if (id_type == 'alias')
					$('#'+ place_id).html(html.responseText);
				else{
					$('#banner_place_'+ place_id).html(html.responseText);
				}
			//console.log('upload '+place_id+': '+$('#sidebar').height())
			ParalaxSetParams();
		},
		cache: false,
		async: true
	});
}
*/
function LoadAdvPrice(){

	$.ajax({
		url: '/user_request.php',
		type: 'post',
		data: {
			what: 'get_banners_price'
		},
		dataType:'json',
		success: function(response) {
			if(response.price){
				var price=response.price;

				var shadow=$('<div>').attr('id',"map-box-bg").mouseover(function(){
					$('.map-box').css('opacity','1');
				})
				$('body').prepend(shadow);

				var fixed=price.fixed;
				for( var j in fixed ){
                    if($('.set_banner_price#'+j).length){
                        $('.set_banner_price#'+j).html(fixed[j].html).css({'z-index':9001});
                    }else{
                        $('.set_banner#'+j).html(fixed[j].html).css({'z-index':9001});
                        if (j == '_banner-index-blocs') {
                            let mapEl = $('.set_banner#'+j);
                            let p = mapEl.parent();
                            mapEl.remove()
                            p.before(mapEl);
                            mapEl.height(p.height())
                        }
                    }
				}

				var multi=price.multiple;
				for( var j in multi ){
					//console.log($('.set_banner#banner_place_'+j));
					$('.set_banner#banner_place_'+j).html(multi[j].html);
				}

				var top =$(''+
				'<div id="topadv" class="container" style="position: inherit !important;">'+
				'<div class="row">'+
				'<div class="twelvecol last" style="position:relative">'+
				'<div id="slogan" >Выйти из режима просмотра рекламных площадок</div>'+
				'<div id="close">&times;</div>'+
				'</div>'+
				'</div>'+
				'</div>')
				top.click(function(){

					window.location.pathname=='/' ? window.location.href='/advertisement' : window.location.reload();
				})
				$('#up_1180').prepend(top).css({'z-index':10000});
				$('#_banner-running-row').css({'z-index':10001});

				function closeRequirements(e){

					if($(e.target).closest('.highslide-container').length==0){
						//console.log(hs);
						//console.log(hs.Expander);
						hs.close();
					}
				}

				$('#main-articles-news-hor-full ul li').each(function(i,li){
					if(i && !$(li).find('#s_730_2').length)
						$(li).hide();
				});
				$('#content #forum').hide();
				$('#content #new').hide();
				$('.main_observ>div').each(function(i,div){
						//console.log(i);
					if(i>1) $(div).hide();
				})
			    //	$('#news_right_scroller').height(11*120-29);
				// $('#news-wrapper').height(11*120-29+54);

				$('#news_right li .preload').each(function(i,img){
                    if(i < 11){
                        preloadRightNewsImg(img);
                    }
                });
				$('#banner_place_29,#banner_place_13').css({'margin-bottom':'30px'})


				hs.Expander.prototype.onAfterExpand = function () {
				   $('body').on('click',closeRequirements);
				}
				hs.Expander.prototype.onAfterClose = function () {

				   $('body').off('click',closeRequirements);
				}

				var shadowtop=shadow.clone().height('33px');
				$('.top-fixed').css({'z-index':10000}).prepend(shadowtop);


				setInterval(function(){
					setTimeout(function(){$("#slogan").fadeOut(1000);}, 0);
					setTimeout(function(){$("#slogan").fadeIn(1000);}, 1000);
					}, 1500);
				}

		},
		async: true /*,
		error: function(jqXHR, textStatus, err) {
			alert( "Request failed: " + textStatus + " Detail: " + err);
		}*/
	});
}

function LoadBanners(o){

	if(o)
		var banners=$(o).find('.set_banner');
	else
		var banners=$('.set_banner');
	var bs=[];
	banners.each(function(i,b){
		var method=$(b).data('method');
		if(method=='alias')
			var id=$(b).attr('id')
		else
			var id=$(b).attr('id').replace('banner_place_','');
		var bb={'id':id};
		if(method)	bb.method=method;
		bs.push(bb);
	})
	if(bs.length){
		$.ajax({
			url: '/user_request.php',
			type: 'post',
			data: {
				what: 'get_banners_list',
				is_main: window.location.pathname=='/' ?  1 : '',
				banners: bs
			},
			dataType:'json',
			success: function(response) {
				var upBannerExists=false;

				if (response.banners){
					for(var i in response.banners){

						if (response.banners[i].method == 'alias'){
							$('#'+ response.banners[i].id).html(response.banners[i].html);
							$('#'+ response.banners[i].id).find('img').load(function(){
								//console.log($(this).attr('src'));
								ParalaxSetParams();
							})
							if(response.banners[i].id == 'up_1180'){
									upBannerExists=true;
									$('#'+ response.banners[i].id).find('img').load(function(i){
										$('#article').livescroll({'selector':'#article','selectorh1':'#article #page_h1_string #page_h1 h1','type':'articles'});
										$('#news-item').livescroll({'selector':'#news-item','selectorh1':'#news-item #page_h1_string #page_h1 h1','type':'news'});
									})
							}
                            $('#'+ response.banners[i].id + ' [data-toggle="popover"]').popover({html: true})
						} else{
							$('#banner_place_'+ response.banners[i].id).html(response.banners[i].html);
							$('#banner_place_mobile_'+ response.banners[i].id).html(response.banners[i].html);
							$('#banner_place_'+ response.banners[i].id).find('img').load(function(){
								//console.log($(this).attr('src'));
								ParalaxSetParams();
							})
                            $('#banner_place_'+ response.banners[i].id + ' [data-toggle="popover"]').popover({html: true})
                            $('#banner_place_mobile_'+ response.banners[i].id + ' [data-toggle="popover"]').popover({html: true})
						}
					}
				//console.log('upload '+place_id+': '+$('#sidebar').height())
				ParalaxSetParams();
				}
				if(!upBannerExists){
					$('#article').livescroll({'selector':'#article','selectorh1':'#article #page_h1_string #page_h1 h1','type':'articles'});
					$('#news-item').livescroll({'selector':'#news-item','selectorh1':'#news-item #page_h1_string #page_h1 h1','type':'news'});
				}
			},
			cache: false,
			async: true /*,
			error: function(jqXHR, textStatus, err) {
				alert( "Request failed: " + textStatus + " Detail: " + err);
			}*/
		});
	}
}


function authors_getpreload(){
		var div=$('#right_block_authors .right_block_authors_list');
		var ul=div.children('ul');
		ul.children('li').each(function(i,li){
			var preload=$(li).data('preload');
			var img = new Image();
			img.src = preload;
		})
	}
	$(window).load(function(){
			if($('#right_block_authors').length)
				authors_getpreload()
	})


var topRowDynamic;

const state = {
    isWebpSupported: false,
    isRetina: is_retina()
}

function replaceWebp() {
    if (state.isWebpSupported) return;

    let images = document.querySelectorAll('[data-webp-alter-source]');
    // Проходимся по каждому
    for (let i = 0; i < images.length; i++) {
        // Получаем значение каждого дата-атрибута
        let image = images[i].getAttribute('data-webp-alter-source');
        if (state.isRetina && images[i].hasAttribute('data-webp-alter-source-retina')) {
            image = images[i].getAttribute('data-webp-alter-source-retina');
        }

        // Каждому найденному элементу задаем свойство background-image с изображение формата jpg
        images[i].style.backgroundImage = 'url(' + image + ')';
        $(images[i]).removeAttr('data-webp-alter-source');
        $(images[i]).removeAttr('data-webp-alter-source-retina');
    }
}


$(document).ready(function(){
    (() => {
        // Проверяем, является ли браузер посетителя сайта Firefox и получаем его версию
        let isitFirefox = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
        let firefoxVer = isitFirefox ? parseInt(isitFirefox[1]) : 0;

        // Если есть поддержка Webp или браузер Firefox версии больше или равно 65

        if (canUseWebp() || firefoxVer >= 65) {
            state.isWebpSupported = true;
        }
    })();

    var monitorClickOutsideSearch = function(e){

        if(    $(e.target).closest('#search_form').length
            || $(e.target).is('#search_form')
            || $(e.target).closest('#search-live').length
            || $(e.target).is('#search-live')
        ){

        }else{
            $('#header-links li.search').removeClass('active');
            $("#search-live").hide();
            $("#search-close").hide();
            $('body').off('click', monitorClickOutsideSearch );
        }
    }

    $('#search-inpt').focus(function(){
        $('body').on('click', monitorClickOutsideSearch );
    })


	if($('body').data('fe')){
    	AOS.init();
    }
    $('#header-links li.social i').click(function(){
        $(this).closest('li').toggleClass('opened');
    })

	$('body').on('click','[data-need-auth]', function(e){
		showLogin('', window.location.pathname);
		return false;
	});


	$("body").on('click', '[href*="#"]', function(e){
		var name=$(this).attr('href').replace(/^\#/,'');
        var anchor = $('a[name='+name+']');
        if(anchor.length){
			$('html,body').stop().animate({ scrollTop: $(anchor).offset().top - (window.pageState.floatingTopHeight+25) }, 1000);
			e.preventDefault();
		}
	});

	$(document).on('click','#articles-lables span.title', function(){
		var c=$(this).closest('.articles-lables__type-container');
		var ul=c.find('ul');
		var w=$('#articles-lables').width()-60;
		var title=$(this).text();



		if( ul.css('display')=='none'){
			var d=c.clone();
			d.find('ul').addClass('cok-tags');

			hs.htmlExpand(null,{
				maincontentText:d.html(),
				dimmingOpacity : 0.8,
				width: w
				//headingText: title
			});
		}
	})


	if($('#content').length){
		var contentContainer=$('#content');

		var initTimer=setInterval(function(){
            //console.log(contentContainer.width(), $(window).width());

					if(contentContainer.width() <= $(window).width()){
						clearInterval(initTimer);
						mobilePluginsInit();
					}
				},10)

	}
	var mobilePluginsInit=function(){
		if($('.index-block-reviews.swiper-container').length){

			var reviewsSwiper = new Swiper ('.index-block-reviews.swiper-container',{
				slidesPerView:1,
				spaceBetween:0,
				//centeredSlides:true,
				scrollbar: {
				  el: '.index-block-swiper-scrollbar',
				},
				/*pagination: {
					el: '.swiper-pagination.test-swiper',
					clickable: true,
				  },*/
				breakpoints: {
					// when window width is >= 640px
					768: {
					  slidesPerView: 3,
					  spaceBetween: 10,
					  centeredSlides:false,
					  simulateTouch:false,
					}
				},
				on:{
					init:function(){

						var swiper=this;
						if(this.params.slidesPerView==1){

							var w=$(swiper.el).width();
							var delta=w-230;
							//console.log(w,delta);
							var nextSlideContent=$(swiper.slides[1]).find('.index-blocs__slide-wrapper');
							nextSlideContent.css('marginLeft',(-delta+10)+'px');
						}
					},
					slideChange:function(){
						//console.log(this);

						var swiper=this;
						var w=$(swiper.el).width();
						var delta=w-230;
						var activeSlide=$(swiper.slides[swiper.activeIndex]);
						var activeSlideContent=activeSlide.find('.index-blocs__slide-wrapper');


						/*
						if(!swiper.isBeginning && !swiper.isEnd){

							var prevSlideContent=$(swiper.slides[swiper.activeIndex-1]).find('.index-blocs__slide-wrapper');
							prevSlideContent.css({'marginLeft':(delta*3/2-10)+'px'});

							var nextSlideContent=$(swiper.slides[swiper.activeIndex+1]).find('.index-blocs__slide-wrapper');
							nextSlideContent.css({'marginLeft':(-delta/2+10)+'px'});

							activeSlideContent.css({'marginLeft':(delta/2)+'px'});

						}else{

							if(swiper.isBeginning){
								activeSlideContent.css({'marginLeft':0});
								var nextSlideContent=$(swiper.slides[swiper.activeIndex+1]).find('.index-blocs__slide-wrapper');
								nextSlideContent.css({'marginLeft':(-delta+10)+'px'});
							}

							if(swiper.isEnd){
								activeSlideContent.css({'marginLeft':(delta)+'px'});
								var prevSlideContent=$(swiper.slides[swiper.activeIndex-1]).find('.index-blocs__slide-wrapper');
								prevSlideContent.css({'marginLeft':(2*delta-10)+'px'});
							}
						}
						*/

						if(!swiper.isBeginning && !swiper.isEnd){

							var prevSlideContent=$(swiper.slides[swiper.activeIndex-1]).find('.index-blocs__slide-wrapper');
							prevSlideContent.animate({'marginLeft':(delta*3/2-10)+'px'},500);

							var nextSlideContent=$(swiper.slides[swiper.activeIndex+1]).find('.index-blocs__slide-wrapper');
							nextSlideContent.animate({'marginLeft':(-delta/2+10)+'px'},500);

							activeSlideContent.animate({'marginLeft':(delta/2)+'px'},500);

						}else{

							if(swiper.isBeginning){
								activeSlideContent.animate({'marginLeft':0},500);
								var nextSlideContent=$(swiper.slides[swiper.activeIndex+1]).find('.index-blocs__slide-wrapper');
								nextSlideContent.animate({'marginLeft':(-delta+10)+'px'},500);
							}

							if(swiper.isEnd){
								activeSlideContent.animate({'marginLeft':(delta)+'px'},500);
								var prevSlideContent=$(swiper.slides[swiper.activeIndex-1]).find('.index-blocs__slide-wrapper');
								prevSlideContent.animate({'marginLeft':(2*delta-10)+'px'},500);
							}


						}



					}
				}
			});
		}

		if($('.news-right__mobile.swiper-container').length){
			var mySwiper = new Swiper ('.news-right__mobile.swiper-container',{
				scrollbar: {
				  el: '.news-right__mobile.swiper-container 	.swiper-scrollbar',
				},
			});
		}
	}
	/*
	var swiper = new Swiper('.swiper-container.test-swiper', {
      slidesPerView: 4,
      spaceBetween: 30,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination.test-swiper',
        clickable: true,
      },
    });*/













	$('.years-menu').YearsMenu();
	$('.vak-page-content .ib-tabs').YearsMenu();
	//$('.years-menu').YearsMenu('get');
	$(document).on('click','[data-close-login-form]',function(){
		closeLogin();
		return false;
	})


		if(!getCookie('privacy-policy-confirm',1)){
					showMsg({
						'text':'<div>Этот веб-сайт использует файлы cookies.<br>Продолжая просмотр сайта, Вы соглашаетесь и принимаете нашу <a href="/privacy">политику конфиденциальности</a>.</div>'+
								'<div style="margin-top:20px"><a class="btn btn-default" id="button-privacy-policy-confirm">ОК. Больше не показывать.</a></div>',
						'time':0,
						shadow:false,
						template:'bottom-fixed',
						scroll:false
					})
					$('#button-privacy-policy-confirm').click(function(){
						closeMsg(500);
						setCookie('privacy-policy-confirm',1)
					})
		}


	$('#vak_anons').VakAnons();

	$('#articles-lables ul').articleLabelsShort();


	$('[data-news-tags-menu]').ajaxNewsPager({
		target:'#news-inner'
	})


	$('a[href="/advertisement/site"],a[href="/#adv"]').click(function(){

		window.location.href='/#adv';
		window.location.pathname=='/' ?  window.location.reload() : false;
		return false;
	})


	$('.issue-info--articles-list--item--show-anons').each(function(j,button){
		var c=$(this).children('.issue-info--articles-list--item--show-anons--anons-text');

		if(c.length) {

			/*$(button).tooltip();*/
			$(button).tooltip({'content':c.html()});
			/*$(button).tooltip('open')*/
		}
	})


	/*
	$(document).on('change','#energoatlas_poll_never',function(){
		var i=$(this);
		if(i.prop('checked')){
				setCookie('lastpool',(new Date()).getTime()+86400000*365)
		}else {
				setCookie('lastpool',(new Date()).getTime())
		}
	})

	var lastpool=getCookie('lastpool');
	var ts=(new Date()).getTime();

	if((ts-lastpool > 86400000)){

		showMsg({
			time:0,
			width:796,
			scroll:1,
			blurclose:0,
			text:''+
			'<div style="text-align:right"><input type="checkbox" id="energoatlas_poll_never"> Не показывать больше</div>'+
			'<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfYNcKgBfNFsolBLzGoRwxqP2wIyMhsdntY3C-9aGzTE60okg/viewform?embedded=true" width="760" height="1200" frameborder="0" marginheight="0" marginwidth="0">Загрузка...</iframe>'
		})
		setCookie('lastpool',ts);
	}
	*/

	//$(document).scrollingLogo();
	if($('body').data('fe'))
		topRowDynamic=$('#top').topRowDynamic();







	$('.id-news-comments-anchor').click(function(){
			var comms=$(this).closest('#news-item').find('.id-comms');

			if(comms.length)
				offset=comms.offset();
			else
				offset=$(this).closest('#news-item').find('#add-comm').offset();

			newtop=offset.top-200;
			$(document).scrollTop(newtop);
			return false;
		});


	$(document).on('click','.article-icons .comments a', function(){
		var id=$(this).attr('href').replace('#','');
		var o=$("a[name='"+id+"'");
		$(window).scrollTop(o.offset().top)
		//alert('d');
		return false;
	})
	$(document).on('click','.add_news_comment', function(){

		if(!$(this).hasClass('runing'))	{
			$(this).addClass('runing');
			var button=$(this)
		var data={};


		data.type='news';
		var c=$(this).closest('.row');

		data.recaptcha=c.find('[name="g-recaptcha-response"]').val();

		data.text=c.find('#comment_text').val();
		data.mail=c.find('#comment_mail').val();
		data.fio=c.find('#comment_fio').val();
		data.id=c.find('input[name=news_id]').val();
		//data.check=c.find('#check_symbols').val();
		if(c.find('.id-comms ul li').eq(0).hasClass('empty'))
			data.offset=0;
		else
			data.offset=c.find('.id-comms ul li').length;

		//console.log(data);


		add_comment(data,function(comments,turn_on_notice){
				$(button).removeClass('runing');
				//console.log(noticeObj[data.id]);
				if(turn_on_notice) noticeObj[data.id].comment_on();

				$('.id-comms.comms-'+data.id+' ul li.empty').remove();
				if(!data.offset) $('.id-comms.comms-'+data.id).slideDown(500);
				for(var i in comments){

						$('.id-comms.comms-'+data.id+' ul').append('<li class="insert">'+
							'<p class="date">'+comments[i].date+'</p>'+
							'<p class="name">'+comments[i].fio+'</p>'+
							'<p>'+comments[i].text+'</p>'
						);
						var li=$('.id-comms.comms-'+data.id+' ul li:last');
						var h=$(li).height();
						var text=$(li).html();
						$(li).height(h);
						$(li).html('');
						$(li).hide();
						$(li).slideDown(500,function(){
							$(li).html(text);
							$(li).hide();
							$(li).fadeIn(500,function(){
								$(li).height('auto');
							});
						});
					}
					//$('#comms ul li.insert').fadeIn(1000);
					//console.log(grecaptcha)
					//console.log(recaptcha)

					if(recaptcha && recaptcha['re-captcha-news-'+data.id])
						grecaptcha.reset(recaptcha['re-captcha-news-'+data.id]['id']);
					c.find('#comment_text').val('');
			},function(){
				$(button).removeClass('runing');
				if(recaptcha && recaptcha['re-captcha-news-'+data.id])
					grecaptcha.reset(recaptcha['re-captcha-news-'+data.id]['id']);

			});

		}
	});

	$(document).on('click','.id-comms  ul li .comm-rating .buttons .sbmt',function(){

		if($(this).closest('.buttons').find('.sbmt.disabled').length)
			var repeat=1;

		var li=$(this).closest('li');
		if($(this).hasClass('disabled'))
		return false;
		var id=$(li).find('input[name=comm_id]').val();
		if($(this).hasClass('pos'))
			var val=1;
		if($(this).hasClass('neg'))
			var val=-1;
		data={id:id,val:val,what:'rate_comm',type:'news'}

		var posval=parseInt($(li).find('span.rating-pos-count').text());
		var totalval=parseInt($(li).find('span.rating-total-count').text());

		var div =$(li).find('.comm-rating-count');
		$(div).animate({opacity:0},function(){

		if(val==1){
			$(li).find('.buttons .sbmt.neg').removeClass('disabled');
			$(li).find('.buttons .sbmt.pos').addClass('disabled');
			$(li).find('span.rating-pos-count').html( posval+1 );
			if(repeat)
			$(li).find('span.rating-total-count').html( totalval);
			else
			$(li).find('span.rating-total-count').html( totalval+1 );
		}
		if(val==-1){
			$(li).find('.buttons .sbmt.neg').addClass('disabled');
			$(li).find('.buttons .sbmt.pos').removeClass('disabled');
			if(repeat)
			$(li).find('span.rating-pos-count').html( posval-1 );
			if(repeat)
			$(li).find('span.rating-total-count').html( totalval);
			else
			$(li).find('span.rating-total-count').html( totalval+1 );
		}

			$(div).animate({opacity:1});
		});

		$.ajax({
		url: '/ajax_page.php',
		type: 'post',
		data: data,
		dataType:'json',
		success:function(response){
				if(response.error){
					s='';
					for (var i in response.error)
						s+=response.error[i]+'<br>';
						showMsg({
						'text':s,
						'time':0
					});
				}
				if(!response.success){
					$(li).find('span.rating-pos-count').html(posval);
					$(li).find('span.rating-total-count').html(totalval);
				}



			}
		})
		return false;

	})


	if($('body').data('fe')){
		check_ratio();
		$('#content').addtocopy({
			htmlcopytxt: '<br/>Источник: <a href="' + window.location.href + '" target="_blank">' + window.location.href + '</a>',
			addcopyfirst: false,
			getText:function(el){
				var c,url;
				if(   (  ((c=$(el).closest('#article')) && c.length)  || ( (c=$(el).closest('#news-item')) && c.length )) && (url=c.data('url'))){
					return '<br/>Источник: <a href="' + window.location.origin+url + '" target="_blank">' + window.location.origin+url + '</a>';
				}
				return this.htmlcopytxt;
			}
		});
		$('#content').liQuotes();

		/* ширина подменю */
		//menuW();
	}
	/* загрузим баннеры */

	//if(window.location.pathname=='/advertisement/site'){
	if(window.location.hash=='#adv'){
		LoadAdvPrice();
	}else{
		LoadBanners();
	}
	/* end == загрузим баннеры */



	$(document).on("mousedown","#login-wrapper",function(a){

		if($(a.target).parents().filter("#login").length!=1)
			{
					closeLogin();
					closePop();
					a.stopPropagation();

			}
		});

	setTimeout(function() { show_social(); }, 1);

	/*highslide*/
	hs.graphicsDir = '/js/highslide/graphics/';
    hs.outlineType = 'rounded-white';
    hs.showCredits = false;
	hs.outlineWhileAnimating = true;
	/*highslide*/

	if($('body').data('user')){
        setCookie('userid', $('body').data('user'), 3600 * 100000000, '/');
    }
	if($('body').data('lang')){
        setCookie('lang', $('body').data('lang'), 3600 * 100000000, '/');
    }



     /* Yandex.Metrika counter */
     (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
     m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
     (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

     ym(22155755, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true
     });
     /* Yandex.Metrika counter */


	maxAdverts = $('.offers .offers-list li').length;
	if(maxAdverts){
		adverts={};
		$('.offers .offers-list li').each(function(i,li){
			var text=$(li).children('span').html();
			$(li).children('span').remove();
			adverts[i]={
				id: $(li).data('id'),
				descr:$(li).html(),
				text:text,
				company_name: $(li).data('company'),
				company_phone: $(li).data('phone'),
				company_url: $(li).data('url')
			}
		})
		//adverts = {{$k}: {id:{$it.sys_id}, descr:'{$it.descr|replace:"'":"\'"}', text:'{$it.text|replace:"'":"\'"}', company_name: '{$it.company_name}', company_phone: '{$it.company_phone}', company_url: '{$it.company_url}'}};
		//console.log(adverts);
		if (maxAdverts > 1)
			setAdverts(maxAdverts, 3900);
		else {
			var cAdv= adverts[0];
			//console.log(cAdv);
			$('.running-line').append(
				$('<span>').click(function(){
					setAdvertLink(0);
					setAdvertContent(0);
					closeTopSlider('.cities');
					openTopSlider(".offers");
					$(".running-line").addClass('hidden');
				}).html(cAdv['descr'])
			)
		}

		$(".offers-close").click(function(){
			closeTopSlider(".offers");
			$(".running-line").removeClass('hidden');
		});
	}


	if($(".cities-drop").data('show')){
		if (!window.matchMedia("(max-width:767px)").matches)
								setTimeout(function() {
									openCities();
								}, 5000);
	}

	$("#greyRowText").on('click', ".cities-drop .city" , function(){
									//console.log($(".cities").height());
									if ($(".cities").hasClass("active") == false)
										openCities();
									else
										closeCities();
								});

	$("#greyRowText").on('click', "#top-links .fio", function(){
									var hl = $(this).prev();
									$(this).closest('#top-links').addClass('opened');
									var fio=$(this).find('.fio-hidden');

									if (hl.hasClass("active") == false){

										$('.langs').fadeOut(300);
										$('.cities-drop').fadeOut(300,function(){

											if($('#banner_unit_show_').length)
												$('#banner_unit_show_').fadeOut(300,function(){
													hl.addClass("active").fadeIn(300);
													fio.fadeIn(300);
													$('.cities-drop').fadeIn(300);
													$('.langs').fadeIn(300);
												})
											else{
													hl.addClass("active").fadeIn(300);
													fio.fadeIn(300);
													$('.cities-drop').fadeIn(300);
													$('.langs').fadeIn(300);
												}

										})
									}
									else {
										$('.cities-drop').fadeOut(300);
										$('.langs').fadeOut(300);
										fio.fadeOut(300);
										hl.removeClass("active").fadeOut(300, function() {
											$('.cities-drop').fadeIn(300);
											$('.langs').fadeIn(300);
											if($('#banner_unit_show_').length)
												$('#banner_unit_show_').fadeIn(300)
										});
									}
								});





	$('#menu #activesubmenu').addClass('active_sub');



	$('body').on('click', '.menu_mobile__wrapper li span.active-back a', function(){

		var li=$(this).closest('li');
		var sub=li.children('div');


		if(sub.length && !li.hasClass('active')){
			sub.stop();
			if(sub.css('display')=='none'){
				sub.slideDown();
			}else{
				sub.slideUp();
			}
			return false;
		}else{
			if(li.hasClass('active')){
				li.closest('#menu').find('.mobile-dropdown').click();
				return false;
			}
		}

	})

	$('#menu li').hover(function(e){

		var menu=$(this).closest('#menu');

		var li =$(this);
		//if(li.hasClass('active')) return false;
		var activeli=menu.find('li.active');

		var a=li.find('.active-back a');

		if($(e.target).is(a) && ($(window).width()<=767)){
			return false;
		}

		var div=li.find('div');
		//li.css('opacity':'0.5');
		activeli.find('.active-back a').stop().animate({
			'opacity':'0.9'
		},300)
		a.animate({
			'background-color':'#e6292f'
		},300);

		var activediv=menu.find('li div.active_sub');
		activediv.stop().fadeOut(150,function(){
			activediv.removeClass('active_sub');
			div.stop().fadeIn(150);
			div.addClass('active_sub');
		});

		if($(window).width()<=767){
			return false;
		}


	},
	function(){
		var menu=$(this).closest('#menu');
		var li=$(this);
		if(li.hasClass('active')) return false;
		var a=li.find('.active-back a');
		var div=li.find('div');
		//li.css('opacity':'1');


		var activeli=menu.find('li.active');
		activeli.find('.active-back a').stop().animate({
			'opacity':'1'
		},300)


		a.animate({
			'background-color':'transparent'
		},300)

		div.stop().fadeOut(150,function(){
			menu.find('#activesubmenu').stop().fadeIn(150).addClass('active_sub');
		});

	});



	if (window.matchMedia("(max-width:767px)").matches) {
		$('#big_img_div').height( (330/746)*( $(window).width()) )
	}
	$(window).resize(function(){
		if (window.matchMedia("(max-width:767px)").matches) {
			$('#big_img_div').height( (330/746)*( $(window).width()) )
		}else{
			$('#big_img_div').height(330);
		}
	})


	/* ПОИСК */
	var search_last_keyup = 0;
	$('#search-close').css('cursor','pointer');
	$('#search-close').bind('click', function() {
		$('#search-inpt').val(document.getElementById('search-inpt').defaultValue);
		$('#search-close').hide();
		$('#search-live').html('');
		$('#search-live').hide();
	});

	$('#search-inpt').keyup(function(){
		var input=$(this);
		var search_delay=input.data('delay')-10;

		if (input.val())
			$('#search-close').show();
		else
			$('#search-close').hide();

		var currentDate = new Date();
		search_last_keyup = currentDate.getTime();
		setTimeout(		function(){

									var currentDate = new Date();
									var now_keyup = currentDate.getTime();
									var delta = now_keyup - search_last_keyup;
									//alert(last_keyup+' | '+now_keyup+' | '+delta+' | '+search_delay);
									var result=null;
									if (delta > search_delay) {
										if ($('#search-inpt').val().length > 2) {
											//alert( "go");
											result = new Object;
											var res=$.ajax({
												url: '/ajax_page.php',
												type: 'post',
												data: {
													what:'search_on_fly',
													str:$('#search-inpt').val()
												},
												dataType:'html',
												success: function(data) {
													//setTimeout("$('#search_close').attr('src','/images/close.png')", 500);
												},
												cache: false,
												async: false
											}).responseText;
											if (res) {
												$('#search-live').html(res);
												$('#search-live').show();
											}
											else {
												$('#search-live').html('');
												$('#search-live').hide();
											}
										}
										else {
											$('#search-live').html('');
											$('#search-live').hide();
										}
										return result;
									}

					}, search_delay);

	})
	/* ПОИСК */





	$('.up-1180-close').click(function(){
			var id=$(this).attr('id').replace('close-banner-','');
			$.ajax({
									url: '/user_request.php',
									type: 'post',
									data: {what:'close_banner', id: id},
									dataType:'html'

							});
	})


	$('#header-links .icon-search').click(function(){
		/*
		$(this).closest('.search').addClass('active');
		var w1 = $("#search-inpt").width(); //была ширина поля
		var w2 = $("#header-links li.social").width() + 10; //ширина соц. иконок
		var w = w1 + w2 + "px"; //стала ширина поля
		var l = "-=" + w2 + "px"; //смещаем влево на ширину соц. иконок

		$("#search-inpt").animate({"width":w, "left":l}, 250);
		*/
	/*	$(this).closest('.search').addClass('active')
		$("#search-inpt").focus();
		onFocusSearch()*/

	});




	/*var testdiv=$('<div id="test" style="position:absolute; z-index:100; padding:20px; background-color:#fff"></div>');*/
	/*$('body').prepend(testdiv)*/

	if($('#new-company-tab-onmain').length){
		/*alert('1')*/

		var block=$('#new-company-tab-onmain')
		var main_cities_many_word0=$(block).find('input[name=main_cities_many_word0]').val();
		var main_cities_many_word1=$(block).find('input[name=main_cities_many_word1]').val();
		var main_cities_many_word2=$(block).find('input[name=main_cities_many_word2]').val();
		var main_cities_one_word=$(block).find('input[name=main_cities_one_word]').val();


		var cityrows=$(block).find('.new-company-cities em');


		$(cityrows).each(function(i,em){
			var td=$(em).closest('td');
			var tdw=$(td).width();
			var emw=$(em).width();
			if(emw > tdw){
				var cities=$(em).text().split(', ');
				var text='';
				var ii=0;
				do{
					cities.pop();
					ii++;
					var cityword='';
					if(ii==1){
						cityword=main_cities_one_word;
					}
					else
					{
						if(ii>10 && ii<20){
							cityword=main_cities_many_word0;
						}
						else
						{
							if(ii%10==1)
								cityword=main_cities_many_word1;
							else
							{
								if(ii%10==2 || ii%10==3 || ii%10==4)
									cityword=main_cities_many_word2;
								else
									cityword=main_cities_many_word0;
							}
						}
					}
					$(em).text(cities.join(', ')+' +'+ii+' '+cityword);
				}while( $(em).width() > tdw );


			}
			if(i==$(cityrows).length-1){

				$('#news-tab-2').hide();
			}

	/*		$(em).prepend(i+'=> '+parseInt($(em).width())+' => '+$(td).width()+' ');*/

		})

		$('#news-rating-tabs li').click(function(){
			$('#news-rating-tabs li').toggleClass('active')

			var openid=$(this).attr('data-id');
			if(openid=='news-tab-1')
				var closeid='news-tab-2';
			else
				var closeid='news-tab-1';
				$('#'+closeid).fadeOut(500,function(){
					$('#'+openid).fadeIn(500);
				})
		})


	}

	/* Блок семинары/выставки на главной*/
	if($('#sidebar #events').length){
		var active=0;
		if($('#sidebar #events #events-tab-1 ul li').length < 4){
			active=1;
		}


		$('#sidebar #events').cokTabulator({fixHeight:1,hideEmpty:1,click:function(button){
			$('#events .events-title a').attr('href',$(button).attr('data-url'));
		}, 'active':active})
		/*
		$('#events-tab-2').hide();
		$('#events-tabs li').click(function(){

			$('#events-tabs li').toggleClass('active')

			var openid=$(this).attr('data-id');
			var url =$(this).attr('data-url');

			if(openid=='events-tab-1')
				var closeid='events-tab-2';
			else
				var closeid='events-tab-1';
				$('#'+closeid).fadeOut(500,function(){
					$('#'+openid).fadeIn(500);
				})
		})
		*/
	}
	/* конец ### Блок семинары/выставки на главной*/

	if($('#news-wrapper').length){

		if($('.news-right__mobile').length){
            ;
			$('.news-right__mobile .preload').each(function(i,img){
                preloadRightNewsImg(img);
            });
		}


		if($('#news_right').hasClass('listtype')){

			$('#news .slider-opacity').height('15px');
			$('#news-wrapper .bloc-bottom').css('marginTop','-6px');
			span_count=$('#news_right li  span.title').length;
			//alert('xxx:5');
			$('#news_right li  span.title').each(function(i,span){
				h0=parseInt($(span).css('line-height'));
				h=$(span).height();

				if(h>h0){

					var text=$(span).text().split(' ');
					while($(span).height()>h0)
					{
						text.pop();
						var newtext=text.join(' ')+'...';
						$(span).text(newtext);
					}
					$(span).css({'white-space':'nowrap'})
				}

				if(i==span_count-1){

					var params={};
					params['type']=$('#news_right').data('type');

					newsScroller=$("#news").simpleScroll({
						btnNext:"#news-wrapper .next",
						btnPrev:"#news-wrapper .prev",
						visible:col,
						scroller:'#news_right_scroller',
						speed:700,
						start:$('#newsScrollStart').val(),
						dynamicAddAfterNextClick:function(){
							var startcount=$('#news_right li').length;
							$.ajax({
									url: '/ajax_page.php',
									type: 'post',
									data: {what:'get_right_news', my_begin:$('#news_right li').length, my_count:col, ajax:1, params:params},
									dataType:'html',
									success:function(html){

									if(startcount==$('#news_right li').length)
										{
											$('#news_right').append(html);
                                            replaceWebp();
											if($('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on') || params.type=="companies_news") {
													//alert('xxx:6');
													$('#news_right li  span.title').each(function(i,span){
														h0=parseInt($(span).css('line-height'));
														h=$(span).height();

														if(h>h0){

															var text=$(span).text().split(' ');
															while($(span).height()>h0)
															{
																text.pop();
																var newtext=text.join(' ')+' ...';
																$(span).text(newtext);
															}
															$(span).css({'white-space':'nowrap'})
														}
													});
											}
										}
									}

							});

						}

					  });
				}

			});

		}
		else{
                ;
		  		$('#news_right li img.preload').each(function(i,img){
					if(i < col){
						preloadRightNewsImg(img)
					}
				});

				$('#news .slider-opacity').height('28px');
				$('#news-wrapper .bloc-bottom').css('marginTop','-20px');

				span_count=$('#news_right li').length;

				$('#news_right li').each(function(i,li){

				            $(li).trimNewsAnons();

        					if(i==span_count-1){

        						newsScroller=$("#news").simpleScroll({
        							btnNext:"#news-wrapper .next",
        							btnPrev:"#news-wrapper .prev",
        							visible:col,
        							scroller:'#news_right_scroller',
        							speed:700,
        							itemheight:90,
        							itempadding:30,
        							start:$('#newsScrollStart').val(),
        							dynamicAddAfterNextClick:function(){
        								var startcount=$('#news_right li').length;
        								$.ajax({
        										url: '/ajax_page.php',
        										type: 'post',
        										data: {what:'get_right_news', my_begin:startcount, my_count:col, ajax:1},
        										dataType:'html',
        										success:function(html){
        											if(startcount==$('#news_right li').length) {
                                                        $('#news_right').append(html);
                                                        replaceWebp();
                                                    }
        										}

        								});

        							},
        							afterNextClick:function(now){
                                        ;
        								for(let j=now; j<now+col; j++){
        									const img=$('#news_right li').eq(j).find('.preload');
        									if($(img).length){
        										preloadRightNewsImg(img)
        									}
        								}
        							},
        							afterPrevClick:function(now){
                                        ;
        								for(let j=now-1; j>=now-col; j--){
        									const img=$('#news_right li').eq(j).find('img.preload');
        									if($(img).length){
        										preloadRightNewsImg(img)
        									}
        								}

        							}

        						  });

        					}

        				});

		}


			$('#news-wrapper').hover(function(){
				$(this).find('.controls').fadeIn(300);
			},function(){
				$(this).find('.controls').fadeOut(150);
			})

			$('#news_rubric_select').on('mouseout','li.clicked a',function(){
				$(this).closest('li').removeClass('clicked');
			});

			$('#news_rubric_select').on('click','li a',function(){
				$(this).closest('li').toggleClass('active');
				$(this).closest('li').addClass('clicked');
				link=$(this);

				$.ajax({
					url: '/ajax_page.php',
					type: 'post',
					beforeSend: function() {},
					data: {what:'change_right_news_rubrics',rubric_id:$(this).attr('class').replace('rubric_id_','')},
					dataType:'html',
					complete: function(html)
						{
							if (html.responseText)
							{
								get_news_right();
							}
						}

				});
				return false;
			});



			$('body').click(function(e){
				if($('#news_rubric_select').is(':visible')){



					if(!($(e.target).closest('#news_rubric_select').length || $(e.target).attr('id')=='news_rubric_select' || $(e.target).attr('id')=='news_rubric_select_button'))
						$('#news_rubric_select').slideUp(500,function(){
							$('#news_rubric_select_margin').hide();
						});

				}
			});

			if($('#news_rubric_select').length){
			$.ajax({
					url: '/ajax_page.php',
					type: 'post',
					beforeSend: function() {},
					data: {what:'get_right_news_rubrics'},
					dataType:'html',
					complete: function(html)
						{

						if (html.responseText)
							{

								$('#news_rubric_select').html(html.responseText);
							}
						}
				});
			}

			$('#news_rubric_select_button').click(function(){

				if($('#news_rubric_select').is(':visible'))
					$('#news_rubric_select').slideUp(500,function(){
						$('#news_rubric_select_margin').hide();
					});
				else{
					$('#news_rubric_select_margin').show();
					$('#news_rubric_select').slideDown(500);
				}
			});

	}


	function showStartPageInstructions(){
					$('body').prepend('<div id="popupLayer"></div>');
					$('#popupLayer').css('width',$(window).width());
					$('#popupLayer').css('height',$(document).height());
					$('#popupLayer').css('left','0');
					$('#popupLayer').css('top','0');
					$('#popupLayer').css('position','absolute');
					$('#popupLayer').css('z-index','100000');

					$('#popupLayer').click(function(){
						$('#popupLayer').remove();
						$('#start_page_instruction').hide();
						$('#startpage_instr_zoom').hide();
					});
					$(window).resize(function(){
						$('#popupLayer').css('width',$(window).width());
						$('#popupLayer').css('height',$(document).height());
					});
	}
/*
	$('#slogan').hover(
		function(){

			$('#slogan_set_start_page').stop();
			$('#slogan_set_start_page').fadeIn(1000);

			$('#slogan').stop();
			$('#slogan').animate({'color':'#58595b'});
		},
		function(){

			$('#slogan_set_start_page').stop();
			$('#slogan_set_start_page').fadeOut(1000);

			$('#slogan').stop();
			$('#slogan').animate({'color':'#8c8c8c'});
		}
	);
*/
	$('#slogan').hover(
		function(){
			var slogan=$(this);
			slogan.width(slogan.width());
			$(slogan).find('div').stop();
			$(slogan).find('div.onmouseout').fadeOut(500,function(){
				$(slogan).find('div.onmouseover').fadeIn(500);
				//slogan.width('auto');
			});
		},
		function(){
			var slogan=$(this);
			$(slogan).find('div').stop();
			$(slogan).find('div.onmouseover').fadeOut(500,function(){
				$(slogan).find('div.onmouseout').fadeIn(500);
				//slogan.width('auto');
			});
		}
	);


	$('#slogan').click(function(){

		if($('#start_page_instruction').length){
			$('#start_page_instruction').show();
			showStartPageInstructions();
		}
		else
		{
			var ua = navigator.userAgent.toLowerCase();
			var browser;
			if (ua.indexOf("msie") != -1) {
				document.getElementById('set_start_page').style.behavior='url(#default#homepage)';
				document.getElementById('set_start_page').setHomePage('http://c-o-k.ru');
			}
			if (ua.indexOf("chrome") != -1) {
				/*showBrowserPopup("browserChrome");*/
				browser='chrome';
			}
			if (ua.indexOf("opera") != -1) {
				/*showBrowserPopup("browserOpera");*/
				browser='opera';
			}
			if ((ua.indexOf("mozilla") != -1) && (ua.indexOf("chrome") == -1) && (ua.indexOf("msie") == -1) && (ua.indexOf("safari") == -1)) {
				/*showBrowserPopup("browserMozilla");*/
				browser='firefox';
			}
			if ((ua.indexOf("safari") != -1) && (ua.indexOf("chrome") == -1)) {
				/*showBrowserPopup("browserSafari");*/
				browser='safari';
			}

			if(browser)
			$.ajax({
				url: '/ajax_page.php',
				type: 'POST',
				data: 'what=get_startpage_instructions&browser='+browser,
				cache: false,
				dataType: 'json',
				success: function(data){
					//$('#wrapper').prepend(data.text);
					$('#wrapper').prepend(data.text);
					showStartPageInstructions();

					$('#start_page_instruction').on('click',function(e){
						if(!$(e.target).is('#start_page_instruction a.preview'))
							$('#startpage_instr_zoom').hide();
					});

					$('#start_page_instruction .up-1180-close').on('click',function(){
						$('#start_page_instruction').hide();
						$('#popupLayer').remove();
					});

				}

			});
		}
	});

	/*Покажем галерею на главной*/
	if($('#index_gallery').length){
		var imgs_count=$('#preview_images #small_div li').length;
		$('#preview_images #small_div li').each(function(i,li){
			if(i<4){
				var small_img=$(li).find('input.img_small').val();
				$(li).find('img').attr('src', small_img);
			}
			/*
			if(i<4){
				var big_img=$(li).find('input.img_big').val();
				$('#big_img_div img').eq(i).attr('src',big_img);
			}*/

		})
	}



	/* ПЛАШКА НАСТРОЙКИ НОВОСТЕЙ */
	var subscr_email_start_text='';
	$('#news_rubric_select').on('click','#news_list_right_preferences a#news_list_right_preferences_list',function(){
			$(this).find('.fa').toggleClass('fa-toggle-on').toggleClass('fa-toggle-off');
			$.ajax({
						url: '/ajax_page.php',
						type: 'post',
						data: {what:'change_right_news_rubrics_preferences',list: ($('#news_list_right_preferences_list span.fa').hasClass('fa-toggle-on') ? 1 : 0)},
						dataType:'json',
						success: function(response)
							{
								if (response.success)
								{
									get_news_right();
								}
								if(parseInt(response.list)){
									$('#news_list_right_preferences a#news_list_right_preferences_autoscroll').addClass('disabled')
								}
								else
									$('#news_list_right_preferences a#news_list_right_preferences_autoscroll').removeClass('disabled')

								//console.log('after list click',response);
								if(response.autoscroll)
									$('#news_list_right_preferences_autoscroll').addClass('on');
								else
									$('#news_list_right_preferences_autoscroll').removeClass('on');
							}
					});
			return false;
		});


	$('#news_rubric_select').on('click','#news_list_right_preferences a#news_list_right_preferences_autoscroll',function(){
			if(!$(this).hasClass('disabled')){
				$(this).find('.fa').toggleClass('fa-toggle-on').toggleClass('fa-toggle-off');
				$.ajax({
							url: '/ajax_page.php',
							type: 'post',
							data: {what:'change_right_news_rubrics_preferences',autoscroll: ($('#news_list_right_preferences_autoscroll span.fa').hasClass('fa-toggle-on') ? 1 : 0)},
							dataType:'json',
							success: function(response){
									//console.log('after autoscroll click',response.success, response.autoscroll);

									if(response.autoscroll)
										$('#news_list_right_preferences_autoscroll').addClass('on');
									else
										$('#news_list_right_preferences_autoscroll').removeClass('on');
							}
						});

			}
			return false;
		});

	$('#news_rubric_select').on('click','#news_list_right_preferences_close,#news_list_right_preferences_close_bot',function(){
		$('#news_rubric_select').slideUp(500,function(){
			$('#news_rubric_select_margin').hide();
		});
	})

	$('#news_rubric_select').on('focus','#news_list_right_subscribe_email', function(){
		if(subscr_email_start_text=='' && !$(this).hasClass('donotclear')) subscr_email_start_text=$('#news_list_right_subscribe_email').val();
		$(this).removeClass('noactive');
		if($(this).val()==subscr_email_start_text)
			$(this).val('');
		if($(this).hasClass('error')){
			$(this).removeClass('error');
			$(this).val('');
		}

	});
	$('#news_rubric_select').on('blur','#news_list_right_subscribe_email',function(){
		if($(this).val()==''){
			$(this).addClass('noactive');
			$(this).val(subscr_email_start_text);
		}
	});
	$('#news_rubric_select').on('mouseover','#news_list_right_show_subscribe_send',function(){
		$(this).addClass('hover');
	});
	$('#news_rubric_select').on('mouseout','#news_list_right_show_subscribe_send',function(){
		$(this).removeClass('hover');
	});

	$('#news_rubric_select').on('click','#news_list_right_show_subscribe_send',function(){
		if($(this).hasClass('disabled'))
			return false;

		$(this).addClass('disabled');
		email=$('#news_list_right_subscribe_email').val();
		if(email && !$('#news_list_right_subscribe_email').hasClass('noactive') && !$('#news_list_right_subscribe_email').hasClass('error'))
			{
				$.ajax({
					url: '/ajax_page.php',
					type: 'post',
					data: {what:'add_subscr_news', email:email},
					dataType:'json',
					success: function(response) {
						$('#news_list_right_subscribe_email').val('');
						if(response['error']){
							$('#news_list_right_subscribe_email').val(response['error']);
							$('#news_list_right_show_subscribe_send').removeClass('disabled');
							$('#news_list_right_subscribe_email').removeClass('noactive');
							$('#news_list_right_subscribe_email').addClass('error');
						}
						if(response['success']){

							var news_common_prefs_email_sent=$('#news_rubric_select #subscr_form .data .news_common_prefs_email_sent').val();
							var news_common_prefs_check_email=$('#news_rubric_select #subscr_form .data .news_common_prefs_check_email').val();
							$('#news_rubric_select #subscr_form .field').before('<div style="font-size:10px; margin-top:10px; position:absolute; color:#A6A6A6;">'+news_common_prefs_email_sent+'<br>'+news_common_prefs_check_email+'</div>');
							$('#news_rubric_select #subscr_form .field').css('visibility','hidden');
							$('#news_list_right_preferences_close_bot').show();
						}

					}
				});

			}
		else{
			$('#news_list_right_subscribe_email').removeClass('noactive');
			$('#news_list_right_subscribe_email').addClass('error');
			$('#news_list_right_show_subscribe_send').removeClass('disabled');
			}
	});


	if($('#about-company').length){
		//скрипты старницы компаний
		var abouttext=$('#company-about-text');
		abouttext.remove();
		$('#tab-about').prepend(abouttext);

		$('#comment_title').clearStartValue();
						$('#video .video-item').jQPager({
							onpage:3,
							afterSelectPage:function(){
								$('#video .video-item iframe').remove();
							}
						});
						$('#tab-library li').jQPager({
							onpage:10
						});

						$('#tab-video').hide();

						$('#video .video-item a').click(function(){
							var id=$(this).attr('href').replace('#','');
							$(this).before('<iframe width="240"  src="http://www.youtube.com/embed/'+id+'?feature=player_detailpage&rel=0&autoplay=1" frameborder="0" style="position:absolute; left:0; top:0;z-index:2" ></iframe>');
							return false;
						})

						$('#photo ul li').jQPager({
							onpage:10
						});
						$('#tab-photo').hide();


  						$('#bookmarks-tab .bookmark_info').hover(function(){
  							$(this).children('.del_note').show();
  						},function(){
  							$(this).children('.del_note').hide();
  						});

  						$('.bookmark_form .bookmark_title input').focus(function(){

  							$(this).closest('.bookmark_title').addClass('focus');
  						});
  						$('.bookmark_form .bookmark_title input').blur(function(){

  								$(this).closest('.bookmark_title').removeClass('focus');
  						});

  						$('#bookmarks-tab .bookmark_item .del_note').click(function(){

  							button=$(this);
  							$('.bookmark_form').slideUp(500);
  							$('.bookmark_del').slideUp(500);
  							$('.bookmark_item').removeClass('active');
  							$(button).closest('.bookmark_item').addClass('active');

  							$('#bookmarks-tab .bookmark_info').mouseover(function(){
  								$(this).children('.del_note').show();
  							});
  							$('#bookmarks-tab .bookmark_info').mouseout(function(){
  								$(this).children('.del_note').hide();
  							});

  							$(button).closest('.bookmark_item').children('.bookmark_del').slideDown(50);
  							$(button).closest('.bookmark_item').children('.bookmark_info').unbind('mouseover').unbind('mouseout');
  							$(button).hide();

  						});

  						$('#bookmarks-tab .bookmark_item .bookmark_item_time, #bookmarks-tab .bookmark_item .bookmark_item_title').click(function(){

  							button=$(this);

  							//$(button).closest('.bookmark_item').find('.bookmark_form')
  							if($(button).closest('.bookmark_item').find('.bookmark_form').is(':visible')){
  								$(button).closest('.bookmark_item').find('.bookmark_form').slideUp(500);
  							}
  							else{
  								$('.bookmark_form').slideUp(500);
  								$('.bookmark_del').slideUp(500);
  								$('.bookmark_item').removeClass('active');
  								$(button).closest('.bookmark_item').find('.bookmark_form').slideDown(500);

  								$('#bookmarks-tab .bookmark_info').mouseover(function(){
  									$(this).children('.del_note').show();
  								});
  								$('#bookmarks-tab .bookmark_info').mouseout(function(){
  									$(this).children('.del_note').hide();
  								});


  								note_id=$(button).closest('.bookmark_item').find('input[name=note_id]').val();

  								if($('#bookmark_form_note_'+note_id+' .category_selector select').val()=='new')
  									$('#bookmark_form_note_'+note_id+' .category_selector select').closest('.category_selector').children('.new_category_input').show();
  								else
  									$('#bookmark_form_note_'+note_id+' .category_selector select').closest('.category_selector').children('.new_category_input').hide();


  								$('#bookmark_form_note_'+note_id+' .category_selector select').unbind('change');
  								$('#bookmark_form_note_'+note_id+' .category_selector select').change(function(){
  									if($(this).val()=='new')
  										$(this).closest('.category_selector').children('.new_category_input').show();
  									else
  										$(this).closest('.category_selector').children('.new_category_input').hide();
  								});

  								$('#bookmark_form_note_'+note_id+' .send_button input').unbind('click');
  								$('#bookmark_form_note_'+note_id+' .send_button input').click(function(){
  									var error=false;
  									var title_tag=$(this).closest('.bookmark_item').find('.bookmark_item_title');
  									if($(this).closest('.bookmark_bot').find('.category_selector select').val()=='new'){
  										if(!$(this).closest('.bookmark_bot').find('.category_selector .new_category_input input').val())
  											{
  												$(this).closest('.bookmark_bot').find('.category_selector .new_category_input label.error').show();
  												error=true;
  											}
  										var category='new';
  										var category_name=$('#bookmark_form_note_'+note_id+' .category_selector .new_category_input input').val();
  									}else{
  										var category=$('#bookmark_form_note_'+note_id+' .category_selector select').val();
  									}

  									var comment=$('#bookmark_form_note_'+note_id+' .bookmark_desc textarea').val();
  									var title=$('#bookmark_form_note_'+note_id+' .bookmark_title input').val();
  									if(!title && !comment){
  										$(this).closest('.bookmark_form').find('.bookmark_desc label').hide();
  										$(this).closest('.bookmark_form').find('.bookmark_desc label.error').show();
  										error=true;
  									}

  									if(!error){
  										//$('#bookmark_form_'+note_id).children('form').submit();
  										//$('#bookmark_form_note_'+note_id).slideUp(500);
  										data={'title':title,'note_id':note_id,'comment':comment,'what':'changeNote','category':category};
  										if(category=='new')
  											data.category_name=category_name;

  										$.ajax({
  											   type: "POST",
  											   url: "/ajax_page.php",
  											   data: data,
  											   dataType: 'json',
  											   success: function(response){
  													if(response['status']=='change'){
  														$('#bookmark_form_note_'+note_id).slideUp(500);

  														if(data.title){
  															if(data.title.length<70)
  																title=data.title;
  															else
  																title=data.title.substr(0,70)+"...";
  															}
  														else
  															title=data.comment.substr(0,70)+"...";
  														$(title_tag).html(title);
  													}
  											   }
  										   });



  									}
  								});



  							}
  						});

						$('#bookmarks-tab .bookmark_item .bookmark_del .cancellink').click(function(){

  								$(this).closest('.bookmark_item').children('.bookmark_del').slideUp();
  								$(this).closest('.bookmark_item').removeClass('active');

  								$(this).closest('.bookmark_item').children('.bookmark_info').mouseover(function(){
  									$(this).children('.del_note').show();
  								});
  								$(this).closest('.bookmark_item').children('.bookmark_info').mouseout(function(){
  									$(this).children('.del_note').hide();
  								});


  								return false;
  						});



						  						$('#bookmarks-tab .bookmark_item .bookmark_del .dellink').click(function(){

  								var bookmark=$(this).closest('.bookmark_item');

  								$(bookmark).hide();
  								$(bookmark).children('.bookmark_del').hide();
  								$(bookmark).removeClass('active');

  								$(this).closest('.bookmark_item').children('.bookmark_info').mouseover(function(){
  									$(this).children('.del_note').show();
  								});
  								$(this).closest('.bookmark_item').children('.bookmark_info').mouseout(function(){
  									$(this).children('.del_note').hide();
  								});


  								data={'what':'delNote', 'note_id':$(this).closest('.bookmark_item').children('input[name=note_id]').val(), 'type':'company', 'document_id': $(this).closest('.bookmark_item').children('input[name=note_id]').val()};
  								$.ajax({
  								   type: "POST",
  								   url: "/ajax_page.php",
  								   data: data,
  								   dataType: 'json',
  								   success: function(response){
  												if(response['status']=='del'){
  													$(bookmark).remove();
  													var count=$('#bookmarks-tab').data('mynotes')+' ('+$('#bookmarks-tab .bookmark_item').length+')';

  													if($('li.add_note_menu').hasClass('active')){
  														$('li.add_note_menu').html(count);
  													}
  													else{
  														$('li.add_note_menu a').html(count);
  													}


  													if($('#bookmarks-tab .bookmark_item').length==0){

  														location.href=location.href.replace('bookmarks','');
  													}

  												}else
  													$(bookmark).show();
  								   },
  								   error:	function(response){
  									$(bookmark).show();
  								  }
  							   });



  								return false;
  						});



						if($('#activate_company_review_error').length)
							showMsg({
  												'text':'Ссылка для активации отзыва недействительна',
  												'time':300,
  												'hide':1000,
  												'shadow':0,
  												'bgcolor':'#fff7ca',
  												'boxshadow':1,
  												'fadein':'slipfromtop',
  												'close':0
  											});

						if($('#activate_company_review').length)
							showMsg({
  												'text':'Вы успешно активировали отзыв.',
  												'time':300,
  												'hide':1000,
  												'shadow':0,
  												'bgcolor':'#fff7ca',
  												'boxshadow':1,
  												'fadein':'slipfromtop',
  												'close':0
  											});



				var rubric_count= $('#tab-br-eq-equip .rubric_block').length;
									$('#tab-br-eq-equip .rubric_block').each(function(i,obj){
													$(obj).remove();
													if($('#tab-br-eq-equip .leftcol').height()<=$('#tab-br-eq-equip .rightcol').height())
														$('#tab-br-eq-equip .leftcol').append($(obj));
													else
														$('#tab-br-eq-equip .rightcol').append($(obj));
									})
									$('#tab-brands').hide();
									$('#tab-br-eq-equip').hide();

									$('.up-corner-buttons div').click(function(){
										if(!$(this).hasClass('active')){
											var activeli=$(this).closest('.up-corner-buttons').find('div.active');
											var id=$(activeli).attr('id').replace('tab-button-','');
											var newid=$(this).attr('id').replace('tab-button-','');
											$(activeli).removeClass('active');
											$(this).addClass('active');
											var container=$(this).parent().parent().find('.tabs-container');
											var h=$(container).height();
											$(container).height(h);
											$(container).find('#tab-'+id).fadeOut(300,function(){
												$(container).height('auto');
												$(container).find('#tab-'+newid).show();
												var newh=$(container).height();
												$(container).find('#tab-'+newid).hide();
												$(container).height(h);
												$(container).animate({height:newh},300,function(){
													$(container).find('#tab-'+newid).fadeIn(300);
												})

											})
										}
									})

									var addrh=$('#company-address').closest('.container').height();
									//var test=$('<div style="position:fixed; top:0; left:0;z-index:100000; padding:20px; background-color:#fff"></div>');
									//$('body').prepend(test);
									$('#show_review_button').click(function(){

										var activeli=$('#about-company .tabs li.active');
										var id=$(activeli).attr('id').replace('tab-button-','');
										var newid='review';
										var button=$('#tab-button-review');
										$(activeli).removeClass('active');
										$(button).addClass('active');
										var h=$('#company-content-tabs').height();
										$('#company-content-tabs').height(h);
										$('#company-address').fadeOut(300,function(){
											$('#company-address').closest('.container').animate({height:0})
										})
										$('#company-content-tabs').height('auto');
										var newh=$('#company-content-tabs').height();
										$('#company-content-tabs').height(h);
										$('#about-company #tab-'+id).fadeOut(300,function(){
												$('#about-company #tab-'+newid).show();
												var offset=$('#tab-review').offset();
												$('#about-company #tab-'+newid).hide();
												$('html, body').animate( {
														scrollTop: offset.top
													}, 300,function(){

														$('#company-content-tabs').animate({height:newh},300,function(){
															$('#about-company #company-content-tabs #tab-'+newid).fadeIn(300,function(){
																$('#company-content-tabs').height('auto');
															});

														});
													})
										})
										return false;
									})
									$('#about-company .tabs li').click(function(){
										if(!$(this).hasClass('active')){
											var activeli=$('#about-company .tabs li.active');
											var id=$(activeli).attr('id').replace('tab-button-','');
											var newid=$(this).attr('id').replace('tab-button-','');
											//console.log(id,	newid);
											if(newid=="video"){
												$('#about-company #tab-'+newid).find('.video-item iframe').remove();
											}
											$(activeli).removeClass('active');
											$(this).addClass('active');
											var h=$('#company-content-tabs').height();
											$('#company-content-tabs').height(h);
											if(id=='about'){
												$('#company-address').fadeOut(300,function(){
													$('#company-address').closest('.container').animate({height:0})
												})
											}
												//console.log('fade out '+id);

												$('#company-content-tabs').children('div').each(function(j,d){
															var id=$(d).attr('id');
															if(id)
																if(id.indexOf('tab-')==0){
																	if(id.replace('tab-','')!=newid && id.replace('tab-','')!=id)
																		$(d).stop().hide();
																}
														})


												$('#about-company #tab-'+id).stop().fadeOut(300,function(){


														//console.log('ready fade out '+id);
														$('#about-company #tab-'+newid).show();
														$('#company-content-tabs').height('auto');
														var newh=$('#company-content-tabs').height();
														$('#company-content-tabs').height(h);
														$('#about-company #company-content-tabs #tab-'+newid).hide();
														$('#company-content-tabs').animate({height:newh},300,function(){
															$('#about-company #company-content-tabs #tab-'+newid).fadeIn(300,function(){
																$('#company-content-tabs').height('auto');
															});

														});
														if(newid=='about'){
															//$('#company-address').animate({height:addrh},300,function(){
																//$('#company-address').height('auto');
																$('#company-address').closest('.container').animate({height:addrh},function(){
																	$('#company-address').fadeIn(300,function(){
																		$('#company-content-tabs').height('auto');
																	});
																})
																//});
														}


												})



										}
									})

									$('#about-company .icons .views .like').addLike({type:'company','id':$('#about-company').data('id')});

			          				$('#review_value_checker i').mouseenter(function(){
				          				var tmp_review=$(this).find('input').val();
			          					var top=13+13*(tmp_review-1)*2;
										$('#review_value_checker').css({
			          						'background-position':'0 -'+top+'px'
			          					})

										$('#review_value_desc span').finish();
										$('#review_value_desc span').hide();
										$('#review_value_desc span.val'+tmp_review).fadeIn(1000);

			          				});
			          				$('#review_value_checker').mouseleave(function(){
			          					var review=$('#review_value_checker #company_review_value').val();
			          					if(review > 0)
				          					var top=13+13*(review-1)*2;
										else var top=0;

			          					$('#review_value_checker').css({
			          						'background-position':'0 -'+top+'px'
			          					})

										$('#review_value_desc span').finish();
										$('#review_value_desc span').hide();
										$('#review_value_desc span.val0').fadeIn(1000);
			          				});
			          				$('#review_value_checker i').mouseleave(function(){
				          				var tmp_review=$(this).find('input').val();
										//$('#review_value_desc span.val'+tmp_review).hide();
									})

			          				$('#review_value_checker i').click(function(){
						          		$('#review_value_checker #company_review_value').val($(this).find('input').val());
			          				})

			          				$('.reviews').on('click','.buttons .sbmt',function(){
			          					var li=$(this).closest('li');
			          					if($(this).hasClass('disabled'))
			          					return false;
			          					var id=$(li).find('input[name=review_id]').val();
			          					if($(this).hasClass('pos'))
			          						var val=1;
			          					if($(this).hasClass('neg'))
			          						var val=-1;
			          					data={id:id,val:val,what:'rate_review'}

			          					$.ajax({
										url: '/ajax_page.php',
										type: 'post',
										data: data,
										dataType:'json',
										success:function(response){
												if(response.error){
													s='';
													for (var i in response.error)
														s+=response.error[i]+'<br>';
														showMsg({
														'text':s,
														'time':0
													});
												}
												if(response.success){
													var div =$(li).find('span.rating-pos-count').closest('div');
													$(div).fadeOut(500,function(){

													if(val==1){
														$(li).find('.buttons .sbmt.neg').removeClass('disabled');
														$(li).find('.buttons .sbmt.pos').addClass('disabled');
													}
													if(val==-1){
														$(li).find('.buttons .sbmt.neg').addClass('disabled');
														$(li).find('.buttons .sbmt.pos').removeClass('disabled');
													}

														$(li).find('span.rating-pos-count').html(response.rates.pos);
														$(li).find('span.rating-total-count').html(parseInt(response.rates.pos)+parseInt(response.rates.neg));
														$(div).fadeIn(500);
													});
												}



											}
										})
			          					return false;

			          				})

			          				$('#add_news_comment').click(function(){

										var button=$(this);
										if(!$(button).hasClass('runing')){
										$(button).addClass('runing');
										var data={};
										data.text=$('#comment_text').val();
										data.mail=$('#comment_mail').val();
										data.fio=$('#comment_fio').val();
										data.title=$('#comment_title').val();
										if($('#comment_form').find('input[name="start_add[title]"]').length)
											data.title='';
										data.id=$('#comment_form').find('input[name=company_id]').val();
										data.check=$('#check_symbols').val();
										data.what="add_company_review";
										data.review_value=$('#company_review_value').val();
										if($('.reviews ul li').eq(0).hasClass('empty'))
											data.offset=0;
										else
											data.offset=$('.reviews ul li').length;

													$.ajax({
													url: '/ajax_page.php',
													type: 'post',
													data: data,
													dataType:'json',
													success:function(response){

															$(button).removeClass('runing');

															if(response.success==1){
													var reviews=response.reviews;
														$('.reviews ul li.empty').remove();
														//if(!data.offset) $('.reviews').slideDown(500);
														for(var i in reviews){
																var append='<li>'+
																'<input type="hidden" name="review_id" value="'+reviews[i].id+'">'+
																'<div class="rating-value val'+reviews[i].review_value+'"></div>'+
																			(reviews[i].title ? '<div class="review-title">'+reviews[i].title+'</div>' : '')+
																			'<div class="review-text">'+reviews[i].text+'</div>'+
														                      '<div class="small overflow">'+
														                        '<div class="fright">'+reviews[i].rate_pos+' из '+(parseInt(reviews[i].rate_neg)+parseInt(reviews[i].rate_pos))+' пользователей считают этот отзыв объективным</div>'+
														                        '<div class="fleft">'+reviews[i].fio+' | <span class="rating-date">'+reviews[i].format_date+'</span></div>'+
														                     '</div>'+
														                      '<div class="review-rating">Отзыв объективен?'+
														                        '<div class="buttons">'+
														                          '<a class="sbmt pos" href="#">Да</a>'+
														                          '<a class="sbmt neg" href="#">Нет</a>'+
														                        '</div>'+
														                      '</div>'+
														                      '</li>';
																$('.reviews ul').append(append);
																var li=$('.reviews ul li:last');
																var h=$(li).height();
																var text=$(li).html();
																$(li).height(h);
																$(li).html('');
																$(li).hide();
																$(li).slideDown(500,function(){
																	$(li).html(text);
																	$(li).hide();
																	$(li).fadeIn(500,function(){
																		$(li).height('auto');
																	});
																});
															}
															for(var i in response.rating_struct){

																$('.structure-rating .bar'+i+' span').css({'width':response.rating_struct[i].percent+'%'});
																$('.structure-rating .count'+i).html(response.rating_struct[i].count);
															}
															$('.icons .rating span').html('('+response.rating_total+')');
															$('.icons .rating div').attr( "class", "val"+response.summary_rating )


															$('#comment_text').val('');
															$('#comment_title').val('');
															$('#company_review_value').val(0);
															$('#review_value_checker').css({'background-position':'0 0'})
															}else
																if(response.error){
															s='';
															for (var i in response.error)
																s+=response.error[i]+'<br>';
																showMsg({
																'text':s,
																'time':0
															});
														}

														}

													});
										}
									});



					var map;
					$(document).ready(function(){
						ymaps.ready(show_map);

					})




					var map;
					var points = new Array();
					var plmarks = new Array();

					function change_point(pnum) {
						//alert(pnum);
						map.panTo(plmarks[pnum].geometry.getCoordinates(), {
							duration:2000, callback: function () {
								//console.log(plmarks[pnum]);
								//map.setZoom(8, {duration:1000});
							}
						});
						setTimeout(function () {
						//console.log(plmarks[pnum]);
						plmarks[pnum].balloon.open();}, 1);
					}



					function show_map() {
						map = new ymaps.Map("yandex_map",{
							center: [55.76, 37.64],
							zoom: 10,
							controls: ['zoomControl', 'typeSelector',  'fullscreenControl','rulerControl']
						})
						var GeoCollection = new ymaps.GeoObjectCollection(null)
						var inum = 0;
						var placemark;
						$('#address ul li').each(function(i,li){

							var descr2=$(li).data('descr2');
							var city=$(li).data('city');
							var gps_x = $(li).data('coordx');
							var gps_y = $(li).data('coordy');
							var id=$(li).attr('id');

							if(gps_x && gps_y){

									var placemark = new ymaps.Placemark([gps_y,gps_x],
										{
											balloonContentHeader: "<b>"+city+'</b>',
											 balloonContentBody: descr2


										},{
											// Опции.
											// Необходимо указать данный тип макета.
											iconLayout: 'default#image',
											// Своё изображение иконки метки.
											iconImageHref: '/images/Pushpin1.png',
											// Размеры метки.
											iconImageSize: [32, 32],
											// Смещение левого верхнего угла иконки относительно
											// её "ножки" (точки привязки).
											iconImageOffset: [0, -32],
											 balloonPanelMaxMapArea: 0
										});
									plmarks[id]=placemark;
									GeoCollection.add(placemark);
									placemark.events.add('click', function (e) {
											//console.log(e,id)
											$('.addresses').removeClass('current_selected');
											$('#'+ id).addClass('current_selected');
											$('.'+ id).click();
										});
							}

						})
						map.geoObjects.add(GeoCollection);
						map.setBounds(GeoCollection.getBounds());
						map.geoObjects.add(GeoCollection);
						map.setBounds(GeoCollection.getBounds());

						var mapZoom=map.getZoom()
						var coords=map.getCenter();
						map.zoomRange.get(coords).then(function (range) {
							if(range[1] < mapZoom)
								map.setCenter(coords, range[1]);
						});


						//alert(zoomRange);
						//map.setZoom(18);
					}

						$('#address').mouseover(function(){
								$("#address .slider-opacity").hide();
							}).mouseout(function(){
								$("#address .slider-opacity").show();
							});

							$('.addresses').mouseover(function(){
								//console.log($(this).attr('id'));
								$(this).addClass('current_hover');
							}).mouseout(function(){
								$(this).removeClass('current_hover');
							}).click(function(){
								$('.addresses').removeClass('current_selected');
								$(this).addClass('current_selected');
								change_point($(this).attr('id'));
							});

					if($('#address-wrapper  #address li.addresses').length > 3 ){
						var btngoarr=[];
						for(var ii=0; ii<$('#address-wrapper  #address li.addresses').length; ii++)
							btngoarr.push("."+ii);

						$("#address").jCarouselLite({
											btnNext: "#company-address .next",
											btnPrev: "#company-address .prev",
											btnGo: btngoarr,
											visible: 3,
											scroll: 1,
											vertical: true,
											circular: false,
											speed: 700,
											mouseWheel: true,
											afterEnd: function(a){
												var index = $(a[0]).index();
												$("#nums").text((index+1)*1 +' - '+ (index+3)*1);
												$("#go_up").css('visibility', index > 0 ? 'visible' : 'hidden');
											}
										});
					}

	}


	/*Виджеты*/

	/* Виджет статьи */
	if($('#right_block_articles').length){
		$('#right_block_articles').cokTabulator({fixHeight:1,hideEmpty:1})
	}


	/*Виджет новости компаний*/
    /*
	if($('#right_block_companies_news_main').length){

		$('#right_block_companies_news_main	.right_block_companies_news_main_list li.preload').css({
			'display':'block'
		})

		$('#right_block_companies_news_main').hover(function(){
			$(this).children('.controls').stop().fadeIn(500)
		},function(){
			$(this).children('.controls').stop().fadeOut(500)
		})


		$('#right_block_companies_news_main .controls .prev').click(function(){
			var button=$(this);
			var ul=$('#right_block_companies_news_main	.right_block_companies_news_main_list').children('ul');
			if(!button.hasClass('disabled')){
					button.addClass('disabled');
					var m=parseInt(ul.css('margin-top'));
					var mnew=m+116;
					if(mnew>0) mnew=0;
					if(mnew==0)	button.addClass('disabled');
					ul.stop().animate({
						'margin-top': mnew+'px'
					},500,function(){
						button.removeClass('disabled');
					})
			}
		})

		$('#right_block_companies_news_main .controls .next').click(function(){
				var button=$(this);
				var ul=$('#right_block_companies_news_main	.right_block_companies_news_main_list').children('ul');

				if(!button.hasClass('disabled')){
					button.addClass('disabled');
					var offset=ul.children('li').length;
					var m=parseInt(ul.css('margin-top'));


					ul.stop().animate({
						'margin-top': (m-116)+'px'
					},500,function(){
						button.removeClass('disabled');
					});

					$('#right_block_companies_news_main .controls .prev').removeClass('disabled');
					$.ajax({
						'url':'/ajax/get-company-news',
						'type':'post',
						'dataType':'html',
						'data':{'offset':offset},
						'success':function(r){
							ul.append(r);
						}
					})
				}
		})
		$('#right_block_companies_news_main	.right_block_companies_news_main_list').children('ul').mousewheel(function (event, delta){

					if(delta<0)
						$('#right_block_companies_news_main .controls .next').click();
					if(delta>0)
						$('#right_block_companies_news_main .controls .prev').click();

				return false;
			})
	}
    */
	if($('#right_block_authors').length){
		$('#right_block_authors .renew-authors-widget').click(function(){
			var div=$('#right_block_authors .right_block_authors_list');
			div.height(div.height());
			div.width(div.width());
			var ul=div.children('ul');
			var hide=0;
			var ready=0;
			var updatehtml;

			ul.fadeOut(500,function(){
				hide=1;
				if(ready){
						ul.stop();
						ul.html(updatehtml);
						authors_getpreload();
						ul.fadeIn(500);
				}
			});

			$.ajax({
				url:'/ajax/renew-authors-widget',
				type:'get',
				dataType:'html',
				success:function(r){
					ready=1;
					if(hide){
						ul.stop();
						ul.html(r);
						authors_getpreload();
						ul.fadeIn(500);
					}else
						updatehtml=r;
				}
			})
			return false;
		})
	}

	/* виджет новое в библиоте */

	if($('#right_block_library_new').length){
		$('#right_block_library_new ul li').each(function(i,li){
			var li=$(li);
			var l=li.children('a.img');
			var r=li.children('p');
			var lh=l.height();
			var rh=r.height();
			var anons=r.children('a.anons');
			var ah=anons.height();
			var ahmin=3*parseInt(anons.css('line-height'));
			if(rh>lh && ah>ahmin){
				var s=anons.text().trim();
				do{
					s=s.replace(/\s+\S+$/,'');
					anons.text(s+'...')
					rh=r.height();
					ah=anons.height();
				}while(rh>lh && ah > ahmin)
			}
		})
	}

	/* виджет популярное в библиотеке */
	if($('#right_block_library_pop').length){
		$('#right_block_library_pop ul li').each(function(i,li){
			var li=$(li);
			var l=li.children('a.img');
			var r=li.children('p');
			var lh=l.height();
			var rh=r.height();
			var anons=r.children('a.anons');
			var ah=anons.height();
			var ahmin=3*parseInt(anons.css('line-height'));
			if(rh>lh && ah>ahmin){
				var s=anons.text().trim();
				do{
					s=s.replace(/\s+\S+$/,'');
					anons.text(s+'...')
					rh=r.height();
					ah=anons.height();
				}while(rh>lh && ah > ahmin)
			}
		})
	}



	$('#magazine-inner a.anonsonly').click(function(){
		var id=$(this).data('id');
		$.ajax({
			url: '/ajax_page.php',
			type: 'post',
			data: {'what':'get_article_anons','id':id},
			dataType:'html',
			success:function(response){
					showMsg({
						text:response,
						time:0,
						width:796
					})
				}
			});


		return false;
	})



	if(	 ( (['/advertisement','/subscribe','/where-to-buy','/service-centers','/advertisement/magazine-cok']).indexOf(window.location.pathname) > -1 ) || ( window.location.pathname=='/' && window.location.hash=='#adv') ){
		(function(d, w, m) {
			window.supportAPIMethod = m;
			var s = d.createElement('script');
			s.type ='text/javascript'; s.id = 'supportScript'; s.charset = 'utf-8';
			s.async = true;
			var id = '681f5eb0dd98f7daea8ac56a29586c19';
			s.src = '//lcab.talk-me.ru/support/support.js?h='+id;
			var sc = d.getElementsByTagName('script')[0];
			w[m] = w[m] || function() { (w[m].q = w[m].q || []).push(arguments); };
			if (sc) sc.parentNode.insertBefore(s, sc);
			else d.documentElement.firstChild.appendChild(s);
		})(document, window, 'TalkMe');
	}

});
function closeMsg(time,callback) {
	if($(".msg-wrapper").length){
		$(".msg-wrapper").animate({"opacity":0},time,function(){
			$(this).remove();
			if(callback) callback();
		});
	}else{
		if($(".msg-content").length){
			$(".msg-content").animate({"opacity":0},time,function(){
				$(this).remove();
				if(callback) callback();
			});
		}
	}
}
function showMsg(msg) {


	var defaults = {
		close	: 1,	/*показывать иконку-крестик, 1/0*/
		blurclose:1,	/*скрывать при потере фокуса ( при клике по тени)*/
		hide	: 500,	/*время плавного исчезновения, милисекунды*/
		shadow	: 1,	/*c фоном или без, 1/0*/
		time	: 500,	/*время показа, милисекунды, 0 - не скрывать*/
		title	: '',	/*заголовок, в одну строку*/
		text	: '',	/*текст, можно html, в одну строку*/
		bgcolor	: '',
		boxshadow: 0,
		width:		0,
		scroll:		0,
		template:'default'
	};
	var startScrollTop=$(window).scrollTop();

	var i;
	for (i in msg) {
		defaults[i] = msg[i];
	}
	if(defaults['template']=='comix-top'){
		defaults['close']=false;
		defaults['blurclose']=false;
		defaults['shadow']=false;
		defaults['boxshadow']=true;
	}





	var msgcontent=$('<div class="msg-content"></div>').css({'z-index':501});
	if(defaults['title'].length > 0) {
		var msgtitle=$('<div class="msg-title"></div>');
		$(msgcontent).append(msgtitle);
		$(msgtitle).html(defaults['title']);
	}
	else
		$(msgcontent).addClass('notitle');

	var msgtext=$('<div class="msg-text"></div>');
	$(msgcontent).append(msgtext);
	$(msgtext).html(defaults['text']);

	if(defaults['template']=='comix-top'){
		var corner=$('<div>').css({
			width:'30px',
			height:'17px',
			position:'absolute',
			marginTop:'-17px',
			marginLeft:'30px',
			background: 'url(/images/startpage_instr_arrow.png) left top no-repeat'
		})
		$(msgcontent).prepend(corner).css({
			border:'solid 1px #EDEDED'
		});
		$(msgcontent).css({
			margin:0,
			left:'10px',
			position:'absolute',
			top: ($('.top-fixed').height()+11)+'px'
		})
	}
	if(defaults['width'])
		$(msgcontent).css({
			'width': defaults['width']
		})
	if(defaults['bgcolor'].length>0) $(msgcontent).css({
		'background-color': defaults['bgcolor']
	});
	if(defaults['boxshadow'])
		$(msgcontent).css({
			'-moz-box-shadow':'0 0 30px #bbb',
			'-webkit-box-shadow':'0 0 30px #bbb',
			'-khtml-box-shadow':'0 0 30px #bbb',
			'box-shadow':'0 0 30px #bbb',
		})

	if(defaults['template']=='bottom-fixed'){
		$(msgcontent).css({
			position:'fixed',
			width:'100%',
			bottom:0,
			left:0,
			'border-radius': 0,
			'box-shadow':'0 0 30px #bbb'
		})
	}




	var closeButton=$('<div class="msg-close" onclick="closeMsg(500)" >×</div>');

    if (defaults['close'] == 1) $(msgcontent).append(closeButton);



	if(defaults['shadow']){

		var fCloseMsg=function(time){
				$(msgwrapper).animate({"opacity":0},time,function(){$(this).remove()});
				$(msgcontent).animate({"opacity":0},time,function(){$(this).remove()});
		}

		var msgwrapper=$('<div class="msg-wrapper"></div>');
		if (!defaults['shadow'])	$(msgwrapper).addClass('noshadow');
		$(msgwrapper).click(function(e){

			if(!defaults['blurclose'])
				return false;
			if(e.target.tagName!='A'){
				if($(msgcontent).find($(e.target)).length || $(e.target).is(msgcontent) ){
					return false;
				}
				fCloseMsg(500)
			}

		});

		if(defaults['scroll']){
			$("body").append(msgwrapper);
			$("body").append(msgcontent);
			$(msgcontent).css({
				'top':$(window).scrollTop(),
				'z-index':10001,
				'position':'absolute',
				'left':'50%',
				'margin-left':-$(msgcontent).width()/2+'px'
			})
			$(closeButton).click(function(e){
				$(msgcontent).animate({"opacity":0},500,function(){$(this).remove()});
			})
		}
		else{
			$(msgwrapper).append(msgcontent);
			$("body").append(msgwrapper);
		}
	}
	else{

			if(defaults['template']=='comix-top'){
				$('.top-fixed .top-wrapper').append(msgcontent);
			}else{
				$("body").append(msgcontent);
			}
			var fCloseMsg=function(time){
					$(msgcontent).animate({"opacity":0},time,function(){$(this).remove()});
			}
			var fCloseMsgContent=function(e){
			//alert(e);
				if($(e.target).is(closeButton))
					fCloseMsg(500);

				if($(msgcontent).find($(e.target)).length || $(e.target).is(msgcontent))
					return false;
				else
					fCloseMsg(500);
			}
			$('body').unbind('click', fCloseMsgContent);
			$('body').on('click', fCloseMsgContent);

			if(defaults['template']=='default'){
				$(msgcontent).css({
					'position':'absolute',
					'left':'50%',
					'margin-left':'-250px',
					'margin-top':'100px',
					'top':$(window).scrollTop()
				})
			}
		}
	if(defaults['fadein']){

		if(defaults['fadein']=='slipfromtop'){
			var h=$(msgcontent).height();

			if(defaults['title'].length > 0)
			var tmp=msgtitle;
			else
			var tmp=msgtext;

			if(defaults['template']=='default'){
				$(msgcontent).css({
					'position':'fixed',
					'left':'50%',
					'margin-left':'-250px',
					'margin-top':'-'+h+'px',
					'top':$('#top').height()+'px'
				})
			}
				//return false;

			$(msgcontent).animate({
				'margin-top':0
			},750,function(){
				if (defaults['time'] > 0) {
					setTimeout(
						function(){$(msgcontent).animate({"opacity":0},750,function(){$(this).remove()})},
						2000
					);
				}
			})
		}

	}
	else

		if (defaults['time'] > 0) {
			setTimeout(
				function(){$(".msg-wrapper").animate({"opacity":0},defaults['time'],function(){$(this).remove()})},
				defaults['hide']
			);
		}

	/*
	$(window).scroll(function(e){

		var bot_dif=$(window).height()-($(msgcontent).height()+$(msgcontent).offset().top);
		var top_dif=$(msgcontent).offset().top;
		console.log(e,bot_dif,top_dif, $(document).height(), $(msgcontent).height(), $(msgcontent).offset().top);

		if(top_dif < 0){

		}
		if(bot_dif < 0){

			var scrolldif=startScrollTop-$(window).scrollTop();
			console.log(scrolldif);
			$(msgcontent).css({
				'margin-top': 100+scrolldif+'px'
			})
		}
		if(top_dif > 0 && bot_dif > 0 && bot_dif!=top_dif){

		}
	})
	*/

}

jQuery.fn.extend({


	YearsMenu:function(method){

		if(method==undefined){

			$(this).each(function(i,el){
				//console.log($(el));
				var obj={};
				el=$(el);
				obj.el=el;
				el.addClass('scrollingMenu');

				var ul=el.children('ul');
				obj.ul=ul;
				obj.lis=ul.find('li');
				obj.ul.wrap($('<div></div>'));
				obj.container=$(obj.ul).parent();
				obj.scroll=false;


				obj.calcUlWidth= function(){
					var w=0;
					obj.lis.each(function(i,li){
						w+=$(this).width()+parseInt($(this).css('padding-left'))+parseInt($(this).css('margin-left'))+parseInt($(this).css('padding-right'))+parseInt($(this).css('margin-right'));
					})
					obj.w=w;
					return w;
				}
				obj.calcUlWidth();

				obj.shadowR=$('<div>');
				obj.container.append(obj.shadowR);
				obj.shadowL=$('<div>');
				obj.container.append(obj.shadowL);
				obj.shadowR.css({
					'position':'absolute',
					'right': '-15px',
					'width': '15px',
					'height':'100%',
					'top':'0',
					'display':'none',
					'background': 'rgb(255,255,255)',
					'background': 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)'
				});
				obj.shadowL.css({
					'position':'absolute',
					'left': '-15px',
					'width': '15px',
					'height':'100%',
					'top':'0',
					'display':'none',
					'background': 'rgb(255,255,255)',
					'background': 'linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)'
				})


				obj.shadowShow=function(){
					obj.shadowR.show();
					obj.shadowL.show();
				}
				obj.shadowHide=function(){
					obj.shadowR.hide();
					obj.shadowL.hide();
				}


				obj.changeScroll=function(){

					//console.log(obj.w, obj.cW, obj.winW, obj.ul);

					obj.scroll=(obj.w > obj.cW && obj.winW <=767) ? true : false;
					//console.log('scroll: '+obj.scroll);
					if(obj.scroll){
						obj.container.height(obj.lis.height()).css({'position':'relative'});
						obj.ul.addClass('is_Scrolling');
						obj.shadowShow();

						var diff = obj.ul.find('li.active').offset().left - obj.initLeft;
						if(diff){
							var maxDiff=obj.w-obj.cW;
							diff=Math.min(diff,maxDiff);
							obj.ul.css('margin-left', -diff + 'px');

						}

					}else{
						obj.ul.removeClass('is_Scrolling');
						obj.container.css({'height':'auto'});
						obj.shadowHide();
						obj.ul.css('margin-left', 0);
					}
				}
				obj.changeScroll();



				obj.ul.css('opacity',0);

				var init=function(){
					//console.log('init');
					obj.winW=$(window).width();
					obj.calcUlWidth();
					obj.ul.animate({'opacity':1},500);
					obj.initLeft=obj.ul.offset().left;

					obj.changeScroll();


				}

						obj.el.get(0).addEventListener('touchmove', function(event) {

							if(obj.scroll){
								//console.log('touchmove');
										// Если 1 палец внутри элемента
										if (event.targetTouches.length == 1) {
											var touch = event.targetTouches[0];
											// Place element where the finger is
											var dif=touch.pageX-obj.starttouch;
											var newpos= obj.startpos+dif;
											newpos= newpos < 0 ? (newpos < (obj.cW-obj.w) ? (obj.cW-obj.w) : newpos) : 0;
											//$('#menu').after("<div>"+newpos+": "+w+", newpos <(-w)"+(newpos<(-w))+"</div>")
											obj.ul.css('margin-left', newpos + 'px');
											//obj.style.top = touch.pageY + 'px';
										}
								}
							}, false);


						obj.el.get(0).addEventListener('touchstart', function(event) {
							if(obj.scroll){
								obj.cW=$(obj.container).width();
								//console.log('touchmove',obj.cW);

							  if (event.targetTouches.length == 1) {
								var touch = event.targetTouches[0];
								// Place element where the finger is
								obj.starttouch = touch.pageX;
								obj.startpos=obj.ul.css('margin-left') ? parseInt(obj.ul.css('margin-left')) : 0;
							  }
							}
						}, false);


				var initTimer=setInterval(function(){
					obj.cW=$(obj.container).width();
					if(obj.cW <= $(window).width()){
						clearInterval(initTimer);
						init();
					}
				},10)
				/*
				setTimeout(function(){
					obj.scroll=obj.w > obj.el.width() ? true : false
					console.log(obj.el.width());
					if(obj.scroll){
						console.log(obj.ul.find('li.active').offset().left)
					}
				},500)
					*/


				$(window).resize(function(){
					obj.calcUlWidth();
					obj.winW=$(window).width();
					obj.cW=$(obj.container).width();
					obj.changeScroll();
				})





				el.data('YearsMenu',obj);

			})

		}

		if(method=='get'){
			$(this).each(function(i,el){
				return $(el).data('YearsMenu');
			})
		}

	},

	VakAnons:function(){

		var o=$(this);
		if(!$(this).length) return false;
		$(this).find('.vak-anons-text').hide();

		$(this).find('.show-vak-anons').click(function(){
			o.toggleClass('opened');
			if(o.hasClass('opened'))
				o.find('.vak-anons-text').slideDown(1000);
			else
				o.find('.vak-anons-text').slideUp(500);
			return false;
		})
	},

	articleLabelsShort: function(params){
		var params= params ? params : [];

		if(! $(this).length) return;
		var el=$(this);
		$(el).addClass('cok-widget-tags-row');

		var o={
			el: el
		}




		$(el).each(function(i,u){

			var Lis=$(u).children('li');
			var fLi=Lis.eq(0);

			if( $(u).height() > $(fLi).height()+parseInt($(fLi).css('marginBottom'))+parseInt($(fLi).css('marginTop')) ){
				var button=$('<li>').html('Еще').attr('data-show-more',true);
				$(u).append(button);
				for(var j=Lis.length-1; j>0;j--){
					Lis.eq(j).addClass('to-show-more');
					if( $(u).height() <= $(fLi).height()+parseInt($(fLi).css('marginBottom'))+parseInt($(fLi).css('marginTop')) )
						break;
				}
				button.click(function(){
					$(u).toggleClass('opened');
					if($(u).hasClass('opened'))
						button.text('Свернуть');
					else
						button.text('Еще');
				})
				$(u).find('.to-show-more').css({
					'-webkit-transition':'all .3s ease',
					'-moz-transition':'all .3s ease',
					'-o-transition':'all .3s ease',
					'transition':'all .3s ease'
				})
			}

		});




	},


	ajaxNewsPager: function(params){
		if(! $(this).length) return;
		var el=$(this);

		params.target=params.target ? params.target :'#news-inner';

		var o={
			el: el,
			baseUrl:  el.data('base-url'),
			tags: el.find('.tags a'),
			params: params,
			content: el.parent().find(params.target),
			clearButton: el.find('[data-clear-all]'),
			queue:0
			//pages: el.closest('.eightcol').find('.pages a[href]')
		};


		o.tagsLoseFocus=function(e){

			if($(e.target).closest('[data-news-tags-menu]').length){
				return true;
			}
			if($(e.target).is('[data-news-tags-menu]')){
				return true;
			}

			var opened=el.find('.news-inner-tags-container .tags.opened');
			opened.removeClass('opened');
			if(opened.find('a.active').length==0){

				if(el.find('.tags a.active').length){
					var tags=el.find('.tags a.active').eq(0).closest('.tags');
					var type=tags.data('tags-type');
					el.find('.news-tags-menu-types [data-switch-tags-type]').val(type).trigger('change');
					el.find('.news-inner-tags-container .tags.opened').removeClass('opened')
				}
			}


			$(document).off('click', o.tagsLoseFocus);

			return true;
		}

		el.find('[data-clear-all]').click(function(){
			o.el.find('.news-tags-menu-types [data-switch-tags-type]').val('').trigger('change');
			o.el.find('.news-tags-menu-types [data-switch-year]').val('').trigger('change');
			o.tags.removeClass('active');
			o.update();
			return false;
		})



		el.find('.news-tags-menu-types [data-switch-tags-type]').change(function(){
			var type=$(this).val();
			el.find('.news-inner-tags-container .tags').hide().removeClass('opened');
			if(type){
				el.find('.news-inner-tags-container .tags[data-tags-type-'+type+']').slideDown().addClass('opened');

				$(document).on('click', o.tagsLoseFocus);
			}else{
				$(document).off('click', o.tagsLoseFocus);
			}


		}).select2({
			minimumResultsForSearch:100
		}).on('select2:closing',function(e){
			var type=$(e.target).val();
			if(type){
				var c=el.find('.news-inner-tags-container .tags[data-tags-type-'+type+']');
				!c.hasClass('opened') ? c.addClass('opened') : void(0);

				$(document).on('click', o.tagsLoseFocus);
			}
		})










		o.tags.click(function(){
			$(this).toggleClass('active');
			var c=$(this).closest('.tags');

			if($(this).is('[data-select-all]')){
				if($(this).hasClass('active'))
					c.find('a').addClass('active');
				else
					c.find('a').removeClass('active');
			}else{
				if(c.find('a.active[data-id]').length==c.find('a[data-id]').length)
					c.find('a[data-select-all]').addClass('active')
				else
					c.find('a[data-select-all]').removeClass('active')
			}

			var type=c.data('tags-type');
			el.find('.news-inner-tags-container .tags').each(function(i,t){
				if($(t).data('tags-type')!=type)
					 $(t).find('a.active').removeClass('active');
			})
			o.update();
			return false;
		})

		$(o.el).parent().on('click','.pages a[href]',function(){
			o.el.find('.pages a[href]').removeClass('active');
			$(this).addClass('active');
			o.update($(this).data('page'))
			return false;
		})


		o.parseUrl=function(){
			if(window.location.pathname != o.baseUrl ){
				var url=window.location.pathname.replace(o.baseUrl+'/','');
				url.split('/').forEach(function(i){
					var type	=	i.substr(0,i.indexOf('-'));
					var val		=	i.substr(1+i.indexOf('-'));

					if(type && val){
						if(o.clearButton.css('display')=='none')
							o.clearButton.show();

						if(type!='year'){
							//$(o.el).find('[data-switch-tags-type]').val(type).trigger('change');
							//$(document).off('click', o.tagsLoseFocus);
							el.find('.news-inner-tags-container .tags[data-tags-type-'+type+']').show();

							$(o.el).find('.news-inner-tags-container .tags.opened').removeClass('opened')
							$(o.el).find('.news-inner-tags-container .tags[data-tags-type='+type+']').find('a[data-url='+i+']').addClass('active');
						}else{
							$(o.el).find('[data-switch-year]').val(val).trigger('change');
						}
					}
				})
				return false;
			}else{
				var params={filters:{}};
				var str=window.location.hash.replace('#','');
				if(str){
					var ar=str.split('&')
					ar.forEach(function(a){
						var s1=a.split('=');
						var name=s1[0];

						if(name=='page')
								params[name]=s1[1];
						else{
							var vals=s1[1].split('-');
							params.filters[name]=vals;
						}
					})
				}

				return(params);
			}
		}
		o.load=function(data,scroll){
			scroll = ( scroll != undefined ) ? scroll : true;
			o.queue++;

			$.ajax({
					url:o.baseUrl,
					data: data,
					type: 'post',
					dataType: 'json',
					success:function(r){
						o.queue--;
						var pages=$(o.el).parent().find('.pages');
						var nNews=$(r.news);

						if(!o.queue){
							pages.fadeOut(300);

							$(o.el).parent().find(o.params.target).fadeOut(300,function(){
									pages.stop().hide().replaceWith(r.pager).fadeIn(300);
									$(o.el).parent().find(o.params.target).replaceWith(nNews).fadeIn(300);
									$('h1').html(r.meta.h1);

									if(scroll){
										var stickedMenu=$('#content').closest('#wrapper').find('#menu');
										if( stickedMenu.length && ( stickedMenu.css('position')=='fixed' ) ){
											offset = stickedMenu.height();
										}else{
											offset = $('.top-fixed').height();
										}

										$('html,body').animate({scrollTop:$('#content').offset().top - offset},500);
									}
									$('title').text(r.meta.title);
									if(r.meta.metadesc) $('meta[name=description]').attr('content',r.meta.metadesc);
									if(r.meta.metakey) 	$('meta[name=keywords]').attr('content',r.meta.metakey);

									LoadBanners(nNews);
							})
						}
					}
			})
		}

		if( params=o.parseUrl() && params.filters && params.filters.length){
			for(var j in params.filters){
				if(o.clearButton.css('display')=='none')
					o.clearButton.show();

				if(params.filters[j] instanceof Array){

						if(j!='year'){
							$(o.el).find('[data-switch-tags-type]').val(j).trigger('change');
							$(document).off('click', o.tagsLoseFocus);
						}
						$(o.el).find('.news-inner-tags-container .tags.opened').removeClass('opened')
						params.filters[j].forEach(function(v){
							if(j!='year'){
								$(o.el).find('.news-inner-tags-container .tags[data-tags-type='+j+']').find('a[data-id='+v+']').addClass('active');
							}else{
								$(o.el).find('[data-switch-year]').val(v).trigger('change');
							}
						})

				}
			}

			o.load(params,false);
		}

		o.update=function(page){

			page= page && page>1 ? page : 0;

			var activeTags=o.el.find('a.active[data-id]');
			/*if(activeTags.length<2){

				window.history.pushState(

						{section: activeTags.length ? activeTags.eq(0).data('id') : null, page : page },
						window.title,
						activeTags.length ? activeTags.eq(0).attr('href')+(page==0 ? '' : '?page='+page) : o.baseUrl+(page==0 ? '' : '?&num='+page)
				)
			}
			else{*/
				var tags={};
				var hash=false;

				o.el.find('.news-inner-tags-container .tags').each(function(i,tags){
					tags[$(tags).data('tags-type')]=[];
					if($(tags).find('a.active').length>1) hash=true;
				})

				var url=[];
				activeTags.each(function(i,a){
					var type=$(a).closest('.tags').data('tags-type');
					if(!tags[type])	tags[type]=[];
					tags[type].push($(a).data('id'));
				})

				var y;
				if(y=o.el.find('[data-switch-year]').val())
					tags['year']=[y];

				if(hash){
					for(var i in tags)
						url.push(i+'='+tags[i].join('-'));
				}else{
					activeTags.each(function(i,a){
						url.push($(a).data('url'));
					})
					if(y) url.push('year-'+y);
				}



				//console.log(url && clearButton.css('display')=='none', url, !url , clearButton.css('display'), clearButton.css('display')=='none');
				if(url.length && o.clearButton.css('display')=='none')
						o.clearButton.fadeIn(500);
				else{
					if(o.clearButton.css('display')=='block' && !url.length)
						o.clearButton.fadeOut(500);
				}


				window.history.pushState(
						{section: tags,page:page },
						window.title,
							hash ?
							o.baseUrl+'#'+url.join('&')+(page==0 ? '' : '&page='+page)	 :
							o.baseUrl+( url.length ? '/'+url.join('/') : '')+(page==0 ? '' : '/page-'+page)
							//o.baseUrl+'#rubrics='+tags.join('-')+(page==0 ? '' : '&page='+page)
				)
				o.load({filters:tags,page:page})
			//}

		}


		el.find('.news-tags-menu-types [data-switch-year]').change(function(){
			o.update();
			return false;
		}).select2({
			minimumResultsForSearch:100
		});
	},

	topRowDynamic: function(){
		var row=$(this);
		var topMenuOverHeight=300;
		var o={
				o 			: 	row,
				title		:	{
									o: $('#top > .wrapper .row #greyRowText'),
									initial: $('#top > .wrapper .row #greyRowText').html(),
									isInitial	: true
								},
				logoObj		:	{
									o: row.find('#greyRowLogo'),
									show: false,
									border : $('#logo').length ? ($('#logo').offset().top+$('#logo').height()) : 0
								},
				menuButton	:	{
									o: row.find('#menuButton'),
									show: false
								},
				showLogo	:	function(){
									o.logoObj.o.stop().fadeIn(1000);
									o.logoObj.show=true;
								},
				hideLogo	:	function(){
									o.logoObj.o.stop().hide();
									o.logoObj.show=false;
								},
				scrolling	:	function(){

									var s=$(window).scrollTop();
									//if(s>=o.logoObj.border && !o.logoObj.show)
									//	o.showLogo();
									//if(s<o.logoObj.border && o.logoObj.show)
									//	o.hideLogo();

									if(o.contextMenu.show){
										o.contextMenu.o.stop().animate({'top':-(o.contextMenu.o.height()+topMenuOverHeight)+'px'},function(){
											o.contextMenu.show=false;
										})
									}
								},
				setTitle	:	function(html){
									o.title.o.html(html);
									o.title.isInitial=false;
								},

				resetTitle	:	function(){
									o.title.o.html(o.title.initial);
									o.title.isInitial=true;
								},
				showMenuButton	:	function(html){
									o.menuButton.o.stop().fadeIn(1000);
								},
				hideMenuButton	:	function(html){
									o.menuButton.o.stop().hide();
								},
 				contextMenu: 	{
									o: $('#menu').clone().prependTo($('#wrapper'))
                                        .width($('#wrapper').width())
                                        .height($('#menu').height)
                                        .css({
											'position':'fixed',
											'padding':0,
											'top':-($('#menu').height()+topMenuOverHeight)+'px',
											'z-index':'999',
											'background': '#265a99 url(/images/menu.png) center top repeat'
										}),
									show: false
								}

		};
		o.contextMenu.o.find('.twelvecol').find('#submenuBg').css({
																												'left': 0,
																												'position':'absolute'
						 																					});
		o.contextMenu.o.find('.row').append(o.contextMenu.o.find('#submenuBg'));

		o.menuButton.o.click(function(){
			if(!o.contextMenu.show){
				o.contextMenu.o.stop().animate({'top':'33px'},function(){
					o.contextMenu.show=true;
				})
			}
		})

		$(window).scroll(o.scrolling)


		return o;
	},
	scrollingLogo:function(){
		var o={};
		o.greyRowLogo=false;
		o.maxScroll=$('#logo').offset().top+$('#logo').height();
		o.logoObj=null;

		$(window).scroll(function(){
			var s=$(window).scrollTop();
			//o.greyRowLogo=scrollingLogo.greyRowLogo;
			if(!o.greyRowLogo){
				if(s >= o.maxScroll){
					/*if(!o.logoObj){
							o.logoObj=$('<div>').attr('id','greyRowLogo').width('108px').height('26px').css({
							'background':'url(/images/logo_transparent.png) center center no-repeat',
							'background-size': '108px 26px',
							'float':'left',
							'margin':'3px 20px 0 0'
						}).prependTo($('#top .row .twelvecol'));
					}*/
					//o.logoObj.show();
					o.greyRowLogo=true;
				}
			}else{
				if(s<o.maxScroll){
					$('#top .row #greyRowLogo').hide();
					o.greyRowLogo=false;
				}
			}
			//console.log(o.greyRowLogo)
			//scrollingLogo.greyRowLogo=o.greyRowLogo;
		})
		return o;
	},
	livescroll:function(params){
		var params = params ? params : {};
		params.selector = params.selector ? params.selector : '#article';
		params.type = params.type ? params.type : 'articles';
		params.selectorh1 = params.selectorh1 ? params.selectorh1 :'#article #page_h1_string #page_h1 h1';



		var a=$(this);
		if(!$(this).length) return false;


		var c = {o:a.closest('#content')};
		var e = {o:a.closest('.eightcol')};
		var r = {o:a.closest('.row'),t:a.closest('.row'),p:'r', u:a.closest('.row').find(params.selector).data('url'),id:a.closest('.row').find(params.selector).data('id'), y:a.closest('.row').find(params.selector).data('year'),date:a.closest('.row').find(params.selector).data('date'), n:a.closest('.row').find(params.selector).data('num'), sidebar:1, t:a.closest('.row').find(params.selectorh1).text(), a: a.closest('.row').children('#sidebar').find('#article_authors')}
			r.o.css({'background-color':'#fff', 'z-index':'500','position':'relative'}).addClass('row-1');

		var sidebar = {o:r.o.children('#sidebar')}
			c.ot=c.o.offset().top;
			c.h=c.o.height();
		c.o.addClass('articles-scroller').css({'padding-bottom':'33px'});
		c.fixH=false;
		var shadow=$('<div>').css({'height':'200px','position':'relative','z-index':500, 'margin':'0 -20px 0 -20px','background':'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0))'});

		var o={
					a:a,
					status:{
								current:r,
								next:[],
								prev:[],
								pos:0,
								rows:[r]
							},
					shadow:{
								o:shadow,
								h:shadow.height()
							},
					toprow:{
						o:$('#top > .wrapper .row'),
						inner:$('#top > .wrapper .row').html(),
						at:$('<div>').css({'padding-left':'30px'}).html(''),
						maxFirstScroll:r.o.find('#page_h1 h1').offset().top+r.o.find('#page_h1 h1').height(),
						firstTitle:false
					},
					init:false,
					finish:false,
					//ya: null,

					changeTopRow: function(){

						//if(!o.ya){	o.ya=new Ya.Metrika({ id:22155755});}



						if(params.type=='articles'){
							$('title').html(o.status.rows[o.status.pos].t+'| Архив С.О.К. | '+o.status.rows[o.status.pos].y+' |№'+o.status.rows[o.status.pos].n);


							ym(22155755, "hit", o.status.rows[o.status.pos].u , {
								title: o.status.rows[o.status.pos].t+'| Архив С.О.К. | '+o.status.rows[o.status.pos].y+' |№'+o.status.rows[o.status.pos].n,
							});
								topRowDynamic.setTitle('СОК № '+o.status.rows[o.status.pos].n+' '+o.status.rows[o.status.pos].y+' '+o.status.rows[o.status.pos].t);

						}

						if(params.type=='news'){
							$('title').html(o.status.rows[o.status.pos].t+'| Новости рынка');


							ym(22155755, 'hit', o.status.rows[o.status.pos].u , {
								title: o.status.rows[o.status.pos].t+'| Новости рынка',
							});
								topRowDynamic.setTitle('Новости рынка | '+o.status.rows[o.status.pos].date+' | '+o.status.rows[o.status.pos].t);

						}


					},

			};


		$(window).scroll(function(){
			var s=$(window).scrollTop();
			if(topRowDynamic.title.isInitial){
				if(s>=o.toprow.maxFirstScroll){

							if(params.type=='articles'){
								topRowDynamic.setTitle('СОК № '+o.status.rows[o.status.pos].n+' '+o.status.rows[o.status.pos].y+' '+o.status.rows[o.status.pos].t);
							}
							if(params.type=='news'){
								topRowDynamic.setTitle('Новости рынка | '+o.status.rows[o.status.pos].date+' | '+o.status.rows[o.status.pos].t);
							}
							topRowDynamic.showMenuButton();
				}
			}else{
				if(s<o.toprow.maxFirstScroll){

							topRowDynamic.resetTitle();
							topRowDynamic.hideMenuButton();

				}
			}
		})



		o.status.rows[o.status.pos].o.after(shadow);


		o.loadNext=function(init){

			var id=$('#content .row ' + params.selector + ':last').data('id');
			//	console.log(id);


			var request={
				dataType:'json',
				success:function(res){

					if(res.finish)
						o.finish=1;

								if(res.next){
									for(var j in res.next){
										//console.log('next',j);
										var n	=e.o.clone();
										n.html(res.next[j]);



										var nr=$('<div>').addClass('row').css({
											'background-color':'#fff',
											'z-index': 500-(o.status.rows.length),
											'position':'relative',
											'top':(c.ot)+'px',
											'display':'none'

										});
										if($(window).width()<=1180){
											nr.css({
												'left':0,
												'padding':'0',
												'box-sizing':'border-box'
											})
										}

										nr.append(n);
										if(res.newissue){
                                            nr.prepend(res.newissue);
                                        }

                                        c.o.append(nr);


                                        c.ot=c.o.offset().top;
                                        c.h=c.o.height();
                                        c.o.height(c.h);

                                        if(!res.finish){
                                          var sh=shadow.clone().css({'margin-top':'33px'});
                                          nr.after(sh);
                                          sh.hide();
                                        }
                                        o.status.rows.push({o:nr,t:nr.offset().top,p:'f',u:nr.find(params.selector).data('url'),id:nr.find(params.selector).data('id'), n:nr.find(params.selector).data('num') , y:nr.find(params.selector).data('year'), date:nr.find(params.selector).data('date') ,sh: res.finish ? false : sh,sidebar:0, t:nr.find(params.selectorh1).text(), a:res.authors});

                                        nr.css({'position':'fixed'});


									}
								}


								if(!o.init)
									o.scrollInit();

				},
				error:function(){

				}
			};


			if(params.type=='news'){
				request.url='/market_news/next/'+id;
				request.type='GET';
			}
			if(params.type=='articles'){
					request.url='/ajax_page.php';
					request.data={};
					request.data.what='get_next_article';
					request.data.id=id;
					request.type='POST';
			}


			$.ajax(request);


		}

		o.loadNext();




		var wh=$(window).height();

			$(window).resize(function(){
				wh=$(window).height();
				c.ot=c.o.offset().top;
				c.h=c.o.height();
			})

		o.check=function(e){



				var s=$(window).scrollTop();
				var current=o.status.rows[o.status.pos];
				var next=o.status.rows[o.status.pos+1];
				var prev=o.status.rows[o.status.pos-1];

				if(next){

						if(current.sidebar){
							if(s > sidebar.o.offset().top + sidebar.o.height()){

								sidebar.o.find('#article_authors').remove();
								if(next.a) sidebar.o.prepend(next.a);

								next.o.append(sidebar.o);
								next.sidebar=1;
								current.sidebar=0;
							}
						}else{
							if(  s < current.o.offset().top+sidebar.o.height() ){

								sidebar.o.find('#article_authors').remove();
								if(current.a) sidebar.o.prepend(current.a);

								current.o.append(sidebar.o);
								next.sidebar=0;
								current.sidebar=1;
							}
						}
						if( s >= c.ot){

							if(!c.fixH){

									c.fixH=true;

									next.o.css({'position':'relative','top': window.pageState.floatingTopHeight+'px'}).show();
									c.o.height('auto');
									c.h=c.o.height();
									c.o.height(c.h);
									next.o.css({
										position:'fixed'
									});

							}
						}else{

							if(c.fixH){
									c.fixH=false;
									next.o.css({'position':'fixed','top': window.pageState.floatingTopHeight+'px'})
							}

						}
						if( s > current.o.offset().top + current.o.height()+o.shadow.h+33 ){
							if(!o.finish)
								o.loadNext();


							if(next.p=='f'){

								next.o.css({'position':'relative'});
								if(next.sh)	next.sh.show();
								c.o.height('auto');
								o.status.rows[o.status.pos+1].p='r';
								o.status.pos=o.status.pos+1;
								window.history.pushState(null, null, o.status.rows[o.status.pos].u);
								o.changeTopRow();
								c.fixH=false;
                show_up_btn_for_scroll();
							}

						}

						if( s < current.o.offset().top)
							next.o.css({top:window.pageState.floatingTopHeight+'px'});
				}

				if(prev){
					if( s < prev.o.offset().top + prev.o.height()+o.shadow.h +33 ){
						if(current.p=='r'){
								current.o.css({'position':'fixed'});
								if(current.sh)	current.sh.hide();
								o.status.rows[o.status.pos].p='f';
								o.status.pos=o.status.pos-1;
								o.changeTopRow();
								window.history.pushState(null, null, o.status.rows[o.status.pos].u);
							}

					}

				}

			}

		o.scrollInit=function(){
			o.check();
			$(window).scroll(o.check);

		}



	},

	rotateBanners:function(){



				var changeBanner=function(){
					time = timeouts[j] ? 1000*timeouts[j] : 5000;

					setTimeout(function(){
						items.eq(j).fadeOut(500,function(){
							j=(j+1)%l;
							items.eq(j).fadeIn(500,function(){
									changeBanner();
								});
						});
					},time)
				}


				var block=$(this);
				var items = block.children('.banner_rotator_item');
				var l=items.length
				var j=0;
				var max=0;
				if(l > 1){
					var h=0;
					var timeouts=[];
					for( var i=0; i<l; i++){
						var item=items.eq(i);
						timeouts[i]=item.data('duration');
						h=item.height();
						max= max >= h ? max : h;
						if(i)item.hide();
					}

					block.height(max);

					changeBanner();
				}
			},
	limitRow:function(count){

		if(!count) count=1;
		var h0=parseInt($(this).css('line-height'))*count;
		var h=parseInt($(this).height());

		var content=$(this).text();
		//console.log(h0,h,content);

			if(h>h0){

				var text=content.split(' ');
				while($(this).height()>h0)
				{
					text.pop();
					var newtext=text.join(' ')+'...';
					$(this).text(newtext);
				}

			}

	},
	tabulator:function(params){
			params=params ? params : {};
			params.speed=params.speed ? params.speed : 300;
			var active= params.active ? params.active : 0;


			var childs=$(this).children();
			if(childs.length < 2) return false;

			var buttonsDIV=$('<div>').addClass('ib-tabs').css({'margin-bottom':'20px'});
			var buttonsUL=$('<ul>');
			buttonsDIV.append(buttonsUL);

			var buttons=[];
			var activetab;
			var maxH;

			childs.each(function(i,ch){
				maxH= maxH > $(ch).height() ? maxH : $(ch).height();

				var button=$('<li>').html($(ch).data('title'));
				if($(ch).attr('id'))	button.data('id',$(ch).attr('id'));


				buttonsUL.append(button);
				if(i)
					$(ch).hide();
				else{
					$(button).addClass('active');
					activetab=$(ch);
				}
				if($(ch).data('href')){
					button.click(function(){
							window.open($(ch).data('href'));
					})
				}else
					button.click(function(){
					if($(this).hasClass('active'))	return false;

					$(activetab).stop().fadeOut(500,function(){
							activetab=$(ch);
							buttonsDIV.find('.active').removeClass('active');
							button.addClass('active');
							activetab.fadeIn(500)
					})

				})
			})
			childs.height(maxH);

			buttonsDIV.append(buttonsDIV);
			$(this).prepend(buttonsDIV);
			ParalaxSetParams();
	},

	tabulator_subscr:function(params){
			params=params ? params : {};
			params.speed=params.speed ? params.speed : 300;
			var active= params.active ? params.active : 0;
			var container=$(this);

			var childs=$(this).children();
			if(childs.length < 2) return false;

			var buttonsDIV=$('<div>').addClass('ib-tabs').css({'margin-bottom':'20px'});
			var buttonsUL=$('<ul>');
			buttonsDIV.append(buttonsUL);

			var buttons=[];
			var activetab;
			var maxH;

			container.height(container.height());

			childs.each(function(i,ch){
				maxH= maxH > $(ch).height() ? maxH : $(ch).height();

				var button=$('<li>').html($(ch).data('title'));
				if($(ch).attr('id'))	button.data('id',$(ch).attr('id'));

				//$(ch).css({'position':'absolute'});



				buttonsUL.append(button);
				if(i)
					$(ch).hide();
				else{
					//$(button).addClass('active');
					activetab=$(ch);
				}
				if($(ch).data('href')){
					button.click(function(){
							window.open($(ch).data('href'));
					})
				}else
					button.click(function(){
					if($(this).hasClass('active'))	return false;

					$(activetab).stop().fadeOut(500,function(){
							activetab=$(ch);
							buttonsDIV.find('.active').removeClass('active');
							button.addClass('active');
							activetab.fadeIn(500)
					})

				})
			})
			childs.height(maxH);

			buttonsDIV.append(buttonsDIV);
			$(this).prepend(buttonsDIV);
			ParalaxSetParams();
	},

	cokTabulator:function(params){
		params=params ? params : {};
		params.speed=params.speed ? params.speed : 300;
		var active= params.active ? params.active : 0;
		var buttons=$(this).find('.tabs-button');
		var tabs=$(this).find('.tabs-content');

		var maxH=0;
			$(tabs).each(function(i,tab){
				if(params.hideEmpty)
					if(!$(tab).html().trim().length)
						{

							$(buttons).eq(i).hide();
							if(i==active)
								active++;
						}

				maxH= maxH >= $(tab).height() ? maxH : $(tab).height();
			});
		var activetab=$(tabs).eq(active);
		var activebutton=$(buttons).eq(active);
		$(activebutton).addClass('active');

		$(buttons).each(function(i,button){
			$(button).data('id',i);
			$(button).addClass('cokTabulator');
		});


		if(params.fixHeight){
			var tabsContentContainer=$('<div></div>');
			$(tabsContentContainer).height(maxH);
			$(tabs).wrapAll(tabsContentContainer);
		}


		$(tabs).hide();
		$(activetab).show();
		//ParalaxSetParams();
		//$('title').html($('.eightcol').height())

		if(params.click)	params.click($(activebutton))

		$(buttons).click(function(){
			if(params.click)	params.click($(this))
			if(!$(this).hasClass('active')) {
				var id=$(this).data('id');
				$(activebutton).removeClass('active');
				$(buttons).eq(id).addClass('active');

				$(activetab).fadeOut(params.speed,function(){
					$(tabs).eq(id).fadeIn(params.speed);
					activetab=$(tabs).eq(id);
					activebutton=$(buttons).eq(id);
				});
			}
		});
	},

	addLike:function(params){
		var params = params ? params : {};
		var span=$(this);
		if(span.data('id') && !params.id)
			params.id=span.data('id');
		if(span.data('type') && !params.type)
			params.type=span.data('type');


		$(span).click(function(){
			if($(span).hasClass('disabled')) return false;
			var like=parseInt($(span).text().replace('(','').replace(')',''));
			$(span).addClass('disabled');
			$(span).html('<i class="fa fa-thumbs-o-up fa-lg top-bar-news__icon_pt" aria-hidden="true"></i>' + (like + 1));


			data={
				what:'add_like',
				type:params.type,
				id:params.id
			}
			$.ajax({
			url: '/ajax_page.php',
			type: 'post',
			data: data,
			dataType:'json',
			success:function(response){

					if(response.error){
						s='';
						for (var i in response.error)
							s+=response.error[i]+'<br>';
							showMsg({
							'text':s,
							'time':0
						});
					}
					if(response.return_last_likes){
						$(span).html(`<i class="fa fa-thumbs-o-up fa-lg top-bar-news__icon_pt" aria-hidden="true"></i> ${like}`);
					}
					if(response.success){
						$(span).html(`<i class="fa fa-thumbs-o-up fa-lg top-bar-news__icon_pt" aria-hidden="true"></i> ${response.success.like}`);
					}
				}
			});

		})
	},
	clearStartValue: function() {
					$(this).each(function() {
						var active=false;
						var actcolor=$(this).css('color');
						var discolor='#ddd';
						$(this).css('color',discolor);
						var startvalue=$(this).val();
						var startname='start_'+$(this).attr('name');
						$(this).closest('form').find('input[name="'+startname+'"]').remove();
						$(this).closest('form').prepend('<input type="hidden" name="'+startname+'" value="'+startvalue+'">');

						$(this).focus(function(){
							if(!active){
								$(this).val('');
								active=true;
								$(this).css('color',actcolor);
							}
						});

						$(this).blur(function(){
							if($(this).val()=='')	{
								active=false;
								$(this).css('color',discolor);
								$(this).val(startvalue);
								$(this).closest('form').prepend('<input type="hidden" name="'+startname+'" value="'+startvalue+'">');
							}else
								$(this).closest('form').find('input[name="'+startname+'"]').remove();
						});
					});
			  },
	cokvideophotogallery:function(params){
		var self={};
		self.init=false;
		self.galleries=[];
		self.element=this;
		params.showphoto=params.showphoto ? params.showphoto : "Смотреть фото";
		params.showvideo=params.showvideo ? params.showvideo : "Смотреть видео"
		self.params=params;

		self.galready=0;


		self.photogallery=new cokgallery(params.photo,'photo',params.options.photo)
		self.videogallery=new cokgallery(params.video,'video',params.options.video)


		var foto_on_img='/images/foto_normal'+(params.retina ? '_retina' : '')+'.png';
		var foto_off_img='/images/foto_light'+(params.retina ? '_retina' : '')+'.png';
		var video_on_img='/images/video_normal'+(params.retina ? '_retina' : '')+'.png';
		var video_off_img='/images/video_light'+(params.retina ? '_retina' : '')+'.png';

		self.clickTo=function(gal){

				if(self.photogallery.length && self.videogallery.length){
					var on=gal.gallery;

					if(gal.type=='video'){
						if(typeof setHistory !== "undefined")
						setHistory('video');
						var off=self.photogallery.gallery;
						var on_button=video_button;
						var off_button=photo_button
						var off_src=foto_off_img;
						var on_src=video_on_img;

						}
					if(gal.type=='photo'){
						if(typeof setHistory !== "undefined")
						setHistory('media');
						var off=self.videogallery.gallery;
						var on_button=photo_button;
						var off_button=video_button;
						var off_src=video_off_img;
						var on_src=foto_on_img;

						}
					$(off).fadeOut(300,function(){

							$(on_button).addClass('active');
							$(off_button).removeClass('active');
							if(gal.header){
								$(on_button).css({'background-image':'url('+on_src+')'})
								$(off_button).css({'background-image':'url('+off_src+')'})
							}
							else{
								$(on_button).find('img').attr('src',on_src);
								$(off_button).find('img').attr('src',off_src);
							}
							$(on).fadeIn(300);
							self.videogallery.reload();
					});
				}
			}


			self.setTo=function(gal){
				if(self.photogallery.length && self.videogallery.length){
					var on=gal.gallery;

					if(gal.type=='video'){
						var off=self.photogallery.gallery;
						var on_button=video_button;
						var off_button=photo_button
						var off_src=foto_off_img;
						var on_src=video_on_img;

						}
					if(gal.type=='photo'){
						var off=self.videogallery.gallery;
						var on_button=photo_button;
						var off_button=video_button;
						var off_src=video_off_img;
						var on_src=foto_on_img;

						}

					$(off).hide();
					$(on_button).addClass('active');
					(off_button).removeClass('active');
					if(gal.header){
						$(on_button).css({'background-image':'url('+on_src+')'})
						$(off_button).css({'background-image':'url('+off_src+')'})
					}
					else{
						$(on_button).find('img').attr('src',on_src);
						$(off_button).find('img').attr('src',off_src);
					}
					$(on).show(500);

					self.videogallery.reload();
				}
			}



		if(self.photogallery.length && self.videogallery.length) /* если и фото и видео добавляем элементы переключения*/
		{



		if(self.videogallery.header)
			var video_button=$('<span attr-hash="video" style="background-image:url('+video_off_img+')">'+self.videogallery.header+'</span>');
		else
			var video_button=$('<span attr-hash="video" ><img title="'+params.showvideo+'" src="'+video_off_img+'"></span>');

		if(self.photogallery.header)
			var photo_button=$('<span attr-hash="media" style="background-image:url('+foto_on_img+'); background-position: left 1px">'+self.photogallery.header+'</span>');
		else
			var photo_button=$('<span attr-hash="media" ><img title="'+params.showphoto+'" src="'+foto_on_img+'"></span>');





			var controls=$('<div id="report_gallery_selector"></div>');
			$(controls).append($(photo_button)).append($(video_button));
			$(this).prepend(controls);
			$(controls).width(self.photogallery.params.width-58);
			$(controls).css({'margin-left':-(self.photogallery.params.width-58)/2+'px'});
			$(photo_button).addClass('active');
			$(photo_button).find('img').attr('src',foto_on_img);

			if(params.start=='video')
					self.setTo(self.videogallery)
				else
					self.setTo(self.photogallery)

			$(photo_button).click(function(){
				if(!$(this).hasClass('active'))
				self.clickTo(self.photogallery);
			});

			$(video_button).click(function(){
				if(!$(this).hasClass('active'))
				self.clickTo(self.videogallery);
			});
		}

		return self;




		function cokgallery(elementId,type,params) {

			self.galready++;
			if(!params) params={};

			/*this.prototype=new test();*/
			this.params=params;
			this.id=elementId;
			this.type=type;
			this.galleryinit=false;
			this.gallery=$('#'+this.id);
			if(!params.next) params.next='Вперед';
			if(!params.prev) params.prev='Назад';

			var gallery_h2=$(this.gallery).find('h2');
			this.header=$(gallery_h2).text();
			$(gallery_h2).hide();

			if(!params.counter_title){
				params.counter_title='Фото';
				if(type=='video') params.counter_title='Видео';
			}
			if(!params.counter_of_title){
				params.counter_of_title='из';
			}

			if(!params.width) params.width=746;
			if(!params.height) params.height=500;
			if(!params.previewwidth) params.previewwidth=170;
			if(!params.previewheight) params.previewheight=114;
			if(!params.scroll) params.scroll=4;
			if(!params.visible) params.visible=4;
			var gallery=this;
			var container=$('#'+elementId);
			var ul=$(container).children('ul');
			var lis=$(ul).children('li');



			var preload=[];
			var max_visible=($(lis).length > params.visible) ? params.visible : $(lis).length;
			this.length=max_visible

			if(!this.length) {
				$(this.gallery).hide();

				if(self.galready==2){
					self.init=true;
					var height=Math.max($(self.galleries.photo).height(),$(self.galleries.video).height());
					$(self.element).height(height);
					if(self.params.afterReady)
						self.params.afterReady();
				}


				return false;
			}
			for(var ii=0;ii<max_visible; ii++){
				preload[ii]=$('<img src="" style="display:none">');
				$(container).prepend($(preload[ii]));
			}

			this.hide=function(){
				$(this.gallery).hide();
			}
			this.reload=function(){
				if(this.type=='video'){

					var player='<iframe width="'+params.width+'" height="'+params.height+'" src="//www.youtube.com/embed/'+$(lis).eq(active).attr('id')+'?feature=player_detailpage&rel=0&showinfo=0" frameborder="0" ></iframe>';
					$(bigimg).html(player);
				}
			}


			var toparrows=$('<div class="arrows ontop"></div>');
			$(ul).before(toparrows);
			$(toparrows).css({
				'margin-bottom':'15px'
			})
			var topnextbutton=$('<div class="a-next"><a href="#"><span></span></a></div>');
			$(toparrows).append(topnextbutton);
			var topprevbutton=$('<div class="a-prev"><a href="#"><span></span></a></div>');
			$(toparrows).append(topprevbutton);


			var botarrowscontainer=$('<div class="arrows dotted onbottom"></div>');
			$(botarrowscontainer).css({
				'position':'relative',
				'overflow':'visible'/*,
				'padding-bottom':'15px'*/
			})
			$(ul).after(botarrowscontainer);

			var botarrows=$('<div class="botarrowscontainer"></div>');
			$(botarrowscontainer).append(botarrows);



/*			var arrowswidth=20;*/
			var arrowswidth=0;

			var botnextbutton=$('<div class="a-next"><a href="#"><span>&gt;</span></a></div>');
/*			var botnextbutton=$('<div class="a-next"></div>');*/

			/*$(botnextbutton).css({

				'top':-params.previewheight-parseInt($(ul).css('margin-bottom'))+'px',
				'position':'absolute',
				'width':arrowswidth+'px',
				'height':params.previewheight+'px',
				'cursor':'pointer',
				'right':0
			})*/

			var botprevbutton=$('<div class="a-prev"><a href="#"><span>&lt;</span></a></div>');
/*			var botprevbutton=$('<div class="a-prev"></div>');*/
			$(botarrows).append(botprevbutton);
			$(botarrows).append(botnextbutton);


			if($(lis).length > max_visible){

			//var botfirstbutton=$('<div class="a-first"><a href="#"><span>&lt;&lt; 1-'+max_visible+'</span></a></div>');
			//var botlastbutton=$('<div class="a-last"><a href="#"><span>'+($(lis).length-max_visible+1)+'-'+$(lis).length+' &gt;&gt;</span></a></div>');
			var botfirstbutton=$('<div class="a-first"><a href="#"><span>&lt;&lt;</span></a></div>');
			var botlastbutton=$('<div class="a-last"><a href="#"><span>&gt;&gt;</span></a></div>');


			$(botarrows).prepend(botfirstbutton);
			$(botarrows).prepend(botlastbutton);

			}
/*			$(botprevbutton).css({
				'top':-params.previewheight-parseInt($(ul).css('margin-bottom'))+'px',
				'position':'absolute',
				'width':arrowswidth+'px',
				'height':params.previewheight+'px',
				'cursor':'pointer'
			})*/


			var bimimgdiv=$('<div class="big" style="width:'+params.width+'px; height:'+params.height+'px; overflow:hidden"></div>');
			$(ul).before(bimimgdiv);
			var bigimgdescr=$('<div>').css({
				'margin-bottom':'15px'
				});
			$(bimimgdiv).after(bigimgdescr)
			$(bigimgdescr).html('test');
			var bigimg=$('<img width="'+params.width+'" height="'+params.height+'" alt="" src="/images/pixel.gif" />');
			$(bigimg).css({
				'background-position':'center center',
				'background-size':'contain',
				'background-repeat':'no-repeat',
				'width': params.width+'px',
				'height': params.height+'px'

			})
			if(this.type=='video')
			var bigimg=$('<div style="width: '+params.width+'px; height: '+params.height+'px" ></div>');
			$(bimimgdiv).append(bigimg);

		/*
			if(this.type=='photo'){
						var div_calc_image_size=$('<div style="position:absolute; left:0; top:-10000px;"></div>');
						var img_calc_image_size=$('<img src="">');
						$('body').prepend(div_calc_image_size);
						$(div_calc_image_size).html(img_calc_image_size);

						$(img_calc_image_size).on('load',function(){
								var active_img_height=$(img_calc_image_size).height();
								var active_img_width=$(img_calc_image_size).width();

								var bgsize=DefineBgSize(active_img_width,active_img_height);

								$(bigimg).css({
									'-moz-background-size':bgsize,
									'-webkit-background-size':bgsize,
									'background-size':bgsize
								});
						})

			}*/

			$(ul).wrap('<div></div>');
			var scrollerdiv=$(ul).closest('div');

			$(scrollerdiv).css({
				'margin':'0 '+arrowswidth+'px 30px '+arrowswidth+'px',
				'overflow':'hidden'
			})
			var counter=$('<span>'+params.counter_title+' 1-'+max_visible+' '+params.counter_of_title+' '+$(lis).length+'</span>')
			$(botnextbutton).find('a').prepend(counter);


			var w=0;
			var imgs=$(lis).find('img');
			var imgspan=$('<span class="imgpreview"></span>');
			var previewBgSize='contain';
				if(this.type=='video')
				 previewBgSize='cover';
			$(imgspan).css({
				'display':'block',
				'overflow':'hidden',
				'background-repeat':'no-repeat',
				'background-position':'50% 50%',
				'-moz-background-size':previewBgSize,
				'-webkit-background-size':previewBgSize,
				'background-size':previewBgSize/*,
				'background-color':'rgba(244, 244, 244, 0.97)'*/

			}).height(params.previewheight).width(params.previewwidth);
			$(imgs).height(params.previewheight);
			var imgsheight=$(imgs).height();
			/*if(imgsheight > params.previewheight)
				$(imgs).css('margin-top',((params.previewheight-imgsheight)/2)+'px')
				*/

			$(imgs).wrap(imgspan);

		/*	$(imgs).each(function(i,img){
				alert(i);
			})*/

			$(lis).each(function(i,li){
				var a=$(li).children('a')
				var img=$(li).find('img');
				$(img).width(params.previewwidth);
				$(img).height(params.previewheight);
				$(li).width(params.previewwidth);
				/*$(li).height(params.previewheight);*/

				var src=$(img).attr('src');
				$(img).attr('src','/images/pixel.gif');
				$(img).closest('span').css('background-image','url('+src+')');
				$(img).attr('data-src',src);


				var alt=$(img).attr('alt');
				var attrheader=$(img).attr('data-header');
				var download=$(img).attr('data-download');

				var headerspan=$('<span  class="header"></span>');

				//var itemnumspan=$('<span style="float:left">'+params.counter_title+' '+(i+1)+'</span>');
				var itemnumspan=$('<span style="float:left">#'+(i+1)+'</span>');

				$(headerspan).append(itemnumspan)

				if(download){

					var imagedownloadspan=$('<span  class="imagedownload"><span class="image_format_size">'+attrheader+'</span>&nbsp;<i class="fa fa-cloud-download"></i></span>');
					$(headerspan).prepend(imagedownloadspan)
					$(imagedownloadspan).on('click',function(){

						$.ajax({
						   type: "POST",
						   url: "/ajax_page.php",
						   data: {what:'load_image',imageid:download},
						   dataType: 'json',
						   success: function(response){
							   if(response.error=='auth_required'){
								   showLogin();
							   }else{
								   if(response.path)
									   window.open(response.path);
							   }
						   }
					  	});
						return false;
					})
				}



				$(li).append(headerspan);
				if(alt)	{
					var descr_span=$('<span class="descr">'+alt+'</span>');
					$(li).append(descr_span);
					$(descr_span).limitRow(2);

				}
				//if(i)	$(li).prepend('<span class="cokgallery_preview_separator" style="height:'+params.previewheight+'px;"></span>');

				$(a).click(function(){
					if(!$(this).closest('li').hasClass('active'))
						setActive(i,1);
					else{
						if(i > 1 && i < ($(lis).length-3) )
							setActive(i+1,1);
					}
					return false;
				});
			})


			var padding=(params.width-arrowswidth*2-params.previewwidth*params.visible)/(params.visible-1)/2;
			var full_w=params.previewwidth+2*padding;
			$(lis).css('padding','0 '+padding+'px');
			//$(lis).find('.cokgallery_preview_separator').css('margin-left',-(padding+0.5)+'px');
			var full_ul_width=full_w*$(lis).length
			$(ul).width(full_ul_width);
			$(ul).css('marginLeft',-padding+'px');


			var current=0;
			var active=0;

			var DefineBgSize=function(w,h){

				var bgsize='auto auto';

				if(h < params.height && w < params.width)
					bgsize='auto auto';
				else
				{
					/*if(h > w)
						bgsize='contain';
					else{
						if(

							(h < params.height || w < params.width) || ( (w/h) > 1.2*(params.width/params.height ) )

						)
							bgsize='contain';
						else
						bgsize='cover';
					}*/
					bgsize='contain';
				}

				return bgsize;
			}

			var scrollTo=function(i){
				if(i > $(lis).length-max_visible) i=$(lis).length-max_visible;
				if(i<0)	i=0;
				if(i==current && gallery.galleryinit) return false;
				current=i;
				var m=-full_w*i-padding+'px';
				$(ul).animate({'marginLeft':m},500);
				$(lis).removeClass('current');
				for(kk=0;kk<max_visible;kk++)
					{
						if($(lis).eq(i+kk).length){
							$(lis).eq(i+kk).addClass('current');
							src=$(lis).eq(i+kk).children('a').attr('href');
							$(preload[kk]).attr('src',src);
						}
					}


				$(counter).html(params.counter_title+' '+(i+1)+'-'+(i+max_visible)+' '+params.counter_of_title+' '+$(lis).length);
			}
			var changeImage=function(imgsrc,previewimgsrc,imgdescr){
				var load=0; var fadeout=0;

				var image=new Image()
				image.src=imgsrc;
				image.onload=function(){
					load=1;
					if(fadeout){
						var bgsize=DefineBgSize(image.width,image.height);
						$(bigimg).css({
							'background-image':'url('+imgsrc+')',
							'-moz-background-size':bgsize,
							'-webkit-background-size':bgsize,
							'background-size':bgsize
							});
						$(bigimg).fadeIn(200);
					}

				}

				$(bigimg).fadeOut(200,function(){
					$(bigimgdescr).html(imgdescr);
					fadeout=1;
					if(load){
						var bgsize=DefineBgSize(image.width,image.height);
						$(bigimg).css({
							'background-image':'url('+imgsrc+')',
							'-moz-background-size':bgsize,
							'-webkit-background-size':bgsize,
							'background-size':bgsize
							});
						$(bigimg).fadeIn(200);
					}
				})

			}
			var setImage=function(imgsrc,previewimgsrc, imgdescr){
				$(bigimgdescr).html(imgdescr);
				var image=new Image()

//				image.src=previewimgsrc;
//				var bgsize=DefineBgSize(image.width,image.heigth);
				image.src=imgsrc;
				image.onload=function(){
					var bgsize=DefineBgSize(image.width,image.height);
					$(bigimg).css({
						'background-image':'url('+imgsrc+')',
						'-moz-background-size':bgsize,
						'-webkit-background-size':bgsize,
						'background-size':bgsize
						});
				}






				//$(img_calc_image_size).attr('src',imgsrc);


			}

			var setActive=function(i,activate){
				active=i;

				if(active > $(lis).length-2)
					$(bigimg).css({'cursor':'default'})
				else
					$(bigimg).css({'cursor':'pointer'})

				if(active > $(lis).length-1) active=$(lis).length-1;
				if(active<0)	active=0;

				var src=$(lis).eq(active).children('a').attr('href');

				var previewimg=$(lis).eq(active).find('img');
				var previewsrc=$(previewimg).data('src');
				var previewdescr=$(previewimg).attr('alt');


				var player='<iframe width="'+params.width+'" height="'+params.height+'" src="//www.youtube.com/embed/'+$(lis).eq(active).attr('id')+'?feature=player_detailpage&rel=0&showinfo=0'+(activate ? '&autoplay=1' :'')+'" frameborder="0" ></iframe>';

				$(lis).removeClass('active');
				$(lis).eq(active).addClass('active');
				var scroll=current;
				/*
				if(active<current) scroll=active;
				if(active > current+params.visible-1) scroll=active-params.visible+1;
				*/

				if(active<2)
					scroll=0;
				else
					if(active> $(lis).length - 2)
						scroll=$(lis).length - 2
					else
						scroll=active-2

				scrollTo(scroll);
				if(gallery.galleryinit){

					if(type=='photo'){

						changeImage(src,previewsrc,previewdescr);

					}
					if(type=='video')
						$(bigimg).fadeOut(200,function(){
						$(bigimg).html(player);
						$(bigimg).fadeIn(200);
						$(bigimgdescr).html(previewdescr);
					})
				}
				else{
					if(type=='photo'){
						setImage(src,previewsrc,previewdescr);
					}
					if(type=='video')
					$(bigimg).html(player);
					$(bigimgdescr).html(previewdescr);
					gallery.galleryinit=true;


					self.galleries[type]=gallery.gallery;
					$(gallery.gallery).width(params.width);

					if (self.galready==2){
						self.init=true;
						var height=Math.max($(self.galleries.photo).height(),$(self.galleries.video).height());
						$(self.element).height(height);
						if(self.params.afterReady)
							self.params.afterReady();
					}

				}
			}
			/*
			var scrollSpeed=2;


			$(botnextbutton).hover(function(){
				$(ul).stop();
				var max_right_move=params.width-full_ul_width+padding;
				var movedistance=Math.abs(max_right_move-parseInt($(ul).css('marginLeft')));
				$(ul).animate({'marginLeft':max_right_move},movedistance*10/scrollSpeed,'linear');
			},
			function(){
				$(ul).stop();
			})

			$(botprevbutton).hover(function(){
				$(ul).stop();
				var max_left_move=-padding;
				var movedistance=Math.abs(max_left_move-parseInt($(ul).css('marginLeft')));
				$(ul).animate({'marginLeft':max_left_move},movedistance*10/scrollSpeed,'linear');
			},
			function(){
				$(ul).stop();
			})
			*/


			$(botnextbutton).click(function(){
				tmpcur=current+params.scroll
				scrollTo(tmpcur);
				return false;
			});
			$(botprevbutton).click(function(){
				tmpcur=current-params.scroll;
				scrollTo(tmpcur);
				return false;
			});


			$(botfirstbutton).click(function(){
				scrollTo(0);
				return false;
			});
			$(botlastbutton).click(function(){
				scrollTo($(lis).length-max_visible+1);
				return false;
			});


			$(topnextbutton).click(function(){
				if(active > $(lis).length-2)
					return false;
				active++
				setActive(active);
				return false;
			});

			$(bigimg).click(function(){
				if(active > $(lis).length-2)
					return false;
				active++
				setActive(active);
				return false;
			})

			$(topprevbutton).click(function(){
				if(active < 1)
					return false;
				active--
				setActive(active);
				return false;
			});

			setActive(active);



		}

	},
	NewCommentsNoticeForm: function(params){
		var obj={};

		obj.params=params;
		var table=$('<table align="right"></table>');
		var tr=$('<tr></tr>');
		$(this).append(table);
		$(table).append(tr);

		obj.jqueryObj=this;
		obj.table=table;

		var td_msg=$('<td></td>');
		var td_check=$('<td></td>');
		$(tr).append(td_msg).append(td_check);
		$(td_msg).css('padding-right','10px');
		var input_checkbox=$('<input type="checkbox" '+(params.checked ? ' checked="checked" ' : '')+'id="alert_new_comments" style="display:none">');
		/*var label=$('<label style="cursor:pointer" for="alert_new_comments">'+params.label+'</label>');*/

		var link=$('<span id="news_comments_notice_div_click"></span>');
		var linktext=$('<span class="news_comments_notice_text"></span>');
		var linkicon=$('<span class="news_comments_notice_icon"></span>');

		obj.link=link;
		obj.linktext=linktext;
		obj.linkicon=linkicon;


		$(td_check).append(link);
		$(link).append(linktext).prepend(linkicon).append(input_checkbox);
		if(window.devicePixelRatio >1)
			$(linkicon).addClass('retina');
		$(link).hover(function(){
			$(this).addClass('hover');
		},function(){
			$(this).removeClass('hover');
		});


		function comment_off(){
			$(link).addClass('off');
			$(link).removeClass('on');
		}
		function comment_on(){
			$(link).removeClass('off');
			$(link).addClass('on');
		}

		obj.comment_on=function(){
			$(obj.link).removeClass('off');
			$(obj.link).addClass('on');
			var senddata={'what':'subscribe_new_comments', 'type':params.type, 'news_id':params.news_id, 'action':'on'};
			if(params.auth){

				$.ajax({
				   type: "POST",
				   url: "/ajax_page.php",
				   data: senddata,
				   dataType: 'json',
				   success: function(response){
						showMsg({
							'text':response.error ? response.error : response.text,
							'time':3000,
							'hide':1000,
							'shadow':0,
							'bgcolor':'#fff7ca',
							'boxshadow':1,
							'fadein':'slipfromtop',
							'close':0
						});

						$(obj.linktext).fadeOut(500,function(){
								$(obj.linktext).text(params.label_on);
								$(obj.link).removeClass('off');
								$(obj.link).addClass('on');
								$(obj.linktext).fadeIn(500);
						});
				   }
				 });
			}
		}

		if(params.checked){
			$(linktext).text(params.label_on);
			comment_on();

			}
		else{
			$(linktext).text(params.label_off);
			comment_off();
			}

		$(link).click(function(){
			if(!$(input_checkbox).prop('checked'))
				{
					$(input_checkbox).prop('checked',true);
				}
			else{
					$(input_checkbox).prop('checked',false);
			}
			$(input_checkbox).change();

		});

		var data={'what':'subscribe_new_comments', 'type':params.type, 'news_id':params.news_id};

		$(input_checkbox).change(function(){

			if($(this).prop('checked'))
				{
					data.action='on';
				}
			else{

				data.action='off';

			}

			if(params.auth){
				$.ajax({
				   type: "POST",
				   url: "/ajax_page.php",
				   data: data,
				   dataType: 'json',
				   success: function(response){
					/*
						var msgdiv=$('<div></div>');
						$(td_msg).html('');
						$(msgdiv).text(response.text);
						$(td_msg).append(msgdiv);
						setTimeout(function(){
						$(msgdiv).fadeOut(500, function(){
							$(msgdiv).remove();
						})},
						1000);*/
						showMsg({
							'text':response.error ? response.error : response.text,
							'time':3000,
							'hide':1000,
							'shadow':0,
							'bgcolor':'#fff7ca',
							'boxshadow':1,
							'fadein':'slipfromtop',
							'close':0
						});

						if(data.action=='on')
						$(linktext).fadeOut(500,function(){
								$(linktext).text(params.label_on);
								comment_on()
								$(linktext).fadeIn(500);
						});
						if(data.action=='off'){
							$(linktext).fadeOut(500,function(){
								$(linktext).text(params.label_off);
								comment_off()
								$(linktext).fadeIn(500);
							});
						}
				   }
				 });
			}
			else{
				if(data.action=='on'){
					var input_email=$('<input type="text" maxlength="255" size="50"  name="notice_email" value="'+params.email_start+'" class="comment_dis">');
					var button=$('<input type="button" class="sbmt" value="Сохранить" id="add_news_comment">');
					var form_email=$('<div id="notice_email_form"></div>');
					$(table).after(form_email);
					$(form_email).append(input_email);
					$(form_email).append(button);
					$(input_email).css({
						'height': '24px',
						'line-height': '24px',
						'margin-top': '7px',
						'margin-right': '10px',
						'padding': '0 10px',
						'width': '213px'
					});
					var w=$(form_email).height();
					$(input_email).hide();
					$(button).hide();
					$(form_email).animate({height:w},function(){
						$(button).fadeIn(500);
						$(input_email).fadeIn(500);
						$(form_email).animate({'margin-bottom':'30px'});
					});
					$(input_email).focus(function(){
						$(this).val('');
						$(this).unbind('focus');
					});
					$(button).click(function(){
						data.mail=$(input_email).val();
						$.ajax({
						   type: "POST",
						   url: "/ajax_page.php",
						   data: data,
						   dataType: 'json',
						   success: function(response){
						   /*
								var msgdiv=$('<div></div>');
								if(response.error) $(msgdiv).css('color','red');
								$(td_msg).html('');
								$(msgdiv).text(response.error ? response.error : response.text);
								$(td_msg).append(msgdiv);
								setTimeout(function(){
								$(msgdiv).fadeOut(500, function(){
									$(msgdiv).remove();
								})},
								1000);*/

								showMsg({
									'text':response.error ? response.error : response.text,
									'time':3000,
									'hide':1000,
									'shadow':0,
									'bgcolor':'#fff7ca',
									'boxshadow':1,
									'fadein':'slipfromtop',
									'close':0
								});
								if(!response.error)
								$(form_email).animate({height:0},function(){
									$(form_email).find('input').remove();
								});
						   }
						 });
					})
				}
				if(data.action=='off'){
					var form_email=$('#notice_email_form');
					var w=$(form_email).height();
					$(form_email).height(w);
					$(form_email).find('input').fadeOut(500,function(){
						$(form_email).animate({height:0},function(){
							$(form_email).find('input').remove();
						});
					});
				}
			}

		});
		return obj;
	},
	simpleScroll: function(params){

		params.start=params.start ? params.start : 0;

		var obj={};
		obj.htmlObj=$(this);
		obj.position=0;
		obj.RUN=false;

		obj.goToPos=function(){

			var ul=$(obj.htmlObj).find('ul');
			var lis=$(ul).find('li');

			if($(lis).length-obj.position)
				params.dynamicAddAfterNextClick();
			if(params.afterNextClick)
				params.afterNextClick(obj.position);
			if(params.afterPrevClick)
				params.afterPrevClick(obj.position);

			if(obj.position > ($(lis).length-col)) obj.position=$(lis).length-col;
			if(obj.position < 0) obj.position=0;

			if(!obj.position)
				$(params.btnPrev).addClass('disabled');
			else
				$(params.btnPrev).removeClass('disabled');



			var pos=$(ul).offset().top-$(lis).eq(obj.position).offset().top;
			$(ul).css({'margin-top':pos});
		}

		obj.setPos=function(){
			obj.RUN=true;
			var ul=$(obj.htmlObj).find('ul');
			var lis=$(ul).find('li');

			if($(lis).length-obj.position)
				params.dynamicAddAfterNextClick();
			if(params.afterNextClick)
				params.afterNextClick(obj.position);
			if(params.afterPrevClick)
				params.afterPrevClick(obj.position);
			if(obj.position > ($(lis).length-col)) obj.position=$(lis).length-col;
			if(obj.position < 0) obj.position=0;

			if(!obj.position)
				$(params.btnPrev).addClass('disabled');
			else
				$(params.btnPrev).removeClass('disabled');


			var pos=$(ul).offset().top-$(lis).eq(obj.position).offset().top;
			$(ul).animate({'margin-top':pos},500,function(){ obj.RUN=false});
		}
		obj.refresh=function(data){
			obj.position=0;
			obj.goToPos();
			if(data) params=data;
			var lastmousewheel=0;
			var ul=$(this.htmlObj).find('ul');
			var lis=$(ul).find('li');
			var lis_h=0; var lis_pb=0;

			if(params.itempadding || params.itempadding){
				if(params.itemheight)
				 lis_h=params.itemheight;
	 			if(params.itempadding)
	 			 lis_pb=params.itempadding;
			 }
			else{

				$(lis).each(function(){
					lis_h= lis_h >=  $(this).height() ? lis_h : $(this).height();
					var pb=parseInt($(this).css('padding-bottom'));
					lis_pb= lis_pb >= pb ? lis_pb : pb;
				})

			}
			//alert(lis_h);
			//alert(lis_pb);

			$(lis).height(lis_h);
			var ul_mt=parseInt($(ul).css('margin-top'));
			var scroller_h=params.visible*(lis_h+lis_pb)-lis_pb+ul_mt+1;

			//console.log(scroller_h, params.visible, lis_h, lis_pb,ul_mt);


			$(params.scroller).height(scroller_h);
			$(params.scroller).css({overflow:'hidden'});


            /*
			$(params.scroller).mousewheel(function (event, delta){
				clearInterval(obj.autoscroll);
				obj.autoscroll=null;
				if(!obj.RUN){
					if(delta<0){
						obj.position=parseInt(obj.position)+col;
						obj.setPos();
					}

					else{
						obj.position-=col;
						obj.setPos();
					}

				}
				return false;
			}) */

			/*var testdiv=$('<div id="test" style="position:absolute; z-index:100; padding:20px; background-color:#fff"></div>');*/
			/*$('body').prepend(testdiv)*/

			$(params.btnNext).unbind('click');
			$(params.btnPrev).unbind('click');

			/*прокрутка вниз*/
			$(params.btnNext).click(function(){
				clearInterval(obj.autoscroll);
						obj.autoscroll=null;
				if(!obj.RUN){
					obj.position=parseInt(obj.position)+col;
					obj.setPos();
				}
				/*
				if(!RUN){
					RUN=1;
				$(lis).height(lis_h);
				var curr_mt=parseInt($(ul).css('margin-top'));
				var curr_h=$(ul).height();
				var scroll=0;
				var max_scroll=(lis_h+lis_pb)*params.visible;
				if(curr_h+curr_mt < scroller_h)
					scroll=curr_h+curr_mt;
				else
					scroll=max_scroll;
				if(scroll){
						$(params.btnPrev).removeClass('disabled');
						$(ul).animate({'margin-top':curr_mt-scroll},500,function(){
							$(testdiv).append('<div id="test">stop animation</div>');
							RUN=0;
						});
					}
				if(params.afterNextClick)
					params.afterNextClick();

				if(curr_h+curr_mt < scroller_h*3)
					params.dynamicAddAfterNextClick();
				}
				*/


			});
			/*прокрутка вверх*/
			$(params.btnPrev).click(function(){
			clearInterval(obj.autoscroll);
						obj.autoscroll=null;
				if(!obj.RUN){
					obj.position-=col;
					obj.setPos();
				}
				/*
				if(!RUN){
					RUN=1;
				var curr_mt=parseInt($(ul).css('margin-top'));
				var curr_h=$(ul).height();
				var scroll=0;
				var max_scroll=(lis_h+lis_pb)*params.visible;


				if(max_scroll+curr_mt >= ul_mt){
					scroll=ul_mt-curr_mt;
					$(this).addClass('disabled');
				}else
					scroll=max_scroll;
				if(scroll){
						$(ul).animate({'margin-top':curr_mt+scroll},500,function(){

							RUN=0;
						});
					}
				}*/
			});

		}

		obj.refresh();

		if(params.start > 0){
				obj.position=parseInt(params.start);
				obj.goToPos();

				obj.autoscroll=setInterval(function(){
					if(obj.position > 0){
						obj.position--;
						obj.position = obj.position >=0 ? obj.position : 0;
						obj.setPos();
					}
					else{
						clearInterval(obj.autoscroll);
						obj.autoscroll=null;
					}

				},$('#main_page_autoscroll_news_time').val());
		}
		if(params.ReadyFunc)
			params.ReadyFunc();
		return obj;
	},
	jQPager:function(params){
		params= params ? params : {};
		var items=this;
		var init=false;
		var onpage=params.onpage ? params.onpage : 1;
		/*$(items).parent().after('1234');*/
		var count=$(items).length;

		if(  $(items).prop('tagName')=='LI'){
			var ul=$(items).closest('ul');
			$(ul).wrapAll('<div style="float:left; width:100%"></div>');
			var pageDiv=$(ul).parent();
		}
		else{
			$(items).wrapAll('<div style="float:left; width:100%"></div>');
			var pageDiv=$(items).parent();
		}


		var pager=$('<div style="background:none;margin:10px 0 0 0; float:left; width:100%" class="pages"></div>');
		$(pageDiv).after(pager);


		var pagerObj={
			position:1,
			pager:pager,
			onpage:onpage,
			pages:Math.ceil(count/onpage),
			setTo:function(i){
				if(i>0 && i<=this.pages && (i!=this.position || !init)){
					this.position=i;
					if(params.afterSelectPage) params.afterSelectPage();
					this.refresh()
				}
			},
			refresh:function(){
				var pages='';
				var obj=this;
				var i = this.position;
				pages+='<a class="next" href=""></a><a class="prev" href=""></a>';
				for(var j=1; j<=this.pages; j++){
					if( (j==2 && i>=5) || (j==this.pages-1 && i<this.pages-3) )
						pages+="...";
					else
						if( (Math.abs(i-j)<=2) || j==1 || j==this.pages)
							pages+='<a href="" '+(i==j ? ' class="active"' : '')+'>'+j+'</a>';
				}
				$(this.pager).html(pages);

				if(init){

					var h=$(pageDiv).height();
					$(pageDiv).height(h);
					var olditems=$(items).filter(":visible");
					k=0;
					$(olditems).fadeOut(300,function(){
						k++;
						if(k==$(olditems).length){
							var newitems=$(items).filter(".page-"+i);
							$(newitems).show();
							$(pageDiv).height('auto');
							var nh=$(pageDiv).height();
							$(pageDiv).height(h);
							$(newitems).hide();
							if(nh!=h)
								$(pageDiv).animate({height:nh},300,function(){
									$(newitems).fadeIn(300)
								})
							else
								$(newitems).fadeIn(300)
						}
					})

				}
			},
			init:function(){
				var obj=this;
				obj.setTo(1);
				$(items).hide();
				$(items).filter(".page-1").show();

				init=true;

				$(obj.pager).on('click','a',function(){
					var goTo=parseInt($(this).html());
					if($(this).hasClass('next')) goTo=parseInt(obj.position)+1;
					if($(this).hasClass('prev')) goTo=parseInt(obj.position)-1;
					obj.setTo(goTo);
					return false;
				})
			}
		}

		if(count > onpage)
		$(items).each(function(i){
			$(this).addClass("page-"+(1+Math.floor(i/onpage)))
			if(i==count-1)
				pagerObj.init();
		})


	},
	MultiTab:function(){
		var container=$(this);
		var tabs=container.children('.tabitem');
		container.addClass('ib-tabs-wrapper');
		var tabsButtonsContainer=$('<div>').attr('id','ib-tabs').addClass('ib-tabs');
		container.prepend(tabsButtonsContainer);
		var tabsButtonsUl=$('<ul>');
		tabsButtonsContainer.html(tabsButtonsUl);
		var tabsContentContainer=$('<div>').addClass('ib-tabs-content');
		container.append(tabsContentContainer);

		tabs.each(function(i,tab){
			var id=$(tab).attr('id').replace('tab-','');
			var h2=$(tab).children('h2');
			var count=parseInt(h2.data('count'));
			h2.hide();
			var button=$('<li  data-id="'+id+'" class="">'+h2.text()+(count ? ' ('+count+')' : '')+'</li>');
			tabsButtonsUl.append(button);
			tabsContentContainer.append($(tab).addClass('ib-tab'));
			//tabsButtonsUl.append('<li>test</li>');
			//alert($(tab).children('h2').text());

			var innerttabs=$(tab).children('.tabitem');
			if(innerttabs.length){
				var curtabButtonsContainer=$('<div>');//.attr('id','ib-tabs').addClass('ib-tabs');
				$(tab).prepend(curtabButtonsContainer);
				var curtabButtonsUl=$('<ul>').addClass('ib-inner-tabs').css({'margin-bottom':'30px'});
				curtabButtonsContainer.html(curtabButtonsUl);

				var curtabContentContainer=$('<div>').addClass("ib-inner-tabs-content");
				$(tab).append(curtabContentContainer);







				innerttabs.each(function(i,innerttab){
					var innerid=$(innerttab).attr('id').replace('tab-','');
					var h=$(innerttab).children('h3');
					var count=parseInt(h.data('count'));
					h.hide();
					var innerbutton=$('<li id="" data-id="'+innerid+'" class="ib-inner-tabs-switch">'+h.text()+(count ? ' ('+count+')' : '')+'</li>');
					curtabButtonsUl.append(innerbutton);
					curtabContentContainer.append($(innerttab).addClass('ib-tab'));

				});
				innerttabs.eq(0).show();

				$('.ib-inner-tabs').each(function(i,j){

					$(j).find('.ib-inner-tabs-switch').eq(0).addClass('active')

				})


				var inneranimationRun=false;
				$(curtabButtonsUl).children('li').click(function(){
					//console.log((new Date()), $(this).hasClass('active'), inneranimationRun);
					if(!inneranimationRun && !$(this).hasClass('active')){
						inneranimationRun=true;
						var activeTab=curtabButtonsUl.children('li.active');
						activeTab.removeClass('active');
						$(this).addClass('active');

						var activeID=activeTab.data('id');
						var currentID=$(this).data('id');
						//console.log('hide active '+activeID+' , show '+currentID);
						location.hash=currentID;
						curtabContentContainer.children('#tab-'+activeID).fadeOut(500,function(){
							curtabContentContainer.children('#tab-'+currentID).fadeIn(500);
							inneranimationRun=false;
						})

					}
					return false;
				})

				var j=0;
				curtabButtonsUl.children('li').eq(j).addClass('active');
				innerttabs.eq(j).show();

			}
		});

		var i=0;
		tabsButtonsUl.children('li').eq(i).addClass('active');
		tabs.eq(i).show();


		var animationRun=false;

		tabsButtonsUl.children('li').click(function(){
			if(!animationRun && !$(this).hasClass('active')){
				animationRun=true;
				var activeTab=tabsButtonsUl.children('li.active');
				activeTab.removeClass('active');

				$(this).addClass('active');
				var activeID=activeTab.data('id');
				var currentID=$(this).data('id');
				//console.log('hide active '+activeID+' , show '+currentID);
				location.hash=currentID;

				tabsContentContainer.children('#tab-'+activeID).fadeOut(500,function(){
					tabsContentContainer.children('#tab-'+currentID).fadeIn(500);
					animationRun=false;
				})
			}
			return false;
		})

		if(location.hash){
			var hash=location.hash.replace('#','');
			if($('.tabitem.ib-tab#tab-'+hash).length){
				var tab=$('.tabitem.ib-tab#tab-'+hash);
				//$('#ib-tabs li').removeClass('active');
				tab.parents('.ib-inner-tabs-content').find('.tabitem').hide();


				//$('.ib-inner-tabs li').removeClass('active');
				$('.ib-tabs-content>.tabitem.ib-tab').hide();
				container.find('li[data-id="'+hash+'"]').closest('.ib-inner-tabs').find('.ib-inner-tabs-switch').removeClass('active');
				container.find('li[data-id="'+hash+'"]').closest('.ib-tabs').find('li').removeClass('active');

				container.find('li[data-id="'+hash+'"]').addClass('active');
				tab.show();

					tab.parents('.tabitem.ib-tab').each(function(i,p){
						$(p).show();
						var pid=$(p).attr('id').replace('tab-','');
						container.find('li[data-id="'+pid+'"]').addClass('active');
					});
				var child=	tab.find('.ib-inner-tabs-switch').eq(0);
				child.addClass('active');
				$('#tab-'+child.data('id')).show();


			}
		}

	}

});


function add_comment(data,callback,errorcallback){
	var params={};
	params.what='add_comment_'+data.type;
	params.add={};
	params.add.text=data.text;
	params.add.mail=data.mail;
	params.add.fio=data.fio;
	params.id=data.id;
	if(data.offset) params.offset=data.offset;
	if(data.check)	params.check=data.check;
	if(data.recaptcha)	params.recaptcha=data.recaptcha;


	$.ajax({
			url: '/ajax_page.php',
			type: 'post',
			data: params,
			dataType:'json',
			success:function(response){

				if(response.success==1){
					callback(response.comments,response.turn_on_notice);
				}else
					if(response.error){
						s='';
						for (var i in response.error)
							s+=response.error[i]+'<br>';
							showMsg({
							'text':s,
							'time':0
						});
						errorcallback()
					}

				/*alert(response.responseText);*/
			}
		})
}

function showError(errorText){
	$('body').prepend(''+
'<div id="ErrorMessage">'+
	'<div class="errorText">'+errorText+
	'</div>'+
'</div>'+
''	);
	$(window).scroll(function(){
			$('#ErrorMessage').css('top',$(window).scrollTop());
	});

	$('#ErrorMessage').css('position','absolute');
	$('#ErrorMessage').css('top',$(window).scrollTop());
	$('#ErrorMessage').css('z-index',10);
	$('#ErrorMessage').css('left','50%');
	$('#ErrorMessage').css('padding','0 10px');
	$('#ErrorMessage').css('background-color','#F4CCCC');
	$('#ErrorMessage').css('border','solid 1px #E06666');
	$('#ErrorMessage').width($('#ErrorMessage').width());
	$('#ErrorMessage').css('marginLeft',(-($('#ErrorMessage').width()/2))+'px');
	$('#ErrorMessage').css('marginTop','20px');
	$('#ErrorMessage').css('-moz-border-radius','2px');
	$('#ErrorMessage').css('-webkit-border-radius','2px');
	$('#ErrorMessage').css('-khtml-border-radius','2px');
	$('#ErrorMessage').css('border-radius','2px');
	$('#ErrorMessage').css('-moz-box-shadow','0 2px 4px rgba(0, 0, 0, 0.2)');
	$('#ErrorMessage').css('-webkit-box-shadow','0 2px 4px rgba(0, 0, 0, 0.2)');
	$('#ErrorMessage').css('-khtml-box-shadow','0 2px 4px rgba(0, 0, 0, 0.2)');
    $('#ErrorMessage').css('box-shadow','0 2px 4px rgba(0, 0, 0, 0.2)');

	$('#ErrorMessage').hide();
	$('#ErrorMessage').fadeIn(500,function(){
		setTimeout(function(){
			$('#ErrorMessage').fadeOut(500)
		},2000);
	});

}

$(window).resize(function(){

	if($('#menu').length){
		//menuW();
		$("#news ul,#news li").width($("#news-wrapper").width());
		$("#seminars ul,#seminars li").width($("#seminars-wrapper").width());
		$("#exibs ul,#exibs li").width($("#exibs-wrapper").width());
	};
    if($('body').data('fe')){
    	ParalaxSetParams();
    }
});


function scroll_up_to_top(el){
  if(!el) return;
  el.addEventListener('click', () => {
    window.scrollTo(0, 0);
    el.style.display = 'none';
  })
}

function show_up_btn_for_main(){
  const url = location.pathname;
  if(url !== '/') return;
  const media = window.matchMedia('(max-width: 425.98px)');
  if(!media.matches) return;

  setTimeout(() => {
    const el = document.querySelector('.infinite-scroll__btn');
    document.addEventListener('scroll', () => {
      const y = window.scrollY;
      if(y >= 500) {
        el.style.display = 'block';
        scroll_up_to_top(el);
      } else {
        el.style.display = 'none';
      }
    })

  }, 2000);
}

show_up_btn_for_main();

function show_up_btn_for_scroll(){
  const el = document.querySelector('.infinite-scroll__btn');
  el.style.display = 'block';
  scroll_up_to_top(el);
}
